$('.small-bannerslick').slick({

  arrows: true,

  dots: false,

  infinite: true,

  speed: 500,

  slidesToShow: 1,

  slidesToScroll: 1,

  prevArrow: '<button type="button" class="info-slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30" id="Layer_1" style="enable-background:new 0 0 64 64;" version="1.1" viewBox="0 0 64 64" xml:space="preserve"><style type="text/css">.st0{fill:#134563;}</style><g><g id="Icon-Chevron-Left" transform="translate(237.000000, 335.000000)"><polyline class="st0" id="Fill-35" points="-199.1,-289 -212.9,-302.7 -199.1,-316.4 -197.1,-314.4 -208.9,-302.7 -197.1,-291-199.1,-289"/></g></g></svg></button>',

  nextArrow: '<button type="button" class="info-slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30" id="Layer_1" style="enable-background:new 0 0 64 64;" version="1.1" viewBox="0 0 64 64" xml:space="preserve"><style type="text/css">.st0{fill:#134563;}</style><g><g id="Icon-Chevron-Left" transform="translate(237.000000, 335.000000)"><polyline class="st0" id="Fill-35" points="-210.9,-289 -212.9,-291 -201.1,-302.7 -212.9,-314.4 -210.9,-316.4 -197.1,-302.7-210.9,-289"/></g></g></svg></button>'

});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function ($) {

  var $ = jQuery = $;

  var cc = {

    sections: []

  }; // requires: throttled-scroll, debouncedresize

  theme.Sections = new function () {

    var _ = this;

    _._instances = [];

    _._deferredSectionTargets = [];

    _._sections = [];

    _._deferredLoadViewportExcess = 300; // load defferred sections within this many px of viewport

    _._deferredWatcherRunning = false;

    _.init = function () {

      $(document).on('shopify:section:load', function (e) {

        // load a new section

        var target = _._themeSectionTargetFromShopifySectionTarget(e.target);

        if (target) {

          _.sectionLoad(target);

        }

      }).on('shopify:section:unload', function (e) {

        // unload existing section

        var target = _._themeSectionTargetFromShopifySectionTarget(e.target);

        if (target) {

          _.sectionUnload(target);

        }

      });

      $(window).on('throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader', _._processDeferredSections);

      _._deferredWatcherRunning = true;

    }; // register a type of section

    _.register = function (type, section, options) {

      _._sections.push({

        type: type,

        section: section,

        afterSectionLoadCallback: options ? options.afterLoad : null,

        afterSectionUnloadCallback: options ? options.afterUnload : null

      }); // load now

      $('[data-section-type="' + type + '"]').each(function () {

        if (Shopify.designMode || options && options.deferredLoad === false || !_._deferredWatcherRunning) {

          _.sectionLoad(this);

        } else {

          _.sectionDeferredLoad(this, options);

        }

      });

    }; // prepare a section to load later

    _.sectionDeferredLoad = function (target, options) {

      _._deferredSectionTargets.push({

        target: target,

        deferredLoadViewportExcess: options && options.deferredLoadViewportExcess ? options.deferredLoadViewportExcess : _._deferredLoadViewportExcess

      });

      _._processDeferredSections(true);

    }; // load deferred sections if in/near viewport

    _._processDeferredSections = function (firstRunCheck) {

      if (_._deferredSectionTargets.length) {

        var viewportTop = $(window).scrollTop(),

            viewportBottom = viewportTop + $(window).height(),

            loopStart = firstRunCheck === true ? _._deferredSectionTargets.length - 1 : 0;

        for (var i = loopStart; i < _._deferredSectionTargets.length; i++) {

          var target = _._deferredSectionTargets[i].target,

              viewportExcess = _._deferredSectionTargets[i].deferredLoadViewportExcess,

              sectionTop = $(target).offset().top - viewportExcess,

              doLoad = sectionTop > viewportTop && sectionTop < viewportBottom;

          if (!doLoad) {

            var sectionBottom = sectionTop + $(target).outerHeight() + viewportExcess * 2;

            doLoad = sectionBottom > viewportTop && sectionBottom < viewportBottom;

          }

          if (doLoad || sectionTop < viewportTop && sectionBottom > viewportBottom) {

            // in viewport, load

            _.sectionLoad(target); // remove from deferred queue and resume checks

            _._deferredSectionTargets.splice(i, 1);

            i--;

          }

        }

      } // remove event if no more deferred targets left, if not on first run

      if (firstRunCheck !== true && _._deferredSectionTargets.length === 0) {

        _._deferredWatcherRunning = false;

        $(window).off('.themeSectionDeferredLoader');

      }

    }; // load in a section

    _.sectionLoad = function (target) {

      var target = target,

          sectionObj = _._sectionForTarget(target),

          section = false;

      if (sectionObj.section) {

        section = sectionObj.section;

      } else {

        section = sectionObj;

      }

      if (section !== false) {

        var instance = {

          target: target,

          section: section,

          $shopifySectionContainer: $(target).closest('.shopify-section'),

          thisContext: {

            functions: section.functions

          }

        };

        _._instances.push(instance); //Initialise any components

        if ($(target).data('components')) {

          //Init each component

          var components = $(target).data('components').split(',');

          components.forEach(function (component) {

            $(document).trigger('cc:component:load', [component, target]);

          });

        }

        _._callSectionWith(section, 'onSectionLoad', target, instance.thisContext);

        _._callSectionWith(section, 'afterSectionLoadCallback', target, instance.thisContext); // attach additional UI events if defined

        if (section.onSectionSelect) {

          instance.$shopifySectionContainer.on('shopify:section:select', function (e) {

            _._callSectionWith(section, 'onSectionSelect', e.target, instance.thisContext);

          });

        }

        if (section.onSectionDeselect) {

          instance.$shopifySectionContainer.on('shopify:section:deselect', function (e) {

            _._callSectionWith(section, 'onSectionDeselect', e.target, instance.thisContext);

          });

        }

        if (section.onBlockSelect) {

          $(target).on('shopify:block:select', function (e) {

            _._callSectionWith(section, 'onBlockSelect', e.target, instance.thisContext);

          });

        }

        if (section.onBlockDeselect) {

          $(target).on('shopify:block:deselect', function (e) {

            _._callSectionWith(section, 'onBlockDeselect', e.target, instance.thisContext);

          });

        }

      }

    }; // unload a section

    _.sectionUnload = function (target) {

      var sectionObj = _._sectionForTarget(target);

      var instanceIndex = -1;

      for (var i = 0; i < _._instances.length; i++) {

        if (_._instances[i].target == target) {

          instanceIndex = i;

        }

      }

      if (instanceIndex > -1) {

        var instance = _._instances[instanceIndex]; // remove events and call unload, if loaded

        $(target).off('shopify:block:select shopify:block:deselect');

        instance.$shopifySectionContainer.off('shopify:section:select shopify:section:deselect');

        _._callSectionWith(instance.section, 'onSectionUnload', target, instance.thisContext);

        _._callSectionWith(sectionObj, 'afterSectionUnloadCallback', target, instance.thisContext);

        _._instances.splice(instanceIndex); //Destroy any components

        if ($(target).data('components')) {

          //Init each component

          var components = $(target).data('components').split(',');

          components.forEach(function (component) {

            $(document).trigger('cc:component:unload', [component, target]);

          });

        }

      } else {

        // check if it was a deferred section

        for (var i = 0; i < _._deferredSectionTargets.length; i++) {

          if (_._deferredSectionTargets[i].target == target) {

            _._deferredSectionTargets[i].splice(i, 1);

            break;

          }

        }

      }

    }; // helpers

    _._callSectionWith = function (section, method, container, thisContext) {

      if (typeof section[method] === 'function') {

        try {

          if (thisContext) {

            section[method].bind(thisContext)(container);

          } else {

            section[method](container);

          }

        } catch (ex) {

          var sectionType = container.dataset['sectionType'];

          console.log("Theme warning: '".concat(method, "' failed for section '").concat(sectionType, "'"));

          console.debug(container, ex.stack);

        }

      }

    };

    _._themeSectionTargetFromShopifySectionTarget = function (target) {

      var $target = $('[data-section-type]:first', target);

      if ($target.length > 0) {

        return $target[0];

      } else {

        return false;

      }

    };

    _._sectionForTarget = function (target) {

      var type = $(target).attr('data-section-type');

      for (var i = 0; i < _._sections.length; i++) {

        if (_._sections[i].type == type) {

          return _._sections[i];

        }

      }

      return false;

    };

    _._sectionAlreadyRegistered = function (type) {

      for (var i = 0; i < _._sections.length; i++) {

        if (_._sections[i].type == type) {

          return true;

        }

      }

      return false;

    };

  }();

  var ccComponent = /*#__PURE__*/function () {

    "use strict";

    function ccComponent(name) {

      var cssSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".cc-".concat(name);

      _classCallCheck(this, ccComponent);

      var _this = this;

      this.instances = []; // Initialise any instance of this component within a section

      $(document).on('cc:component:load', function (event, component, target) {

        if (component === name) {

          $(target).find("".concat(cssSelector, ":not(.cc-initialized)")).each(function () {

            _this.init(this);

          });

        }

      }); // Destroy any instance of this component within a section

      $(document).on('cc:component:unload', function (event, component, target) {

        if (component === name) {

          $(target).find(cssSelector).each(function () {

            _this.destroy(this);

          });

        }

      }); // Initialise any instance of this component

      $(cssSelector).each(function () {

        _this.init(this);

      });

    }

    _createClass(ccComponent, [{

      key: "init",

      value: function init(container) {

        $(container).addClass('cc-initialized');

      }

    }, {

      key: "destroy",

      value: function destroy(container) {

        $(container).removeClass('cc-initialized');

      }

    }, {

      key: "registerInstance",

      value: function registerInstance(container, instance) {

        this.instances.push({

          container: container,

          instance: instance

        });

      }

    }, {

      key: "destroyInstance",

      value: function destroyInstance(container) {

        this.instances = this.instances.filter(function (item) {

          if (item.container === container) {

            if (typeof item.instance.destroy === 'function') {

              item.instance.destroy();

            }

            return item.container !== container;

          }

        });

      }

    }]);

    return ccComponent;

  }();

  (function () {

    function throttle(callback, threshold) {

      var debounceTimeoutId = -1;

      var tick = false;

      return function () {

        clearTimeout(debounceTimeoutId);

        debounceTimeoutId = setTimeout(callback, threshold);

        if (!tick) {

          callback.call();

          tick = true;

          setTimeout(function () {

            tick = false;

          }, threshold);

        }

      };

    }

    var scrollEvent = document.createEvent('Event');

    scrollEvent.initEvent('throttled-scroll', true, true);

    window.addEventListener("scroll", throttle(function () {

      window.dispatchEvent(scrollEvent);

    }, 200));

  })();

  theme.Shopify = {

    formatMoney: function formatMoney(t, r) {

      function e(t, r) {

        return void 0 === t ? r : t;

      }

      function a(t, r, a, o) {

        if (r = e(r, 2), a = e(a, ","), o = e(o, "."), isNaN(t) || null == t) return 0;

        t = (t / 100).toFixed(r);

        var n = t.split(".");

        return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (n[1] ? o + n[1] : "");

      }

      "string" == typeof t && (t = t.replace(".", ""));

      var o = "",

          n = /\{\{\s*(\w+)\s*\}\}/,

          i = r || this.money_format;

      switch (i.match(n)[1]) {

        case "amount":

          o = a(t, 2);

          break;

        case "amount_no_decimals":

          o = a(t, 0);

          break;

        case "amount_with_comma_separator":

          o = a(t, 2, ".", ",");

          break;

        case "amount_with_space_separator":

          o = a(t, 2, " ", ",");

          break;

        case "amount_with_period_and_space_separator":

          o = a(t, 2, " ", ".");

          break;

        case "amount_no_decimals_with_comma_separator":

          o = a(t, 0, ".", ",");

          break;

        case "amount_no_decimals_with_space_separator":

          o = a(t, 0, " ", "");

          break;

        case "amount_with_apostrophe_separator":

          o = a(t, 2, "'", ".");

          break;

        case "amount_with_decimal_separator":

          o = a(t, 2, ".", ".");

      }

      return i.replace(n, o);

    },

    formatImage: function formatImage(originalImageUrl, format) {

      return originalImageUrl ? originalImageUrl.replace(/^(.*)\.([^\.]*)$/g, '$1_' + format + '.$2') : '';

    },

    Image: {

      imageSize: function imageSize(t) {

        var e = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

        return null !== e ? e[1] : null;

      },

      getSizedImageUrl: function getSizedImageUrl(t, e) {

        if (null == e) return t;

        if ("master" == e) return this.removeProtocol(t);

        var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

        if (null != o) {

          var i = t.split(o[0]),

              r = o[0];

          return this.removeProtocol(i[0] + "_" + e + r);

        }

        return null;

      },

      removeProtocol: function removeProtocol(t) {

        return t.replace(/http(s)?:/, "");

      }

    }

  }; // Turn a <select> tag into clicky boxes

  // Use with: $('select').clickyBoxes()

  $.fn.clickyBoxes = function (prefix) {

    if (prefix == 'destroy') {

      $(this).off('.clickyboxes');

      $(this).next('.clickyboxes').off('.clickyboxes');

    } else {

      return $(this).filter('select:not(.clickybox-replaced)').addClass('clickybox-replaced').each(function () {

        //Make sure rows are unique

        var prefix = prefix || $(this).attr('id'); //Create container

       

        var $optCont = $('<ul class="clickyboxes"/>').attr('id', 'clickyboxes-' + prefix).data('select', $(this)).insertAfter(this);

        

        var $label;

        if ($(this).is('[id]')) {

          $label = $('label[for="' + $(this).attr('id') + '"]'); // Grab real label

        } else {

          $label = $(this).siblings('label'); // Rough guess

        }

        if ($label.length > 0) {

          var text = $label.text().split('-')[0];

          $optCont.addClass('options-' + removeDiacritics(text).toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/-*$/, ''));

        } //Add options to container
        //$('.exclusive-text').remove();

        $(this).find('option').each(function () {

          // $('<li/>').appendTo($optCont).append($('<a href="#"/>').attr('data-value', $(this).val()).html($(this).html()).addClass('opt--' + removeDiacritics($(this).text()).toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/-*$/, '')));

          

          var selected_color = $(this).attr('selected');

          var option = $(this).data('option');

          var str1 = $(this).val();

          if(str1.indexOf('"') != -1){

            var replaced_str = str1.replace(/"/g,'\"');

          }

          else{

            var replaced_str = str1;

          }

          if(option == 'Color'){

            var img = $(this).data('img');

            var options = option.toLowerCase();     

            

              var exclusive = $(this).data('exclusive');             

              
              if(img == 'https://cdn.shopify.com/s/files/1/0579/6515/0408/files/no-image-available.jpg') {
              $(`<li class="parent-list unavailable-color ${(selected_color == 'selected')?'activeList': ''}" /><span class="not-available-color"></span> ${(exclusive != '')?'<span class="exclusive-text">Exclusive</span>': ''}`).appendTo($optCont).append($('<a href="#" style="background:url('+img+');background-position: center;background-size: contain;height: 45px;"/>').attr('data-value', $(this).val()).html($(this).html()).addClass('opt--' + removeDiacritics($(this).text()).toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/-*$/, '')));
          } else {
            $(`<li class="parent-list unavailable-color ${(selected_color == 'selected')?'activeList': ''}" /><span class="not-available-color"></span> ${(exclusive != '')?'<span class="exclusive-text">Exclusive</span>': ''}`).appendTo($optCont).append($('<a href="#" style="background:url('+img+');background-position: center;background-size: unset;"/>').attr('data-value', $(this).val()).html($(this).html()).addClass('opt--' + removeDiacritics($(this).text()).toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/-*$/, '')));
          }
           }

          else{

            if($(this).data('url')){

              var prod_url = $(this).data('url'); 

            }

            else{

              var prod_url = '#';

            }

            var already_value = '';

           if($(this).data('type') == 'External'){         

             var external_class = 'availablesizevariant';

             

           }

           else{

              var external_class = '';

            }

            if($(this).data('already') == $(this).html()){

              var duplicate_variable = 'duplicatevariant';

                }

            $('<li class="unavailable-size"><span class="not-available-size"></span>').appendTo($optCont).append($('<a href="'+prod_url+'"/>').attr('data-value', $(this).val()).html($(this).html()).addClass(external_class + ' opt--' + removeDiacritics($(this).text()).toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/-*$/, '')));

            

          }

        }); //Select change event

        $(this).hide().addClass('replaced').on('change.clickyboxes keyup.clickyboxes', function () {

          //Choose the right option to show

          var val = $(this).val();

          $optCont.find('a').removeClass('active').filter(function () {

            return $(this).attr('data-value') == val;

          }).addClass('active');

        }).trigger('keyup'); //Initial value

        //Button click event

        $optCont.on('click.clickyboxes', 'a', function () {

          if (!$(this).hasClass('active')) {

            var parent_div = $(this).closest('.clickyboxes');

            $(this).closest('.clickyboxes').children().removeClass('activeList');

            $(this).closest('li').addClass('activeList');

            var value = removeDiacritics($(this).closest('li a').data('value').toLowerCase()).toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/-*$/, '');

            var part = $('#SingleOptionSelector-0 option[data-value="'+value+'"]').data('part');

            $('.variant-part-number').html(part);

            var $clicky = $(this).closest('.clickyboxes');

            $clicky.data('select').val($(this).data('value')).trigger('change');

            $clicky.trigger('change');

          }

          return false;

        });

      });

    }

  };

  theme.Disclosure = function () {

    var selectors = {

      disclosureList: '[data-disclosure-list]',

      disclosureToggle: '[data-disclosure-toggle]',

      disclosureInput: '[data-disclosure-input]',

      disclosureOptions: '[data-disclosure-option]'

    };

    var classes = {

      listVisible: 'disclosure-list--visible'

    };

    function Disclosure($disclosure) {

      this.$container = $disclosure;

      this.cache = {};

      this._cacheSelectors();

      this._connectOptions();

      this._connectToggle();

      this._onFocusOut();

    }

    Disclosure.prototype = $.extend({}, Disclosure.prototype, {

      _cacheSelectors: function _cacheSelectors() {

        this.cache = {

          $disclosureList: this.$container.find(selectors.disclosureList),

          $disclosureToggle: this.$container.find(selectors.disclosureToggle),

          $disclosureInput: this.$container.find(selectors.disclosureInput),

          $disclosureOptions: this.$container.find(selectors.disclosureOptions)

        };

      },

      _connectToggle: function _connectToggle() {

        this.cache.$disclosureToggle.on('click', function (evt) {

          var ariaExpanded = $(evt.currentTarget).attr('aria-expanded') === 'true';

          $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);

          this.cache.$disclosureList.toggleClass(classes.listVisible);

        }.bind(this));

      },

      _connectOptions: function _connectOptions() {

        this.cache.$disclosureOptions.on('click', function (evt) {

          evt.preventDefault();

          this._submitForm($(evt.currentTarget).data('value'));

        }.bind(this));

      },

      _onFocusOut: function _onFocusOut() {

        this.cache.$disclosureToggle.on('focusout', function (evt) {

          var disclosureLostFocus = this.$container.has(evt.relatedTarget).length === 0;

          if (disclosureLostFocus) {

            this._hideList();

          }

        }.bind(this));

        this.cache.$disclosureList.on('focusout', function (evt) {

          var childInFocus = $(evt.currentTarget).has(evt.relatedTarget).length > 0;

          var isVisible = this.cache.$disclosureList.hasClass(classes.listVisible);

          if (isVisible && !childInFocus) {

            this._hideList();

          }

        }.bind(this));

        this.$container.on('keyup', function (evt) {

          if (evt.which !== 27) return; // escape

          this._hideList();

          this.cache.$disclosureToggle.focus();

        }.bind(this));

        this.bodyOnClick = function (evt) {

          var isOption = this.$container.has(evt.target).length > 0;

          var isVisible = this.cache.$disclosureList.hasClass(classes.listVisible);

          if (isVisible && !isOption) {

            this._hideList();

          }

        }.bind(this);

        $('body').on('click', this.bodyOnClick);

      },

      _submitForm: function _submitForm(value) {

        this.cache.$disclosureInput.val(value);

        this.$container.parents('form').submit();

      },

      _hideList: function _hideList() {

        this.cache.$disclosureList.removeClass(classes.listVisible);

        this.cache.$disclosureToggle.attr('aria-expanded', false);

      },

      unload: function unload() {

        $('body').off('click', this.bodyOnClick);

        this.cache.$disclosureOptions.off();

        this.cache.$disclosureToggle.off();

        this.cache.$disclosureList.off();

        this.$container.off();

      }

    });

    return Disclosure;

  }(); // Loading third party scripts

  theme.scriptsLoaded = {};

  theme.loadScriptOnce = function (src, callback, beforeRun, sync) {

    if (typeof theme.scriptsLoaded[src] === 'undefined') {

      theme.scriptsLoaded[src] = [];

      var tag = document.createElement('script');

      tag.src = src;

      if (sync || beforeRun) {

        tag.async = false;

      }

      if (beforeRun) {

        beforeRun();

      }

      if (typeof callback === 'function') {

        theme.scriptsLoaded[src].push(callback);

        if (tag.readyState) {

          // IE, incl. IE9

          tag.onreadystatechange = function () {

            if (tag.readyState == "loaded" || tag.readyState == "complete") {

              tag.onreadystatechange = null;

              for (var i = 0; i < theme.scriptsLoaded[this].length; i++) {

                theme.scriptsLoaded[this][i]();

              }

              theme.scriptsLoaded[this] = true;

            }

          }.bind(src);

        } else {

          tag.onload = function () {

            // Other browsers

            for (var i = 0; i < theme.scriptsLoaded[this].length; i++) {

              theme.scriptsLoaded[this][i]();

            }

            theme.scriptsLoaded[this] = true;

          }.bind(src);

        }

      }

      var firstScriptTag = document.getElementsByTagName('script')[0];

      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      return true;

    } else if (_typeof(theme.scriptsLoaded[src]) === 'object' && typeof callback === 'function') {

      theme.scriptsLoaded[src].push(callback);

    } else {

      if (typeof callback === 'function') {

        callback();

      }

      return false;

    }

  };

  theme.loadStyleOnce = function (src) {

    var srcWithoutProtocol = src.replace(/^https?:/, '');

    if (!document.querySelector('link[href="' + encodeURI(srcWithoutProtocol) + '"]')) {

      var tag = document.createElement('link');

      tag.href = srcWithoutProtocol;

      tag.rel = 'stylesheet';

      tag.type = 'text/css';

      var firstTag = document.getElementsByTagName('link')[0];

      firstTag.parentNode.insertBefore(tag, firstTag);

    }

  };

  theme.cartNoteMonitor = {

    load: function load($notes) {

      $notes.on('change.themeCartNoteMonitor paste.themeCartNoteMonitor keyup.themeCartNoteMonitor', function () {

        theme.cartNoteMonitor.postUpdate($(this).val());

      });

    },

    unload: function unload($notes) {

      $notes.off('.themeCartNoteMonitor');

    },

    updateThrottleTimeoutId: -1,

    updateThrottleInterval: 500,

    postUpdate: function postUpdate(val) {

      clearTimeout(theme.cartNoteMonitor.updateThrottleTimeoutId);

      theme.cartNoteMonitor.updateThrottleTimeoutId = setTimeout(function () {

        $.post(theme.routes.cart_url + '/update.js', {

          note: val

        }, function (data) {}, 'json');

      }, theme.cartNoteMonitor.updateThrottleInterval);

    }

  };

  var FacetFiltersInstance = /*#__PURE__*/function () {

    "use strict";

    function FacetFiltersInstance(el) {

      _classCallCheck(this, FacetFiltersInstance);

      this.filteringEnabled = el.dataset.filtering === 'true';

      this.sortingEnabled = el.dataset.sorting === 'true';

      this.filtersControl = document.querySelector('.cc-filters-control');

      this.filtersContainer = document.querySelector('.cc-filters-container');

      this.results = document.querySelector('.cc-filters-results');

      if (this.filteringEnabled) {

        this.filters = document.querySelector('.cc-filters');

        this.filtersFooter = document.querySelector('.cc-filters__footer');

        this.activeFilters = document.querySelector('.cc-active-filters');

        this.clearFiltersBtn = document.querySelector('.js-clear-filters');

      }

      if (this.sortingEnabled) {

        this.sortBy = document.querySelector('.cc-filter--sort');

        this.activeSortText = document.querySelector('.cc-sort-selected');

      }

      this.utils = {

        hidden: 'is-hidden',

        loading: 'is-loading',

        open: 'is-open',

        filtersOpen: 'filters-open'

      };

      if (this.filteringEnabled && !this.filtersFooter.classList.contains(this.utils.hidden)) {

        this.filters.style.height = "calc(100% - ".concat(this.filtersFooter.offsetHeight, "px)");

      }

      this.bindEvents();

    }

    _createClass(FacetFiltersInstance, [{

      key: "bindEvents",

      value: function bindEvents() {

        this.filtersControl.addEventListener('click', this.handleControlClick.bind(this));

        this.filtersContainer.addEventListener('click', this.handleFiltersClick.bind(this));

        this.filtersContainer.addEventListener('input', this.debounce(this.handleFilterChange.bind(this), 500));

        if (this.filteringEnabled) {

          if (document.querySelector('.cc-price-range')) {

            this.filtersContainer.addEventListener('change', this.debounce(this.handleFilterChange.bind(this), 500));

          }

          this.activeFilters.addEventListener('click', this.handleActiveFiltersClick.bind(this));

        }

        document.addEventListener('click', this.handleClickOutside.bind(this));

        window.addEventListener('popstate', this.handleHistoryChange.bind(this));

      }

    }, {

      key: "debounce",

      value: function debounce(fn, wait) {

        var _this2 = this;

        var timer;

        return function () {

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {

            args[_key] = arguments[_key];

          }

          clearTimeout(timer);

          timer = setTimeout(function () {

            return fn.apply(_this2, args);

          }, wait);

        };

      }

      /**

       * Handles 'click' event on the filter/sort buttons (mobile only)

       * @param {Object} e - The event object

       */

    }, {

      key: "handleControlClick",

      value: function handleControlClick(e) {

        var _this3 = this;

        if (!e.target.matches('.cc-filters-control__btn')) return;

        document.body.classList.add(this.utils.filtersOpen);

        if (e.target.matches('.js-show-filters')) {

          this.filters.classList.add(this.utils.open);

        } else {

          this.sortBy.open = true; // Slight delay required before starting transition

          setTimeout(function () {

            _this3.sortBy.classList.add(_this3.utils.open);

          }, 10);

        }

      }

      /**

       * Handles 'click' event on the filters container

       * @param {Object} e - The event object

       */

    }, {

      key: "handleFiltersClick",

      value: function handleFiltersClick(e) {

        var _this4 = this;

        var target = e.target;

        var filter = target.closest('.cc-filter'); // Filter 'clear' button clicked

        if (target.matches('.cc-filter-clear-btn')) {

          e.preventDefault();

          this.applyFilters(new URL(e.target.href).searchParams.toString(), e);

          return;

        } // Filters/Sort 'close' button, '[x] results' button or 'apply' button clicked (mobile only)

        if (target.matches('.js-close-filters')) {

          if (filter) {

            // Delay to allow for filter closing transition

            setTimeout(function () {

              filter.classList.remove(_this4.utils.open);

              filter.open = false;

            }, 300);

          }

          if (this.filteringEnabled) {

            this.filters.classList.remove(this.utils.open);

          }

          document.body.classList.remove(this.utils.filtersOpen);

          return;

        }

        if (target.matches('.cc-filter__toggle') || target.matches('.cc-filter-back-btn')) {

          var openFilter = document.querySelector(".cc-filter[open]:not([data-index=\"".concat(filter.dataset.index, "\"])")); // If a filter was opened (tablet/desktop) and there's one already open, close it

          if (openFilter) {

            this.closeFilter(openFilter, false);

          } // Open/close the filter, class added to allow for css transition

          if (!filter.classList.contains(this.utils.open)) {

            setTimeout(function () {

              filter.classList.add(_this4.utils.open);

            }, 10);

          } else {

            e.preventDefault();

            this.closeFilter(filter);

          }

        }

      }

      /**

       * Handles 'click' event outside the filters (tablet/desktop)

       * @param {Object} e - The event object

       */

    }, {

      key: "handleClickOutside",

      value: function handleClickOutside(e) {

        var openFilter = document.querySelector(".cc-filter.".concat(this.utils.open)); // If there's a filter open and the click event wasn't on it, close it (tablet/desktop)

        if (openFilter) {

          var filter = e.target.closest('.cc-filter');

          if (!filter || filter !== openFilter) {

            e.preventDefault();

            this.closeFilter(openFilter);

          }

        }

      }

      /**

       * Handles 'input' and 'change' events on the filters and sort by

       * @param {Object} e - The event object

       */

    }, {

      key: "handleFilterChange",

      value: function handleFilterChange(e) {

        // Ignore 'change' events not triggered by user moving the price range slider

        if (e.type === 'change' && (!e.detail || e.detail.sender !== 'theme:component:price_range')) return; // If price min/max input value changed, dispatch 'change' event to trigger update of the slider

        if (e.type === 'input' && e.target.classList.contains('cc-price-range__input')) {

          e.target.dispatchEvent(new Event('change', {

            bubbles: true

          }));

        }

        var formData = new FormData(document.getElementById('filters'));

        var searchParams = new URLSearchParams(formData);

        this.applyFilters(searchParams.toString(), e);

      }

      /**

       * Handles 'click' event on the active filters

       * @param {Object} e - The event object

       */

    }, {

      key: "handleActiveFiltersClick",

      value: function handleActiveFiltersClick(e) {

        e.preventDefault();

        if (e.target.tagName === 'A') {

          this.applyFilters(new URL(e.target.href).searchParams.toString(), e);

        }

      }

      /**

       * Handles history changes (e.g. back button clicked)

       * @param {Object} e - The event object

       */

    }, {

      key: "handleHistoryChange",

      value: function handleHistoryChange(e) {

        var searchParams = '';

        if (e.state && e.state.searchParams) {

          searchParams = e.state.searchParams;

        }

        this.applyFilters(searchParams, null, false);

      }

      /**

       * Fetches the filtered/sorted page data and updates the current page

       * @param {string} searchParams - The filter/sort search parameters

       * @param {Object} e - The event object

       * @param {boolean} [updateUrl=true] - Whether to update the url with the selected filter/sort options

       */

    }, {

      key: "applyFilters",

      value: function applyFilters(searchParams, e) {

        var _this5 = this;

        var updateUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        this.results.classList.add(this.utils.loading);

        fetch("".concat(window.location.pathname, "?").concat(searchParams)).then(function (response) {

          return response.text();

        }).then(function (responseText) {

          var html = responseText;

          var fetchedHTML = new DOMParser().parseFromString(html, 'text/html');

          _this5.updateFilters(fetchedHTML, e);

          _this5.results.innerHTML = fetchedHTML.querySelector('.cc-filters-results').innerHTML;

          document.dispatchEvent(new CustomEvent('filters-applied', {

            bubbles: true

          }));

          _this5.results.classList.remove(_this5.utils.loading);

        });

        if (updateUrl) {

          this.updateURL(searchParams);

        }

      }

      /**

       * Updates the filters relevant to the fetched data

       * @param {html} fetchedHTML - HTML of the fetched page

       * @param {Object} e - The event object

       */

    }, {

      key: "updateFilters",

      value: function updateFilters(fetchedHTML, e) {

        var _this6 = this;

        // Update the Filter/Sort buttons (mobile only)

        this.filtersControl.innerHTML = fetchedHTML.querySelector('.cc-filters-control').innerHTML; // Update the 'selected' option in the 'Sort by' dropdown button (tablet/desktop)

        if (e && e.target.name === 'sort_by') {

          this.activeSortText.textContent = e.target.nextElementSibling.textContent;

        }

        if (!this.filteringEnabled) return;

        document.querySelectorAll('.cc-filter').forEach(function (filter) {

          var index = filter.dataset.index;

          if (index === '0') return; // Sort by

          var fetchedFilter = fetchedHTML.querySelector(".cc-filter[data-index=\"".concat(index, "\"]"));

          if (filter.dataset.type === 'price_range') {

            _this6.updateFilter(filter, fetchedFilter, false);

            if (!e || e.target.tagName !== 'INPUT') {

              // Update price fields and trigger update of slider

              filter.querySelectorAll('input').forEach(function (input) {

                input.value = fetchedHTML.getElementById(input.id).value;

                input.dispatchEvent(new CustomEvent('change', {

                  bubbles: true,

                  detail: {

                    sender: 'reset'

                  }

                }));

              });

            }

          } else {

            if (e && e.target.tagName === 'INPUT') {

              var changedFilter = e.target.closest('.cc-filter');

              _this6.updateFilter(filter, fetchedFilter, filter.dataset.index !== changedFilter.dataset.index);

            } else {

              _this6.updateFilter(filter, fetchedFilter, true);

            }

          }

        }); // Update the active filters

        this.updateActiveFilters(fetchedHTML); // Update the 'Clear all' button visibility (mobile only)

        this.clearFiltersBtn.hidden = fetchedHTML.querySelector('.js-clear-filters').hidden; // Update the '[x] results' button (mobile only)

        var footerEl = fetchedHTML.querySelector('.cc-filters__footer');

        var footerHidden = footerEl.classList.contains(this.utils.hidden);

        this.filtersFooter.innerHTML = footerEl.innerHTML;

        this.filtersFooter.classList.toggle(this.utils.hidden, footerHidden);

        this.filters.style.height = footerHidden ? null : "calc(100% - ".concat(this.filtersFooter.offsetHeight, "px)");

      }

      /**

       * Updates a filter

       * @param {HTMLElement} filter - The filter element

       * @param {HTMLElement} fetchedFilter - The fetched filter element

       * @param {boolean} updateAll - Whether to update all filter markup or just toggle/header

       */

    }, {

      key: "updateFilter",

      value: function updateFilter(filter, fetchedFilter, updateAll) {

        if (updateAll) {

          filter.innerHTML = fetchedFilter.innerHTML;

        } else {

          // Update toggle and header only

          filter.replaceChild(fetchedFilter.querySelector('.cc-filter__toggle'), filter.querySelector('.cc-filter__toggle'));

          filter.querySelector('.cc-filter__header').innerHTML = fetchedFilter.querySelector('.cc-filter__header').innerHTML;

        }

      }

      /**

       * Updates the active filter

       * @param {html} fetchedHTML - HTML of the fetched page

       */

    }, {

      key: "updateActiveFilters",

      value: function updateActiveFilters(fetchedHTML) {

        var activeFilters = fetchedHTML.querySelector('.cc-active-filters');

        this.activeFilters.innerHTML = activeFilters.innerHTML;

        this.activeFilters.hidden = !this.activeFilters.querySelector('.cc-active-filter');

      }

      /**

       * Updates the url with the current filter/sort parameters

       * @param {string} searchParams - The filter/sort parameters

       */

    }, {

      key: "updateURL",

      value: function updateURL(searchParams) {

        history.pushState({

          searchParams: searchParams

        }, '', "".concat(window.location.pathname).concat(searchParams && '?'.concat(searchParams)));

      }

      /**

       * Closes a filter

       * @param {HTMLElement} filter - The filter element

       * @param {boolean} [delay=true] - Whether to wait for the css transition

       */

    }, {

      key: "closeFilter",

      value: function closeFilter(filter) {

        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        clearTimeout(this.closeTimer);

        filter.classList.remove(this.utils.open); // Delay to allow for filter closing transition

        this.closeTimer = setTimeout(function () {

          filter.open = false;

        }, delay ? 300 : null);

      }

    }]);

    return FacetFiltersInstance;

  }();

  var FacetFilters = /*#__PURE__*/function (_ccComponent) {

    "use strict";

    _inherits(FacetFilters, _ccComponent);

    var _super = _createSuper(FacetFilters);

    function FacetFilters() {

      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'facet-filters';

      var cssSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".cc-facet-filters";

      _classCallCheck(this, FacetFilters);

      return _super.call(this, name, cssSelector);

    }

    _createClass(FacetFilters, [{

      key: "init",

      value: function init(container) {

        _get(_getPrototypeOf(FacetFilters.prototype), "init", this).call(this, container);

        this.registerInstance(container, new FacetFiltersInstance(container));

      }

    }, {

      key: "destroy",

      value: function destroy(container) {

        this.destroyInstance(container);

        _get(_getPrototypeOf(FacetFilters.prototype), "destroy", this).call(this, container);

      }

    }]);

    return FacetFilters;

  }(ccComponent);

  new FacetFilters();

  var PriceRangeInstance = /*#__PURE__*/function () {

    "use strict";

    function PriceRangeInstance(container) {

      var _this7 = this;

      _classCallCheck(this, PriceRangeInstance);

      this.container = container;

      this.selectors = {

        inputMin: '.cc-price-range__input--min',

        inputMax: '.cc-price-range__input--max',

        control: '.cc-price-range__control',

        controlMin: '.cc-price-range__control--min',

        controlMax: '.cc-price-range__control--max',

        bar: '.cc-price-range__bar',

        activeBar: '.cc-price-range__bar-active'

      };

      this.controls = {

        min: {

          barControl: container.querySelector(this.selectors.controlMin),

          input: container.querySelector(this.selectors.inputMin)

        },

        max: {

          barControl: container.querySelector(this.selectors.controlMax),

          input: container.querySelector(this.selectors.inputMax)

        }

      };

      this.controls.min.value = parseInt(this.controls.min.input.value === '' ? this.controls.min.input.placeholder : this.controls.min.input.value);

      this.controls.max.value = parseInt(this.controls.max.input.value === '' ? this.controls.max.input.placeholder : this.controls.max.input.value);

      this.valueMin = this.controls.min.input.min;

      this.valueMax = this.controls.min.input.max;

      this.valueRange = this.valueMax - this.valueMin;

      [this.controls.min, this.controls.max].forEach(function (item) {

        item.barControl.setAttribute('aria-valuemin', _this7.valueMin);

        item.barControl.setAttribute('aria-valuemax', _this7.valueMax);

      });

      this.controls.min.barControl.setAttribute('aria-valuenow', this.controls.min.value);

      this.controls.max.barControl.setAttribute('aria-valuenow', this.controls.max.value);

      this.bar = container.querySelector(this.selectors.bar);

      this.activeBar = container.querySelector(this.selectors.activeBar);

      this.inDrag = false;

      this.bindEvents();

      this.render();

    }

    _createClass(PriceRangeInstance, [{

      key: "getPxToValueRatio",

      value: function getPxToValueRatio() {

        return this.bar.clientWidth / (this.valueMax - this.valueMin);

      }

    }, {

      key: "getPcToValueRatio",

      value: function getPcToValueRatio() {

        return 100.0 / (this.valueMax - this.valueMin);

      }

    }, {

      key: "setActiveControlValue",

      value: function setActiveControlValue(value, reset) {

        // Clamp & default

        if (this.activeControl === this.controls.min) {

          if (value === '') {

            value = this.valueMin;

          }

          value = Math.max(this.valueMin, value);

          value = Math.min(value, this.controls.max.value);

        } else {

          if (value === '') {

            value = this.valueMax;

          }

          value = Math.min(this.valueMax, value);

          value = Math.max(value, this.controls.min.value);

        } // Round

        this.activeControl.value = Math.round(value); // Update input

        if (this.activeControl.input.value != this.activeControl.value) {

          if (this.activeControl.value == this.activeControl.input.placeholder) {

            this.activeControl.input.value = '';

          } else {

            this.activeControl.input.value = this.activeControl.value;

          }

          if (!reset) {

            this.activeControl.input.dispatchEvent(new CustomEvent('change', {

              bubbles: true,

              detail: {

                sender: 'theme:component:price_range'

              }

            }));

          }

        } // A11y

        this.activeControl.barControl.setAttribute('aria-valuenow', this.activeControl.value);

      }

    }, {

      key: "render",

      value: function render() {

        this.drawControl(this.controls.min);

        this.drawControl(this.controls.max);

        this.drawActiveBar();

      }

    }, {

      key: "drawControl",

      value: function drawControl(control) {

        control.barControl.style.left = "".concat((control.value - this.valueMin) * this.getPcToValueRatio(), "%");

      }

    }, {

      key: "drawActiveBar",

      value: function drawActiveBar() {

        this.activeBar.style.left = "".concat((this.controls.min.value - this.valueMin) * this.getPcToValueRatio(), "%");

        this.activeBar.style.right = "".concat((this.valueMax - this.controls.max.value) * this.getPcToValueRatio(), "%");

      }

    }, {

      key: "handleControlTouchStart",

      value: function handleControlTouchStart(e) {

        e.preventDefault();

        this.startDrag(e.target, e.touches[0].clientX);

        this.boundControlTouchMoveEvent = this.handleControlTouchMove.bind(this);

        this.boundControlTouchEndEvent = this.handleControlTouchEnd.bind(this);

        window.addEventListener('touchmove', this.boundControlTouchMoveEvent);

        window.addEventListener('touchend', this.boundControlTouchEndEvent);

      }

    }, {

      key: "handleControlTouchMove",

      value: function handleControlTouchMove(e) {

        this.moveDrag(e.touches[0].clientX);

      }

    }, {

      key: "handleControlTouchEnd",

      value: function handleControlTouchEnd(e) {

        e.preventDefault();

        window.removeEventListener('touchmove', this.boundControlTouchMoveEvent);

        window.removeEventListener('touchend', this.boundControlTouchEndEvent);

        this.stopDrag();

      }

    }, {

      key: "handleControlMouseDown",

      value: function handleControlMouseDown(e) {

        e.preventDefault();

        this.startDrag(e.target, e.clientX);

        this.boundControlMouseMoveEvent = this.handleControlMouseMove.bind(this);

        this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this);

        window.addEventListener('mousemove', this.boundControlMouseMoveEvent);

        window.addEventListener('mouseup', this.boundControlMouseUpEvent);

      }

    }, {

      key: "handleControlMouseMove",

      value: function handleControlMouseMove(e) {

        this.moveDrag(e.clientX);

      }

    }, {

      key: "handleControlMouseUp",

      value: function handleControlMouseUp(e) {

        e.preventDefault();

        window.removeEventListener('mousemove', this.boundControlMouseMoveEvent);

        window.removeEventListener('mouseup', this.boundControlMouseUpEvent);

        this.stopDrag();

      }

    }, {

      key: "startDrag",

      value: function startDrag(target, startX) {

        this.activeControl = this.controls.min.barControl === target ? this.controls.min : this.controls.max;

        this.dragStartX = startX;

        this.dragStartValue = this.activeControl.value;

        this.inDrag = true;

      }

    }, {

      key: "moveDrag",

      value: function moveDrag(moveX) {

        if (this.inDrag) {

          var value = this.dragStartValue + (moveX - this.dragStartX) / this.getPxToValueRatio();

          this.setActiveControlValue(value);

          this.render();

        }

      }

    }, {

      key: "stopDrag",

      value: function stopDrag() {

        this.inDrag = false;

      }

    }, {

      key: "handleInputChange",

      value: function handleInputChange(e) {

        if (e.target.tagName !== 'INPUT') return;

        if (!e.detail || e.detail.sender !== 'theme:component:price_range') {

          var reset = e.detail && e.detail.sender === 'reset';

          this.activeControl = this.controls.min.input === e.target ? this.controls.min : this.controls.max;

          this.setActiveControlValue(e.target.value, reset);

          this.render();

        }

      }

    }, {

      key: "bindEvents",

      value: function bindEvents() {

        var _this8 = this;

        [this.controls.min, this.controls.max].forEach(function (item) {

          item.barControl.addEventListener('touchstart', _this8.handleControlTouchStart.bind(_this8));

          item.barControl.addEventListener('mousedown', _this8.handleControlMouseDown.bind(_this8));

        });

        this.container.addEventListener('change', this.handleInputChange.bind(this));

      }

    }, {

      key: "destroy",

      value: function destroy() {}

    }]);

    return PriceRangeInstance;

  }();

  var PriceRange = /*#__PURE__*/function (_ccComponent2) {

    "use strict";

    _inherits(PriceRange, _ccComponent2);

    var _super2 = _createSuper(PriceRange);

    function PriceRange() {

      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'price-range';

      var cssSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".cc-".concat(name);

      _classCallCheck(this, PriceRange);

      return _super2.call(this, name, cssSelector);

    }

    _createClass(PriceRange, [{

      key: "init",

      value: function init(container) {

        _get(_getPrototypeOf(PriceRange.prototype), "init", this).call(this, container);

        this.registerInstance(container, new PriceRangeInstance(container));

      }

    }, {

      key: "destroy",

      value: function destroy(container) {

        this.destroyInstance(container);

        _get(_getPrototypeOf(PriceRange.prototype), "destroy", this).call(this, container);

      }

    }]);

    return PriceRange;

  }(ccComponent);

  new PriceRange();

  var ccPopup = /*#__PURE__*/function () {

    "use strict";

    function ccPopup($container, namespace) {

      _classCallCheck(this, ccPopup);

      this.$container = $container;

      this.namespace = namespace;

      this.cssClasses = {

        visible: 'cc-popup--visible',

        bodyNoScroll: 'cc-popup-no-scroll',

        bodyNoScrollPadRight: 'cc-popup-no-scroll-pad-right'

      };

    }

    /**

     * Open popup on timer / local storage - move focus to input ensure you can tab to submit and close

     * Add the cc-popup--visible class

     * Update aria to visible

     */

    _createClass(ccPopup, [{

      key: "open",

      value: function open(callback) {

        var _this9 = this;

        // Prevent the body from scrolling

        if (this.$container.data('freeze-scroll')) {

          $('body').addClass(this.cssClasses.bodyNoScroll); // Add any padding necessary to the body to compensate for the scrollbar that just disappeared

          var scrollDiv = document.createElement('div');

          scrollDiv.className = 'popup-scrollbar-measure';

          document.body.appendChild(scrollDiv);

          var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;

          document.body.removeChild(scrollDiv);

          if (scrollbarWidth > 0) {

            $('body').css('padding-right', scrollbarWidth + 'px').addClass(this.cssClasses.bodyNoScrollPadRight);

          }

        } // Add reveal class

        this.$container.addClass(this.cssClasses.visible); // Track previously focused element

        this.previouslyActiveElement = document.activeElement; // Focus on the close button after the animation in has completed

        setTimeout(function () {

          _this9.$container.find('.cc-popup-close')[0].focus();

        }, 500); // Pressing escape closes the modal

        $(window).on('keydown' + this.namespace, function (event) {

          if (event.keyCode === 27) {

            _this9.close();

          }

        });

        if (callback) {

          callback();

        }

      }

    }, {

      key: "close",

      value:

      /**

       * Close popup on click of close button or background - where does the focus go back to?

       * Remove the cc-popup--visible class

       */

      function close(callback) {

        var _this10 = this;

        // Remove reveal class

        this.$container.removeClass(this.cssClasses.visible); // Revert focus

        if (this.previouslyActiveElement) {

          $(this.previouslyActiveElement).focus();

        } // Destroy the escape event listener

        $(window).off('keydown' + this.namespace); // Allow the body to scroll and remove any scrollbar-compensating padding

        if (this.$container.data('freeze-scroll')) {

          var transitionDuration = 500;

          var $innerModal = this.$container.find('.cc-popup-modal');

          if ($innerModal.length) {

            transitionDuration = parseFloat(getComputedStyle($innerModal[0])['transitionDuration']);

            if (transitionDuration && transitionDuration > 0) {

              transitionDuration *= 1000;

            }

          }

          setTimeout(function () {

            $('body').removeClass(_this10.cssClasses.bodyNoScroll).removeClass(_this10.cssClasses.bodyNoScrollPadRight).css('padding-right', '0');

          }, transitionDuration);

        }

        if (callback) {

          callback();

        }

      }

    }]);

    return ccPopup;

  }();

  ;

  theme.MapSection = new function () {

    var _ = this;

    _.config = {

      zoom: 14,

      styles: {

        "default": [],

        silver: [{

          "elementType": "geometry",

          "stylers": [{

            "color": "#f5f5f5"

          }]

        }, {

          "elementType": "labels.icon",

          "stylers": [{

            "visibility": "off"

          }]

        }, {

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#616161"

          }]

        }, {

          "elementType": "labels.text.stroke",

          "stylers": [{

            "color": "#f5f5f5"

          }]

        }, {

          "featureType": "administrative.land_parcel",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#bdbdbd"

          }]

        }, {

          "featureType": "poi",

          "elementType": "geometry",

          "stylers": [{

            "color": "#eeeeee"

          }]

        }, {

          "featureType": "poi",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#757575"

          }]

        }, {

          "featureType": "poi.park",

          "elementType": "geometry",

          "stylers": [{

            "color": "#e5e5e5"

          }]

        }, {

          "featureType": "poi.park",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#9e9e9e"

          }]

        }, {

          "featureType": "road",

          "elementType": "geometry",

          "stylers": [{

            "color": "#ffffff"

          }]

        }, {

          "featureType": "road.arterial",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#757575"

          }]

        }, {

          "featureType": "road.highway",

          "elementType": "geometry",

          "stylers": [{

            "color": "#dadada"

          }]

        }, {

          "featureType": "road.highway",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#616161"

          }]

        }, {

          "featureType": "road.local",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#9e9e9e"

          }]

        }, {

          "featureType": "transit.line",

          "elementType": "geometry",

          "stylers": [{

            "color": "#e5e5e5"

          }]

        }, {

          "featureType": "transit.station",

          "elementType": "geometry",

          "stylers": [{

            "color": "#eeeeee"

          }]

        }, {

          "featureType": "water",

          "elementType": "geometry",

          "stylers": [{

            "color": "#c9c9c9"

          }]

        }, {

          "featureType": "water",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#9e9e9e"

          }]

        }],

        retro: [{

          "elementType": "geometry",

          "stylers": [{

            "color": "#ebe3cd"

          }]

        }, {

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#523735"

          }]

        }, {

          "elementType": "labels.text.stroke",

          "stylers": [{

            "color": "#f5f1e6"

          }]

        }, {

          "featureType": "administrative",

          "elementType": "geometry.stroke",

          "stylers": [{

            "color": "#c9b2a6"

          }]

        }, {

          "featureType": "administrative.land_parcel",

          "elementType": "geometry.stroke",

          "stylers": [{

            "color": "#dcd2be"

          }]

        }, {

          "featureType": "administrative.land_parcel",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#ae9e90"

          }]

        }, {

          "featureType": "landscape.natural",

          "elementType": "geometry",

          "stylers": [{

            "color": "#dfd2ae"

          }]

        }, {

          "featureType": "poi",

          "elementType": "geometry",

          "stylers": [{

            "color": "#dfd2ae"

          }]

        }, {

          "featureType": "poi",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#93817c"

          }]

        }, {

          "featureType": "poi.park",

          "elementType": "geometry.fill",

          "stylers": [{

            "color": "#a5b076"

          }]

        }, {

          "featureType": "poi.park",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#447530"

          }]

        }, {

          "featureType": "road",

          "elementType": "geometry",

          "stylers": [{

            "color": "#f5f1e6"

          }]

        }, {

          "featureType": "road.arterial",

          "elementType": "geometry",

          "stylers": [{

            "color": "#fdfcf8"

          }]

        }, {

          "featureType": "road.highway",

          "elementType": "geometry",

          "stylers": [{

            "color": "#f8c967"

          }]

        }, {

          "featureType": "road.highway",

          "elementType": "geometry.stroke",

          "stylers": [{

            "color": "#e9bc62"

          }]

        }, {

          "featureType": "road.highway.controlled_access",

          "elementType": "geometry",

          "stylers": [{

            "color": "#e98d58"

          }]

        }, {

          "featureType": "road.highway.controlled_access",

          "elementType": "geometry.stroke",

          "stylers": [{

            "color": "#db8555"

          }]

        }, {

          "featureType": "road.local",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#806b63"

          }]

        }, {

          "featureType": "transit.line",

          "elementType": "geometry",

          "stylers": [{

            "color": "#dfd2ae"

          }]

        }, {

          "featureType": "transit.line",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#8f7d77"

          }]

        }, {

          "featureType": "transit.line",

          "elementType": "labels.text.stroke",

          "stylers": [{

            "color": "#ebe3cd"

          }]

        }, {

          "featureType": "transit.station",

          "elementType": "geometry",

          "stylers": [{

            "color": "#dfd2ae"

          }]

        }, {

          "featureType": "water",

          "elementType": "geometry.fill",

          "stylers": [{

            "color": "#b9d3c2"

          }]

        }, {

          "featureType": "water",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#92998d"

          }]

        }],

        dark: [{

          "elementType": "geometry",

          "stylers": [{

            "color": "#212121"

          }]

        }, {

          "elementType": "labels.icon",

          "stylers": [{

            "visibility": "off"

          }]

        }, {

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#757575"

          }]

        }, {

          "elementType": "labels.text.stroke",

          "stylers": [{

            "color": "#212121"

          }]

        }, {

          "featureType": "administrative",

          "elementType": "geometry",

          "stylers": [{

            "color": "#757575"

          }]

        }, {

          "featureType": "administrative.country",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#9e9e9e"

          }]

        }, {

          "featureType": "administrative.land_parcel",

          "stylers": [{

            "visibility": "off"

          }]

        }, {

          "featureType": "administrative.locality",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#bdbdbd"

          }]

        }, {

          "featureType": "poi",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#757575"

          }]

        }, {

          "featureType": "poi.park",

          "elementType": "geometry",

          "stylers": [{

            "color": "#181818"

          }]

        }, {

          "featureType": "poi.park",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#616161"

          }]

        }, {

          "featureType": "poi.park",

          "elementType": "labels.text.stroke",

          "stylers": [{

            "color": "#1b1b1b"

          }]

        }, {

          "featureType": "road",

          "elementType": "geometry.fill",

          "stylers": [{

            "color": "#2c2c2c"

          }]

        }, {

          "featureType": "road",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#8a8a8a"

          }]

        }, {

          "featureType": "road.arterial",

          "elementType": "geometry",

          "stylers": [{

            "color": "#373737"

          }]

        }, {

          "featureType": "road.highway",

          "elementType": "geometry",

          "stylers": [{

            "color": "#3c3c3c"

          }]

        }, {

          "featureType": "road.highway.controlled_access",

          "elementType": "geometry",

          "stylers": [{

            "color": "#4e4e4e"

          }]

        }, {

          "featureType": "road.local",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#616161"

          }]

        }, {

          "featureType": "transit",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#757575"

          }]

        }, {

          "featureType": "water",

          "elementType": "geometry",

          "stylers": [{

            "color": "#000000"

          }]

        }, {

          "featureType": "water",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#3d3d3d"

          }]

        }],

        night: [{

          "elementType": "geometry",

          "stylers": [{

            "color": "#242f3e"

          }]

        }, {

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#746855"

          }]

        }, {

          "elementType": "labels.text.stroke",

          "stylers": [{

            "color": "#242f3e"

          }]

        }, {

          "featureType": "administrative.locality",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#d59563"

          }]

        }, {

          "featureType": "poi",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#d59563"

          }]

        }, {

          "featureType": "poi.park",

          "elementType": "geometry",

          "stylers": [{

            "color": "#263c3f"

          }]

        }, {

          "featureType": "poi.park",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#6b9a76"

          }]

        }, {

          "featureType": "road",

          "elementType": "geometry",

          "stylers": [{

            "color": "#38414e"

          }]

        }, {

          "featureType": "road",

          "elementType": "geometry.stroke",

          "stylers": [{

            "color": "#212a37"

          }]

        }, {

          "featureType": "road",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#9ca5b3"

          }]

        }, {

          "featureType": "road.highway",

          "elementType": "geometry",

          "stylers": [{

            "color": "#746855"

          }]

        }, {

          "featureType": "road.highway",

          "elementType": "geometry.stroke",

          "stylers": [{

            "color": "#1f2835"

          }]

        }, {

          "featureType": "road.highway",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#f3d19c"

          }]

        }, {

          "featureType": "transit",

          "elementType": "geometry",

          "stylers": [{

            "color": "#2f3948"

          }]

        }, {

          "featureType": "transit.station",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#d59563"

          }]

        }, {

          "featureType": "water",

          "elementType": "geometry",

          "stylers": [{

            "color": "#17263c"

          }]

        }, {

          "featureType": "water",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#515c6d"

          }]

        }, {

          "featureType": "water",

          "elementType": "labels.text.stroke",

          "stylers": [{

            "color": "#17263c"

          }]

        }],

        aubergine: [{

          "elementType": "geometry",

          "stylers": [{

            "color": "#1d2c4d"

          }]

        }, {

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#8ec3b9"

          }]

        }, {

          "elementType": "labels.text.stroke",

          "stylers": [{

            "color": "#1a3646"

          }]

        }, {

          "featureType": "administrative.country",

          "elementType": "geometry.stroke",

          "stylers": [{

            "color": "#4b6878"

          }]

        }, {

          "featureType": "administrative.land_parcel",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#64779e"

          }]

        }, {

          "featureType": "administrative.province",

          "elementType": "geometry.stroke",

          "stylers": [{

            "color": "#4b6878"

          }]

        }, {

          "featureType": "landscape.man_made",

          "elementType": "geometry.stroke",

          "stylers": [{

            "color": "#334e87"

          }]

        }, {

          "featureType": "landscape.natural",

          "elementType": "geometry",

          "stylers": [{

            "color": "#023e58"

          }]

        }, {

          "featureType": "poi",

          "elementType": "geometry",

          "stylers": [{

            "color": "#283d6a"

          }]

        }, {

          "featureType": "poi",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#6f9ba5"

          }]

        }, {

          "featureType": "poi",

          "elementType": "labels.text.stroke",

          "stylers": [{

            "color": "#1d2c4d"

          }]

        }, {

          "featureType": "poi.park",

          "elementType": "geometry.fill",

          "stylers": [{

            "color": "#023e58"

          }]

        }, {

          "featureType": "poi.park",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#3C7680"

          }]

        }, {

          "featureType": "road",

          "elementType": "geometry",

          "stylers": [{

            "color": "#304a7d"

          }]

        }, {

          "featureType": "road",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#98a5be"

          }]

        }, {

          "featureType": "road",

          "elementType": "labels.text.stroke",

          "stylers": [{

            "color": "#1d2c4d"

          }]

        }, {

          "featureType": "road.highway",

          "elementType": "geometry",

          "stylers": [{

            "color": "#2c6675"

          }]

        }, {

          "featureType": "road.highway",

          "elementType": "geometry.stroke",

          "stylers": [{

            "color": "#255763"

          }]

        }, {

          "featureType": "road.highway",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#b0d5ce"

          }]

        }, {

          "featureType": "road.highway",

          "elementType": "labels.text.stroke",

          "stylers": [{

            "color": "#023e58"

          }]

        }, {

          "featureType": "transit",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#98a5be"

          }]

        }, {

          "featureType": "transit",

          "elementType": "labels.text.stroke",

          "stylers": [{

            "color": "#1d2c4d"

          }]

        }, {

          "featureType": "transit.line",

          "elementType": "geometry.fill",

          "stylers": [{

            "color": "#283d6a"

          }]

        }, {

          "featureType": "transit.station",

          "elementType": "geometry",

          "stylers": [{

            "color": "#3a4762"

          }]

        }, {

          "featureType": "water",

          "elementType": "geometry",

          "stylers": [{

            "color": "#0e1626"

          }]

        }, {

          "featureType": "water",

          "elementType": "labels.text.fill",

          "stylers": [{

            "color": "#4e6d70"

          }]

        }]

      }

    };

    _.apiStatus = null;

    this.geolocate = function ($map) {

      var deferred = $.Deferred();

      var geocoder = new google.maps.Geocoder();

      var address = $map.data('address-setting');

      geocoder.geocode({

        address: address

      }, function (results, status) {

        if (status !== google.maps.GeocoderStatus.OK) {

          deferred.reject(status);

        }

        deferred.resolve(results);

      });

      return deferred;

    };

    this.createMap = function (container) {

      var $map = $('.map-section__map-container', container);

      return _.geolocate($map).then(function (results) {

        var mapOptions = {

          zoom: _.config.zoom,

          styles: _.config.styles[$(container).data('map-style')],

          center: results[0].geometry.location,

          scrollwheel: false,

          disableDoubleClickZoom: true,

          disableDefaultUI: true,

          zoomControl: true

        };

        _.map = new google.maps.Map($map[0], mapOptions);

        _.center = _.map.getCenter();

        var marker = new google.maps.Marker({

          map: _.map,

          position: _.center,

          clickable: false

        });

        google.maps.event.addDomListener(window, 'resize', function () {

          google.maps.event.trigger(_.map, 'resize');

          _.map.setCenter(_.center);

        });

      }.bind(this)).fail(function () {

        var errorMessage;

        switch (status) {

          case 'ZERO_RESULTS':

            errorMessage = theme.strings.addressNoResults;

            break;

          case 'OVER_QUERY_LIMIT':

            errorMessage = theme.strings.addressQueryLimit;

            break;

          default:

            errorMessage = theme.strings.addressError;

            break;

        } // Only show error in the theme editor

        if (Shopify.designMode) {

          var $mapContainer = $map.parents('.map-section');

          $mapContainer.addClass('page-width map-section--load-error');

          $mapContainer.find('.map-section__wrapper').html('<div class="errors text-center">' + errorMessage + '</div>');

        }

      });

    };

    this.onSectionLoad = function (target) {

      var $container = $(target); // Global function called by Google on auth errors

      window.gm_authFailure = function () {

        if (!Shopify.designMode) return;

        $container.addClass('page-width map-section--load-error');

        $container.find('.map-section__wrapper').html('<div class="errors text-center">' + theme.strings.authError + '</div>');

      }; // create maps

      var key = $container.data('api-key');

      if (typeof key !== 'string' || key === '') {

        return;

      } // load map

      theme.loadScriptOnce('https://maps.googleapis.com/maps/api/js?key=' + key, function () {

        _.createMap($container);

      });

    };

    this.onSectionUnload = function (target) {

      if (typeof window.google !== 'undefined' && typeof google.maps !== 'undefined') {

        google.maps.event.clearListeners(this.map, 'resize');

      }

    };

  }(); // Register the section

  cc.sections.push({

    name: 'map',

    section: theme.MapSection

  }); // Manage videos

  theme.VideoManager = new function () {

    var _ = this;

    _._permitPlayback = function (container) {

      return !($(container).hasClass('video-container--background') && $(window).outerWidth() < 768);

    }; // Youtube

    _.youtubeVars = {

      incrementor: 0,

      apiReady: false,

      videoData: {},

      toProcessSelector: '.video-container[data-video-type="youtube"]:not(.video--init)'

    };

    _.youtubeApiReady = function () {

      _.youtubeVars.apiReady = true;

      _._loadYoutubeVideos();

    };

    _._loadYoutubeVideos = function (container) {

      if ($(_.youtubeVars.toProcessSelector, container).length) {

        if (_.youtubeVars.apiReady) {

          // play those videos

          $(_.youtubeVars.toProcessSelector, container).each(function () {

            // Don't init background videos on mobile

            if (_._permitPlayback($(this))) {

              $(this).addClass('video--init');

              _.youtubeVars.incrementor++;

              var containerId = 'theme-yt-video-' + _.youtubeVars.incrementor;

              $(this).data('video-container-id', containerId);

              var videoElement = $('<div class="video-container__video-element">').attr('id', containerId).appendTo($('.video-container__video', this));

              var autoplay = $(this).data('video-autoplay');

              var loop = $(this).data('video-loop');

              var player = new YT.Player(containerId, {

                height: '360',

                width: '640',

                videoId: $(this).data('video-id'),

                playerVars: {

                  iv_load_policy: 3,

                  modestbranding: 1,

                  autoplay: 0,

                  loop: loop ? 1 : 0,

                  playlist: $(this).data('video-id'),

                  rel: 0,

                  showinfo: 0

                },

                events: {

                  onReady: _._onYoutubePlayerReady.bind({

                    autoplay: autoplay,

                    loop: loop,

                    $container: $(this)

                  }),

                  onStateChange: _._onYoutubePlayerStateChange.bind({

                    autoplay: autoplay,

                    loop: loop,

                    $container: $(this)

                  })

                }

              });

              _.youtubeVars.videoData[containerId] = {

                id: containerId,

                container: this,

                videoElement: videoElement,

                player: player

              };

            }

          });

        } else {

          // load api

          theme.loadScriptOnce('https://www.youtube.com/iframe_api');

        }

      }

    };

    _._onYoutubePlayerReady = function (event) {

      event.target.setPlaybackQuality('hd1080');

      if (this.autoplay) {

        event.target.mute();

        event.target.playVideo();

      }

      _._initBackgroundVideo(this.$container);

    };

    _._onYoutubePlayerStateChange = function (event) {

      if (event.data == YT.PlayerState.PLAYING) {

        this.$container.addClass('video--play-started');

        if (this.autoplay) {

          event.target.mute();

        }

        if (this.loop) {

          // 4 times a second, check if we're in the final second of the video. If so, loop it for a more seamless loop

          var finalSecond = event.target.getDuration() - 1;

          if (finalSecond > 2) {

            var loopTheVideo = function loopTheVideo() {

              if (event.target.getCurrentTime() > finalSecond) {

                event.target.seekTo(0);

              }

              setTimeout(loopTheVideo, 250);

            };

            loopTheVideo();

          }

        }

      }

    };

    _._unloadYoutubeVideos = function (container) {

      for (var dataKey in _.youtubeVars.videoData) {

        var data = _.youtubeVars.videoData[dataKey];

        if ($(container).find(data.container).length) {

          data.player.destroy();

          delete _.youtubeVars.videoData[dataKey];

          return;

        }

      }

    }; // Vimeo

    _.vimeoVars = {

      incrementor: 0,

      apiReady: false,

      videoData: {},

      toProcessSelector: '.video-container[data-video-type="vimeo"]:not(.video--init)'

    };

    _.vimeoApiReady = function () {

      _.vimeoVars.apiReady = true;

      _._loadVimeoVideos();

    };

    _._loadVimeoVideos = function (container) {

      if ($(_.vimeoVars.toProcessSelector, container).length) {

        if (_.vimeoVars.apiReady) {

          // play those videos

          $(_.vimeoVars.toProcessSelector, container).each(function () {

            // Don't init background videos on mobile

            if (_._permitPlayback($(this))) {

              $(this).addClass('video--init');

              _.vimeoVars.incrementor++;

              var $this = $(this);

              var containerId = 'theme-vi-video-' + _.vimeoVars.incrementor;

              $(this).data('video-container-id', containerId);

              var videoElement = $('<div class="video-container__video-element">').attr('id', containerId).appendTo($('.video-container__video', this));

              var autoplay = !!$(this).data('video-autoplay');

              var player = new Vimeo.Player(containerId, {

                url: $(this).data('video-url'),

                width: 640,

                loop: $(this).data('video-autoplay'),

                autoplay: autoplay,

                muted: $this.hasClass('video-container--background')

              });

              player.on('playing', function () {

                $(this).addClass('video--play-started');

              }.bind(this));

              player.ready().then(function () {

                if (autoplay) {

                  player.setVolume(0);

                  player.play();

                }

                if (player.element && player.element.width && player.element.height) {

                  var ratio = parseInt(player.element.height) / parseInt(player.element.width);

                  $this.find('.video-container__video').css('padding-bottom', ratio * 100 + '%');

                }

                _._initBackgroundVideo($this);

              });

              _.vimeoVars.videoData[containerId] = {

                id: containerId,

                container: this,

                videoElement: videoElement,

                player: player,

                autoPlay: autoplay

              };

            }

          });

        } else {

          // load api

          if (window.define) {

            // workaround for third parties using RequireJS

            theme.loadScriptOnce('https://player.vimeo.com/api/player.js', function () {

              _.vimeoVars.apiReady = true;

              _._loadVimeoVideos();

              window.define = window.tempDefine;

            }, function () {

              window.tempDefine = window.define;

              window.define = null;

            });

          } else {

            theme.loadScriptOnce('https://player.vimeo.com/api/player.js', function () {

              _.vimeoVars.apiReady = true;

              _._loadVimeoVideos();

            });

          }

        }

      }

    };

    _._unloadVimeoVideos = function (container) {

      for (var dataKey in _.vimeoVars.videoData) {

        var data = _.vimeoVars.videoData[dataKey];

        if ($(container).find(data.container).length) {

          data.player.unload();

          delete _.vimeoVars.videoData[dataKey];

          return;

        }

      }

    }; // Init third party apis - Youtube and Vimeo

    _._loadThirdPartyApis = function (container) {

      //Don't init youtube or vimeo background videos on mobile

      if (_._permitPlayback($('.video-container', container))) {

        _._loadYoutubeVideos(container);

        _._loadVimeoVideos(container);

      }

    }; // Mp4

    _.mp4Vars = {

      incrementor: 0,

      videoData: {},

      toProcessSelector: '.video-container[data-video-type="mp4"]:not(.video--init)'

    };

    _._loadMp4Videos = function (container) {

      if ($(_.mp4Vars.toProcessSelector, container).length) {

        // play those videos

        $(_.mp4Vars.toProcessSelector, container).addClass('video--init').each(function () {

          _.mp4Vars.incrementor++;

          var $this = $(this);

          var containerId = 'theme-mp-video-' + _.mp4Vars.incrementor;

          $(this).data('video-container-id', containerId);

          var videoElement = $('<div class="video-container__video-element">').attr('id', containerId).appendTo($('.video-container__video', this));

          var $video = $('<video playsinline>');

          if ($(this).data('video-loop')) {

            $video.attr('loop', 'loop');

          }

          if ($(this).data('video-autoplay')) {

            $video.attr({

              autoplay: 'autoplay',

              muted: 'muted'

            });

            $video[0].muted = true; // required by Chrome - ignores attribute

            $video.one('loadeddata', function () {

              this.play();

            });

          }

          $video.on('playing', function () {

            $(this).addClass('video--play-started');

          }.bind(this));

          $video.attr('src', $(this).data('video-url')).appendTo(videoElement);

        });

      }

    };

    _._unloadMp4Videos = function (container) {}; // background video placement for iframes

    _._initBackgroundVideo = function ($container) {

      if ($container.hasClass('video-container--background') && $container.find('.video-container__video iframe').length) {

        var assessBackgroundVideo = function assessBackgroundVideo() {

          var $container = this,

              cw = $container.width(),

              ch = $container.height(),

              cr = cw / ch,

              $frame = $('.video-container__video iframe', this),

              vr = $frame.attr('width') / $frame.attr('height'),

              $pan = $('.video-container__video', this),

              vCrop = 75; // pushes video outside container to hide controls

          if (cr > vr) {

            var vh = cw / vr + vCrop * 2;

            $pan.css({

              marginTop: (ch - vh) / 2 - vCrop,

              marginLeft: '',

              height: vh + vCrop * 2,

              width: ''

            });

          } else {

            var vw = cw * vr + vCrop * 2 * vr;

            $pan.css({

              marginTop: -vCrop,

              marginLeft: (cw - vw) / 2,

              height: ch + vCrop * 2,

              width: vw

            });

          }

        };

        assessBackgroundVideo.bind($container)();

        $(window).on('debouncedresize.' + $container.data('video-container-id'), assessBackgroundVideo.bind($container));

      }

    }; // Compatibility with Sections

    this.onSectionLoad = function (container) {

      // url only - infer type

      $('.video-container[data-video-url]:not([data-video-type])').each(function () {

        var url = $(this).data('video-url');

        if (url.indexOf('.mp4') > -1) {

          $(this).attr('data-video-type', 'mp4');

        }

        if (url.indexOf('vimeo.com') > -1) {

          $(this).attr('data-video-type', 'vimeo');

          $(this).attr('data-video-id', url.split('?')[0].split('/').pop());

        }

        if (url.indexOf('youtu.be') > -1 || url.indexOf('youtube.com') > -1) {

          $(this).attr('data-video-type', 'youtube');

          if (url.indexOf('v=') > -1) {

            $(this).attr('data-video-id', url.split('v=').pop().split('&')[0]);

          } else {

            $(this).attr('data-video-id', url.split('?')[0].split('/').pop());

          }

        }

      });

      _._loadThirdPartyApis(container);

      _._loadMp4Videos(container);

      $(window).on('debouncedresize.video-manager-resize', function () {

        _._loadThirdPartyApis(container);

      }); // play button

      $('.video-container__play', container).on('click', function (evt) {

        evt.preventDefault();

        var $container = $(this).closest('.video-container'); // reveal

        $container.addClass('video-container--playing'); // broadcast a play event on the section container

        $(container).trigger("cc:video:play"); // play

        var id = $container.data('video-container-id');

        if (id.indexOf('theme-yt-video') === 0) {

          _.youtubeVars.videoData[id].player.playVideo();

        } else {

          _.vimeoVars.videoData[id].player.play();

        }

      }); // modal close button

      $('.video-container__stop', container).on('click', function (evt) {

        evt.preventDefault();

        var $container = $(this).closest('.video-container'); // hide

        $container.removeClass('video-container--playing'); // broadcast a stop event on the section container

        $(container).trigger("cc:video:stop"); // play

        var id = $container.data('video-container-id');

        if (id.indexOf('theme-yt-video') === 0) {

          _.youtubeVars.videoData[id].player.stopVideo();

        } else {

          _.vimeoVars.videoData[id].player.pause();

          _.vimeoVars.videoData[id].player.setCurrentTime(0);

        }

      });

    };

    this.onSectionUnload = function (container) {

      $('.video-container__play, .video-container__stop', container).off('click');

      $(window).off('.' + $('.video-container').data('video-container-id'));

      $(window).off('debouncedresize.video-manager-resize');

      _._unloadYoutubeVideos(container);

      _._unloadVimeoVideos(container);

      _._unloadMp4Videos(container);

      $(container).trigger("cc:video:stop");

    };

  }(); // Youtube API callback

  window.onYouTubeIframeAPIReady = function () {

    theme.VideoManager.youtubeApiReady();

  }; // Register the section

  cc.sections.push({

    name: 'video',

    section: theme.VideoManager

  });

  /**

   * Popup Section Script

   * ------------------------------------------------------------------------------

   *

   * @namespace Popup

   */

  theme.Popup = new function () {

    /**

     * Popup section constructor. Runs on page load as well as Theme Editor

     * `section:load` events.

     * @param {string} container - selector for the section container DOM element

     */

    var dismissedStorageKey = 'cc-theme-popup-dismissed';

    this.onSectionLoad = function (container) {

      var _this11 = this;

      this.namespace = theme.namespaceFromSection(container);

      this.$container = $(container);

      this.popup = new ccPopup(this.$container, this.namespace);

      var dismissForDays = this.$container.data('dismiss-for-days'),

          delaySeconds = this.$container.data('delay-seconds'),

          showPopup = true,

          testMode = this.$container.data('test-mode'),

          lastDismissed = window.localStorage.getItem(dismissedStorageKey); // Should we show it during this page view?

      // Check when it was last dismissed

      if (lastDismissed) {

        var dismissedDaysAgo = (new Date().getTime() - lastDismissed) / (1000 * 60 * 60 * 24);

        if (dismissedDaysAgo < dismissForDays) {

          showPopup = false;

        }

      } // Check for error or success messages

      if (this.$container.find('.cc-popup-form__response').length) {

        showPopup = true;

        delaySeconds = 1; // If success, set as dismissed

        if (this.$container.find('.cc-popup-form__response--success').length) {

          this.functions.popupSetAsDismissed.call(this);

        }

      } // Prevent popup on Shopify robot challenge page

      if (document.querySelector('.shopify-challenge__container')) {

        showPopup = false;

      } // Show popup, if appropriate

      if (showPopup || testMode) {

        setTimeout(function () {
          _this11.popup.open();

        }, delaySeconds * 1000);

      } // Click on close button or modal background

      this.$container.on('click' + this.namespace, '.cc-popup-close, .cc-popup-background', function () {

        _this11.popup.close(function () {

          _this11.functions.popupSetAsDismissed.call(_this11);

        });

      });

    };

    this.onSectionSelect = function () {
      this.popup.open();

    };

    this.functions = {

      /**

       * Use localStorage to set as dismissed

       */

      popupSetAsDismissed: function popupSetAsDismissed() {

        window.localStorage.setItem(dismissedStorageKey, new Date().getTime());

      }

    };

    /**

     * Event callback for Theme Editor `section:unload` event

     */

    this.onSectionUnload = function () {

      this.$container.off(this.namespace);

    };

  }(); // Register section

  cc.sections.push({

    name: 'newsletter-popup',

    section: theme.Popup

  });

  /**

   * StoreAvailability Section Script

   * ------------------------------------------------------------------------------

   *

   * @namespace StoreAvailability

   */

  theme.StoreAvailability = function (container) {

    var loadingClass = 'store-availability-loading';

    var initClass = 'store-availability-initialized';

    var storageKey = 'cc-location';

    this.onSectionLoad = function (container) {

      var _this12 = this;

      this.namespace = theme.namespaceFromSection(container);

      this.$container = $(container);

      this.productId = this.$container.data('store-availability-container');

      this.sectionUrl = this.$container.data('section-url');

      this.$modal;

      var firstRun = true; // Handle when a variant is selected

      $(window).on("cc-variant-updated".concat(this.namespace).concat(this.productId), function (e, args) {

        if (args.product.id === _this12.productId) {

          _this12.functions.updateContent.bind(_this12)(args.variant.id, args.product.title, firstRun, _this12.$container.data('has-only-default-variant'), typeof args.variant.available !== "undefined");

          firstRun = false;

        }

      }); // Handle single variant products

      if (this.$container.data('single-variant-id')) {

        this.functions.updateContent.bind(this)(this.$container.data('single-variant-id'), this.$container.data('single-variant-product-title'), firstRun, this.$container.data('has-only-default-variant'), this.$container.data('single-variant-product-available'));

        firstRun = false;

      }

    };

    this.onSectionUnload = function () {

      $(window).off("cc-variant-updated".concat(this.namespace).concat(this.productId));

      this.$container.off('click');

      if (this.$modal) {

        this.$modal.off('click');

      }

    };

    this.functions = {

      // Returns the users location data (if allowed)

      getUserLocation: function getUserLocation() {

        return new Promise(function (resolve, reject) {

          var storedCoords;

          if (sessionStorage[storageKey]) {

            storedCoords = JSON.parse(sessionStorage[storageKey]);

          }

          if (storedCoords) {

            resolve(storedCoords);

          } else {

            if (navigator.geolocation) {

              navigator.geolocation.getCurrentPosition(function (position) {

                var coords = {

                  latitude: position.coords.latitude,

                  longitude: position.coords.longitude

                }; //Set the localization api

                fetch('/localization.json', {

                  method: 'PUT',

                  headers: {

                    'Content-Type': 'application/json'

                  },

                  body: JSON.stringify(coords)

                }); //Write to a session storage

                sessionStorage[storageKey] = JSON.stringify(coords);

                resolve(coords);

              }, function () {

                resolve(false);

              }, {

                maximumAge: 3600000,

                // 1 hour

                timeout: 5000

              });

            } else {

              resolve(false);

            }

          }

        });

      },

      // Requests the available stores and calls the callback

      getAvailableStores: function getAvailableStores(variantId, cb) {

        return $.get(this.sectionUrl.replace('VARIANT_ID', variantId), cb);

      },

      // Haversine Distance

      // The haversine formula is an equation giving great-circle distances between

      // two points on a sphere from their longitudes and latitudes

      calculateDistance: function calculateDistance(coords1, coords2, unitSystem) {

        var dtor = Math.PI / 180;

        var radius = unitSystem === 'metric' ? 6378.14 : 3959;

        var rlat1 = coords1.latitude * dtor;

        var rlong1 = coords1.longitude * dtor;

        var rlat2 = coords2.latitude * dtor;

        var rlong2 = coords2.longitude * dtor;

        var dlon = rlong1 - rlong2;

        var dlat = rlat1 - rlat2;

        var a = Math.pow(Math.sin(dlat / 2), 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.pow(Math.sin(dlon / 2), 2);

        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return radius * c;

      },

      // Updates the existing modal pickup with locations with distances from the user

      updateLocationDistances: function updateLocationDistances(coords) {

        var unitSystem = this.$modal.find('[data-unit-system]').data('unit-system');

        var self = this;

        this.$modal.find('[data-distance="false"]').each(function () {

          var _this13 = this;

          var thisCoords = {

            latitude: parseFloat($(this).data('latitude')),

            longitude: parseFloat($(this).data('longitude'))

          };

          if (thisCoords.latitude && thisCoords.longitude) {

            var distance = self.functions.calculateDistance(coords, thisCoords, unitSystem).toFixed(1);

            $(this).html(distance); //Timeout to trigger animation

            setTimeout(function () {

              $(_this13).closest('.store-availability-list__location__distance').addClass('-in');

            }, 0);

          }

          $(this).attr('data-distance', 'true');

        });

      },

      // Requests the available stores and updates the page with info below Add to Basket, and append the modal to the page

      updateContent: function updateContent(variantId, productTitle, firstRun, isSingleDefaultVariant, isVariantAvailable) {

        var _this14 = this;

        this.$container.off('click', '[data-store-availability-modal-open]');

        this.$container.off('click' + this.namespace, '.cc-popup-close, .cc-popup-background');

        $('.store-availabilities-modal').remove();

        if (firstRun) {

          this.$container.hide();

        } else if (!isVariantAvailable) {

          //If the variant is Unavailable (not the same as Out of Stock) - hide the store pickup completely

          this.$container.addClass(loadingClass).addClass(initClass);

          this.$container.css('height', '0px');

        } else {

          this.$container.addClass(loadingClass).addClass(initClass);

          this.$container.css('height', this.$container.outerHeight() > 0 ? this.$container.outerHeight() + 'px' : 'auto');

        }

        if (isVariantAvailable) {

          this.functions.getAvailableStores.call(this, variantId, function (response) {

            if (response.trim().length > 0 && !response.includes('NO_PICKUP')) {

              _this14.$container.html(response);

              _this14.$container.html(_this14.$container.children().first().html()); // editor bug workaround

              _this14.$container.find('[data-store-availability-modal-product-title]').html(productTitle);

              if (isSingleDefaultVariant) {

                _this14.$container.find('.store-availabilities-modal__variant-title').remove();

              }

              _this14.$container.find('.cc-popup').appendTo('body');

              _this14.$modal = $('body').find('.store-availabilities-modal');

              var popup = new ccPopup(_this14.$modal, _this14.namespace);

              _this14.$container.on('click', '[data-store-availability-modal-open]', function () {

                popup.open(); //When the modal is opened, try and get the users location

                _this14.functions.getUserLocation().then(function (coords) {

                  if (coords && _this14.$modal.find('[data-distance="false"]').length) {

                    //Re-retrieve the available stores location modal contents

                    _this14.functions.getAvailableStores.call(_this14, variantId, function (response) {

                      _this14.$modal.find('.store-availabilities-list').html($(response).find('.store-availabilities-list').html());

                      _this14.functions.updateLocationDistances.bind(_this14)(coords);

                    });

                  }

                });

                return false;

              });

              _this14.$modal.on('click' + _this14.namespace, '.cc-popup-close, .cc-popup-background', function () {

                popup.close();

              });

              if (firstRun) {

                _this14.$container.slideDown(300);

              } else {

                _this14.$container.removeClass(loadingClass);

                var newHeight = _this14.$container.find('.store-availability-container').outerHeight();

                _this14.$container.css('height', newHeight > 0 ? newHeight + 'px' : 'auto');

              }

            }

          });

        }

      }

    }; // Initialise the section when it's instantiated

    this.onSectionLoad(container);

  }; // Register section

  cc.sections.push({

    name: 'store-availability',

    section: theme.StoreAvailability

  });

  /*================ Icons ================*/

  theme.icons = {

    check: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>',

    chevronRight: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg>',

    arrowLeft: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>',

    slideshowPrevArrow: '<button class="slick-prev"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' + theme.strings.previous + '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg></button>',

    slideshowNextArrow: '<button class="slick-next"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' + theme.strings.next + '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg></button>'

  };

  /*================ Slate ================*/

  /**

   * A11y Helpers

   * -----------------------------------------------------------------------------

   * A collection of useful functions that help make your theme more accessible

   * to users with visual impairments.

   *

   *

   * @namespace a11y

   */

  slate.a11y = {

    /**

     * For use when focus shifts to a container rather than a link

     * eg for In-page links, after scroll, focus shifts to content area so that

     * next `tab` is where user expects if focusing a link, just $link.focus();

     *

     * @param {JQuery} $element - The element to be acted upon

     */

    pageLinkFocus: function pageLinkFocus($element) {

      var focusClass = 'js-focus-hidden';

      $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);

      function callback() {

        $element.first().removeClass(focusClass).removeAttr('tabindex');

      }

    },

    /**

     * If there's a hash in the url, focus the appropriate element

     */

    focusHash: function focusHash() {

      var hash = window.location.hash; // is there a hash in the url? is it an element on the page?

      if (hash && document.getElementById(hash.slice(1))) {

        this.pageLinkFocus($(hash));

      }

    },

    /**

     * When an in-page (url w/hash) link is clicked, focus the appropriate element

     */

    bindInPageLinks: function bindInPageLinks() {

      $('a[href*=#]').on('click', function (evt) {

        this.pageLinkFocus($(evt.currentTarget.hash));

      }.bind(this));

    },

    /**

     * Traps the focus in a particular container

     *

     * @param {object} options - Options to be used

     * @param {jQuery} options.$container - Container to trap focus within

     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container

     * @param {string} options.namespace - Namespace used for new focus event handler

     */

    trapFocus: function trapFocus(options) {

      var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

      if (!options.$elementToFocus) {

        options.$elementToFocus = options.$container;

      }

      options.$container.attr('tabindex', '-1');

      options.$elementToFocus.focus();

      $(document).on(eventName, function (evt) {

        if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {

          options.$container.focus();

        }

      });

    },

    /**

     * Removes the trap of focus in a particular container

     *

     * @param {object} options - Options to be used

     * @param {jQuery} options.$container - Container to trap focus within

     * @param {string} options.namespace - Namespace used for new focus event handler

     */

    removeTrapFocus: function removeTrapFocus(options) {

      var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

      if (options.$container && options.$container.length) {

        options.$container.removeAttr('tabindex');

      }

      $(document).off(eventName);

    }

  };

  ;

  /**

   * Cart Template Script

   * ------------------------------------------------------------------------------

   * A file that contains scripts highly couple code to the Cart template.

   *

   * @namespace cart

   */

  slate.cart = {

    /**

     * Browser cookies are required to use the cart. This function checks if

     * cookies are enabled in the browser.

     */

    cookiesEnabled: function cookiesEnabled() {

      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {

        document.cookie = 'testcookie';

        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;

      }

      return cookieEnabled;

    }

  };

  ;

  /**

   * Utility helpers

   * -----------------------------------------------------------------------------

   * A collection of useful functions for dealing with arrays and objects

   *

   * @namespace utils

   */

  slate.utils = {

    /**

     * Return an object from an array of objects that matches the provided key and value

     *

     * @param {array} array - Array of objects

     * @param {string} key - Key to match the value against

     * @param {string} value - Value to get match of

     */

    findInstance: function findInstance(array, key, value) {

      for (var i = 0; i < array.length; i++) {

        if (array[i][key] === value) {

          return array[i];

        }

      }

    },

    /**

     * Remove an object from an array of objects by matching the provided key and value

     *

     * @param {array} array - Array of objects

     * @param {string} key - Key to match the value against

     * @param {string} value - Value to get match of

     */

    removeInstance: function removeInstance(array, key, value) {

      var i = array.length;

      while (i--) {

        if (array[i][key] === value) {

          array.splice(i, 1);

          break;

        }

      }

      return array;

    },

    /**

     * _.compact from lodash

     * Remove empty/false items from array

     * Source: https://github.com/lodash/lodash/blob/master/compact.js

     *

     * @param {array} array

     */

    compact: function compact(array) {

      var index = -1;

      var length = array == null ? 0 : array.length;

      var resIndex = 0;

      var result = [];

      while (++index < length) {

        var value = array[index];

        if (value) {

          result[resIndex++] = value;

        }

      }

      return result;

    },

    /**

     * _.defaultTo from lodash

     * Checks `value` to determine whether a default value should be returned in

     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,

     * or `undefined`.

     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js

     *

     * @param {*} value - Value to check

     * @param {*} defaultValue - Default value

     * @returns {*} - Returns the resolved value

     */

    defaultTo: function defaultTo(value, defaultValue) {

      return value == null || value !== value ? defaultValue : value;

    }

  };

  ;

  /**

   * Rich Text Editor

   * -----------------------------------------------------------------------------

   * Wrap iframes and tables in div tags to force responsive/scrollable layout.

   *

   * @namespace rte

   */

  slate.rte = {

    /**

     * Wrap tables in a container div to make them scrollable when needed

     *

     * @param {object} options - Options to be used

     * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap

     * @param {string} options.tableWrapperClass - table wrapper class name

     */

    wrapTable: function wrapTable(options) {

      var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

      options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');

    },

    /**

     * Wrap iframes in a container div to make them responsive

     *

     * @param {object} options - Options to be used

     * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap

     * @param {string} options.iframeWrapperClass - class name used on the wrapping div

     */

    wrapIframe: function wrapIframe(options) {

      var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

      options.$iframes.each(function () {

        // Add wrapper to make video responsive

        $(this).wrap('<div class="' + iframeWrapperClass + '"></div>'); // Re-set the src attribute on each iframe after page load

        // for Chrome's "incorrect iFrame content on 'back'" bug.

        // https://code.google.com/p/chromium/issues/detail?id=395791

        // Need to specifically target video and admin bar

        this.src = this.src;

      });

    }

  };

  ;

  /**

   * Image Helper Functions

   * -----------------------------------------------------------------------------

   * A collection of functions that help with basic image operations.

   *

   */

  slate.Image = function () {

    /**

     * Preloads an image in memory and uses the browsers cache to store it until needed.

     *

     * @param {Array} images - A list of image urls

     * @param {String} size - A shopify image size attribute

     */

    function preload(images, size) {

      if (typeof images === 'string') {

        images = [images];

      }

      for (var i = 0; i < images.length; i++) {

        var image = images[i];

        this.loadImage(this.getSizedImageUrl(image, size));

      }

    }

    /**

     * Loads and caches an image in the browsers cache.

     * @param {string} path - An image url

     */

    function loadImage(path) {

      new Image().src = path;

    }

    /**

     * Find the Shopify image attribute size

     *

     * @param {string} src

     * @returns {null}

     */

    function imageSize(src) {

      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

      if (match) {

        return match[1];

      } else {

        return null;

      }

    }

    /**

     * Adds a Shopify size attribute to a URL

     *

     * @param src

     * @param size

     * @returns {*}

     */

    function getSizedImageUrl(src, size) {

      if (size === null) {

        return src;

      }

      if (size === 'master') {

        return this.removeProtocol(src);

      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

      if (match) {

        var prefix = src.split(match[0]);

        var suffix = match[0];

        return this.removeProtocol(prefix[0] + '_' + size + suffix);

      } else {

        return null;

      }

    }

    function removeProtocol(path) {

      return path.replace(/http(s)?:/, '');

    }

    return {

      preload: preload,

      loadImage: loadImage,

      imageSize: imageSize,

      getSizedImageUrl: getSizedImageUrl,

      removeProtocol: removeProtocol

    };

  }();

  ;

  /**

   * Variant Selection scripts

   * ------------------------------------------------------------------------------

   *

   * Handles change events from the variant inputs in any `cart/add` forms that may

   * exist. Also updates the master select and triggers updates when the variants

   * price or image changes.

   *

   * @namespace variants

   */

  slate.Variants = function () {

    

    /**

     * Variant constructor

     *

     * @param {object} options - Settings from `product.js`

     */

    function Variants(options) {

      this.$container = options.$container;

      this.product = options.product;

      this.singleOptionSelector = options.singleOptionSelector;

      this.originalSelectorId = options.originalSelectorId;

      this.enableHistoryState = options.enableHistoryState;

      this.currentVariant = this._getVariantFromOptions();

      $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));

    }

    Variants.prototype = $.extend({}, Variants.prototype, {

      /**

       * Get the currently selected options from add-to-cart form. Works with all

       * form input elements.

       *

       * @return {array} options - Values of currently selected variants

       */

      _getCurrentOptions: function _getCurrentOptions() {

        var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {

          var $element = $(element);

          var type = $element.attr('type');

          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {

            if ($element[0].checked) {

              currentOption.value = $element.val();

              currentOption.index = $element.data('index');

              return currentOption;

            } else {

              return false;

            }

          } else {

            currentOption.value = $element.val();

            currentOption.index = $element.data('index');

            return currentOption;

          }

        }); // remove any unchecked input values if using radio buttons or checkboxes

        currentOptions = slate.utils.compact(currentOptions);

        return currentOptions;

      },

      /**

       * Find variant based on selected values.

       *

       * @param  {array} selectedValues - Values of variant inputs

       * @return {object || undefined} found - Variant object from product.variants

       */

      _getVariantFromOptions: function _getVariantFromOptions() {

        var selectedValues = this._getCurrentOptions();

        var variants = this.product.variants;

        var found = false;

        $('.clickyboxes.options--size li a').removeClass('already-click');

        $('.clickyboxes.options--color li a').removeClass('already-click');

        $('.options--size li a').removeClass('available-size');

        $('.options--color li a').removeClass('available-color');

        $('.options--size li a').removeClass('add-to-cart');

        $('.options--size li a').removeClass('soldout');

        $('.options--color li a').removeClass('add-to-cart');

        $('.options--color li a').removeClass('soldout');

        $('.options--color li').removeClass('li-notavailable');

        $('.options--color li').removeClass('li-available');

        $('.product-component-kit').html('');

        $('.component-kit-sec ul').html('');

       

        setTimeout(function(){

          $('.component-list').remove();

        }, 500);

        variants.forEach(function (variant) {

          setTimeout(function(){

            if(variants.length < 2){

              if (variant.option1.indexOf('"') > -1){

                $(`.options--color li a[data-value='${variant.option1}']`).addClass('available-color');

                $(`.options--color li a[data-value='${variant.option1}']`).addClass(`${(variant.available)?'add-to-cart': 'soldout'}`);

              }else{

                $(`.options--color li a[data-value="${variant.option1}"]`).addClass('available-color');

                $(`.options--color li a[data-value="${variant.option1}"]`).addClass(`${(variant.available)?'add-to-cart': 'soldout'}`);



              }

              

              if(variant.option2){

                if (variant.option2.indexOf('"') > -1){

                  $(`.options--size li a[data-value='${variant.option2}']`).addClass('available-size');

                  $(`.options--size li a[data-value='${variant.option2}']`).addClass(`${(variant.available)?'add-to-cart': 'soldout'}`);

                }else{

                  $(`.options--size li a[data-value="${variant.option2}"]`).addClass('available-size');

                  $(`.options--size li a[data-value="${variant.option2}"]`).addClass(`${(variant.available)?'add-to-cart': 'soldout'}`);

                }

                

                

              }              

            }

          }, 100);

          setTimeout(function(){

            //
            if($('.product-component-kit').html() != null) {
            var component_kit = $('.product-component-kit').html().split(",");
            }
            var i;          
            if(component_kit != null) {
            for (i = 0; i < component_kit.length; ++i) {

              if(component_kit[i] == variant.id){

                var variable_sku = variant.sku;

                var variable_title = variant.title;

                if(variant.featured_image){

                  var feature_src= variant.featured_image['src'];

                }else{

                  var feature_src= '';

                }

                      

                $('.component-kit-sec ul').append('<li class="component-list"><img src="'+feature_src+'"><span class="variant-comp-tlt">'+variable_title+'</span><span>'+variable_sku+'</span></li>');

              }               

            }               
          }
          }, 500);

          var satisfied = true;       

           selectedValues.forEach(function (option) {

            

            if (satisfied) {

              satisfied = option.value === variant[option.index];

              }

              if(!selectedValues[1]){ 

                if (variant[option.index].indexOf('"') > -1){

                  $(`.options--color li a[data-value='${variant[option.index]}']`).addClass('available-color');

                  $(`.options--color li a[data-value='${variant[option.index]}']`).addClass(`${(variant.available)?'add-to-cart': 'soldout'}`);

                }else{

                  $(`.options--color li a[data-value="${variant[option.index]}"]`).addClass('available-color');

                  $(`.options--color li a[data-value="${variant[option.index]}"]`).addClass(`${(variant.available)?'add-to-cart': 'soldout'}`);

                }

                    

              }

              if(selectedValues[0]){

                var selectedcolor = selectedValues[0].value;

                if(selectedcolor == variant[option.index]){   
                  if(variant['option2']){

                    var available_size = variant['option2'];

                    if (available_size.indexOf('"') > -1){

                      $(`.options--size li a[data-value='${available_size}']`).addClass('available-size');

                      $(`.options--size li a[data-value='${available_size}']`).addClass(`${(variant.available)?'add-to-cart': 'soldout'}`);

                    }

                    else{

                      $(`.options--size li a[data-value="${available_size}"]`).addClass('available-size');

                      $(`.options--size li a[data-value="${available_size}"]`).addClass(`${(variant.available)?'add-to-cart': 'soldout'}`);

                    }

                   

                  }         

                }

              }

              

              if(selectedValues[1]){                

                var selectedsize = selectedValues[1].value;

                if(selectedsize == variant[option.index]){
                  if(variant['option1']){
                    var available_color = variant['option1'];

                    if (available_color.indexOf('"') > -1){

                      $(`.options--color li a[data-value='${available_color}']`).addClass('available-color');

                      $(`.options--color li a[data-value='${available_color}']`).addClass(`${(variant.available)?'add-to-cart': 'soldout'}`);

                      $(`.options--color li a[data-value='${available_color}']`).parent('.parent-list').addClass(`${(variant.available)?'li-available': 'li-notavailable bg-fixunavailable'}`);

                    }else{

                      $(`.options--color li a[data-value="${available_color}"]`).addClass('available-color');

                      $(`.options--color li a[data-value="${available_color}"]`).addClass(`${(variant.available)?'add-to-cart': 'soldout'}`);

                      $(`.options--color li a[data-value="${available_color}"]`).parent('.parent-list').addClass(`${(variant.available)?'li-available': 'li-notavailable bg-fixunavailable'}`);

                    }

                    

                  }                 

                  

                }

              }

          });

          if (satisfied) {

            found = variant;

          }

        });

        if(found == false){

          

          if($('.clickyboxes.options--color li a').hasClass('fullactive')){

            if($('.options--size li a.available-size.add-to-cart').length > 0){

              $('.options--size li a.available-size.add-to-cart').eq(0).click();

              setTimeout(function(){

                  $('.product-form-button-container .add-to-cart').prop('disabled', false);

                  $('.product-form-button-container .add-to-cart-text').html(theme.strings.addToCart);

                }, 20);

            }else{

              $('.options--size li a.available-size.soldout').eq(0).click();

              setTimeout(function(){

                $('.product-form-button-container .add-to-cart').prop('disabled', true);

                $('.product-form-button-container .add-to-cart-text').html(theme.strings.soldOut);

              }, 20);

            }

            

            // var loop = false;

            // $('.clickyboxes.options--size li a').each(function(index){

            //   if(loop){

            //     $(this).addClass('already-click');

                

            //     return false;

            //   }

            //   if($(this).hasClass('active') || $(this).hasClass('already-click')){             

            //     loop = true;                

            //   }

              

            // });

            

          }

          else{

            var loop = false;

            

            if($('.options--color li a.available-color.add-to-cart').length > 0){

              $('.options--color li a.available-color.add-to-cart').eq(0).click();

              setTimeout(function(){

                $('.product-form-button-container .add-to-cart').prop('disabled', false);

                $('.product-form-button-container .add-to-cart-text').html(theme.strings.addToCart);

              }, 100);

            }else{

              $('.options--color li a.available-color.soldout').eq(0).click();

              setTimeout(function(){

                $('.product-form-button-container .add-to-cart').prop('disabled', true);

                $('.product-form-button-container .add-to-cart-text').html(theme.strings.soldOut);

              }, 100);

            }

            

            // $('.clickyboxes.options--color li a').each(function(index){

            //   if(loop){

            //     $(this).addClass('already-click');

                

            //     return false;

            //   }

            //   if($(this).hasClass('active') || $(this).hasClass('already-click')){             

            //     loop = true;                

            //   }

            // });

          }

          

        }

        if(meta_kit_id[found.sku]){

          setTimeout(function(){

            $('.product-sku__value').html(found.sku);

          }, 100);

          var meta_kitid = meta_kit_id[found.sku];         

          $('.product-component-kit').html(meta_kitid);

      }

      else{

        $('.product-component-kit').html('');

      }

        return found || null;

      },

      /**

       * Event handler for when a variant input changes.

       */

      _onSelectChange: function _onSelectChange() {

        

        var variant = this._getVariantFromOptions();

        if(variant){

          var exclusive = $("div[data-id='"+variant.id+"']").html();

          $('.options--color li a[data-value="'+ variant.option1+'"]').siblings('.exclusive-text').remove(); 

          if(exclusive){    

                  

            $('.options--color li a[data-value="'+ variant.option1+'"]').parent().append('<span class="exclusive-text">Exclusive</span>');

          }

          

        }

        

        this.$container.trigger({

          type: 'variantChange',

          variant: variant

        });

        if (!variant) {

          return;

        }

        const mediaQuery = window.matchMedia('(max-width: 767px)');

        if (mediaQuery.matches) {

        var color_handle = variant.option1.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/-*$/, '');

          if(color_handle){
            $('.product-thumbnails--inline').slick('slickUnfilter');

            $('.product-thumbnails--inline').slick('slickFilter', '.'+ color_handle);

            $('.product-thumbnails--inline').slick('slickGoTo', 0);

            $('.desktop-mobile-both .product-thumbnails').slick('slickUnfilter');

            $('.desktop-mobile-both .product-thumbnails').slick('slickFilter', '.'+ color_handle);

            $('.desktop-mobile-both .product-thumbnails').slick('slickGoTo', 0);
            }
        }

        $(window).trigger('cc-variant-updated', {

          variant: variant,

          product: this.product

        });

        this._updateMasterSelect(variant);

        this._updateImages(variant);

        this._updatePrice(variant);

        this.currentVariant = variant;

        if (this.enableHistoryState) {

          this._updateHistoryState(variant);

        }

      },

      /**

       * Trigger event when variant image changes

       *

       * @param  {object} variant - Currently selected variant

       * @return {event}  variantImageChange

       */

      _updateImages: function _updateImages(variant) {

        var variantMedia = variant.featured_media || {};

        var currentVariantMedia = this.currentVariant.featured_media || {};

        if (!variant.featured_media || variantMedia.id === currentVariantMedia.id) {

          return;

        }

        this.$container.trigger({

          type: 'variantImageChange',

          variant: variant

        });

      },

      /**

       * Trigger event when variant price changes.

       *

       * @param  {object} variant - Currently selected variant

       * @return {event} variantPriceChange

       */

      _updatePrice: function _updatePrice(variant) {

        $('.variant-option-title').html(variant.option1);

        var hasChanged = false;

        if (variant.price !== this.currentVariant.price || variant.compare_at_price !== this.currentVariant.compare_at_price || variant.unit_price_measurement !== this.currentVariant.unit_price_measurement || variant.unit_price_measurement && (variant.unit_price !== this.currentVariant.unit_price || variant.unit_price_measurement.reference_value !== this.currentVariant.unit_price_measurement.reference_value || variant.unit_price_measurement.reference_unit !== this.currentVariant.unit_price_measurement.reference_unit)) {

          hasChanged = true;

        }

        if (!hasChanged) {

          return;

        }

        this.$container.trigger({

          type: 'variantPriceChange',

          variant: variant

        }); // Update the installments banner

        var input = this.$container[0].querySelector('input[name="id"]');

        input.value = variant.id;

        input.dispatchEvent(new Event('change', {

          bubbles: true

        }));

      },

      /**

       * Update history state for product deeplinking

       *

       * @param {object} variant - Currently selected variant

       */

      _updateHistoryState: function _updateHistoryState(variant) {

        if (!history.replaceState || !variant) {

          return;

        }

        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;

        window.history.replaceState({

          path: newurl

        }, '', newurl);

      },

      /**

       * Update hidden master select of variant change

       *

       * @param {object} variant - Currently selected variant

       */

      _updateMasterSelect: function _updateMasterSelect(variant) {

        

        var select = $(this.originalSelectorId, this.$container)[0];

        if (!select) return;

        select.value = variant.id;

        select.dispatchEvent(new Event('change', {

          bubbles: true,

          cancelable: false

        }));

      }

    });

    return Variants;

  }();

  ;

  /*=============== Components ===============*/

  theme.addNoticeToForm = function ($notice, $form) {

    var $existingNotices = $('.ajax-add-notice', $form);

    if ($existingNotices.length > 0) {

      setTimeout(function () {

        // wait until fading-out has definitely finished

        $existingNotices.replaceWith($notice.addClass('ajax-add-notice--pre-replace'));

        setTimeout(function () {

          $notice.removeClass('ajax-add-notice--pre-replace');

        }, 10);

      }, 251);

    } else {

      $notice.addClass('ajax-add-notice--pre-reveal').appendTo($form).slideDown(250, function () {

        $(this).removeClass('ajax-add-notice--pre-reveal');

      });

    }

  };

  $(document).on('submit', 'form.product-form[data-ajax-add="true"]', function (e) {

    var $form = $(this); // Force page reload if product added to cart from a section on the cart page

    if (document.body.classList.contains('template-cart')) {

      $form.attr('data-ajax-add', false);

      $form.submit();

      return;

    } // Disable add button

    $form.find(':submit').attr('disabled', 'disabled').each(function () {

      var contentFunc = $(this).is('button') ? 'html' : 'val';

      $(this).data('previous-value', $(this)[contentFunc]())[contentFunc](theme.strings.addingToCart);

    }); // Hide any notices

    $('.ajax-add-notice', $form).css('opacity', 0); // Add to cart

    $.post(theme.routes.cart_add_url + '.js', $form.serialize(), function (itemData) {

      // Enable add button

      var $btn = $form.find(':submit').each(function () {

        var $btn = $(this);

        var contentFunc = $(this).is('button') ? 'html' : 'val'; // Revert to normal

        $btn.removeAttr('disabled')[contentFunc]($btn.data('previous-value'));

      }).first(); // reload header

      $.get(theme.routes.search_url, function (data) {

        var selectors = ['.page-header .cart'];

        var $parsed = $($.parseHTML('<div>' + data + '</div>'));

        for (var i = 0; i < selectors.length; i++) {

          var cartSummarySelector = selectors[i];

          var $newCartObj = $parsed.find(cartSummarySelector).clone();

          var $currCart = $(cartSummarySelector);

          $currCart.replaceWith($newCartObj);

        }

        document.getElementById("header-cart").addEventListener("mouseover", addClassinbody);

        document.getElementById("header-cart").addEventListener("mouseout", removeClassinbody);

        function addClassinbody(){

          document.body.classList.add("is-header-hover");

          }

        function removeClassinbody(){

          document.body.classList.remove("is-header-hover");

        }

      }); // display added notice

      var $template = $(['<div class="ajax-add-notice ajax-add-notice--added global-border-radius">', '<div class="ajax-add-notice__inner">', '<div class="ajax-add-notice__item">', '<span class="feather-icon">', theme.icons.check, '</span>', theme.strings.addedToCart, '</div>', '<div class="ajax-add-notice__go">', '<a href="', theme.routes.cart_url, '">', theme.strings.goToCart, '<span class="feather-icon feather-icon--small">', theme.icons.chevronRight, '</span>', '</a>', '</div>', '</div>', '</div>'].join(''));

      theme.addNoticeToForm($template, $form);

    }, 'json').fail(function (data) {

      // Enable add button

      var $firstBtn = $form.find(':submit').removeAttr('disabled').each(function () {

        var $btn = $(this);

        var contentFunc = $btn.is('button') ? 'html' : 'val';

        $btn[contentFunc]($btn.data('previous-value'));

      }).first(); // Not added, show message

      if (typeof data != 'undefined' && typeof data.status != 'undefined') {

        var jsonRes = $.parseJSON(data.responseText);

        var $template = $(['<div class="ajax-add-notice ajax-add-notice--error global-border-radius">', '<div class="ajax-add-notice__inner">', jsonRes.description, '</div>', '</div>'].join(''));

        theme.addNoticeToForm($template, $form);

      } else {

        // Some unknown error? Disable ajax and submit the old-fashioned way.

        $form.attr('data-ajax-add', false);

        $form.submit();

      }

    });

    return false;

  });

  ;

  /* Product Media

   *

   * Load and destroy:

   * theme.ProductMedia.init(galleryContainer, {

   *   onModelViewerPlay: function(e){

   *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', false);

   *   },

   *   onModelViewerPause: function(e){

   *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', true);

   *   },

   *   onPlyrPlay: function(e){

   *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', false);

   *   },

   *   onPlyrPause: function(e){

   *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', true);

   *   },

   * });

   *

   * theme.ProductMedia.destroy(galleryContainer);

   *

   * Trigger mediaVisible and mediaHidden events based on UI

   * $slickSlideshow.on('afterChange', function(evt, slick, current){

   *   $('.product-media--activated').removeClass('product-media--activated').trigger('mediaHidden');

   *   $('.product-media', slick.$slides[current]).addClass('product-media--activated').trigger('mediaVisible');

   * });

   */

  theme.ProductMedia = new function () {

    var _ = this;

    _._setupShopifyXr = function () {

      if (!window.ShopifyXR) {

        document.addEventListener('shopify_xr_initialized', _._setupShopifyXr.bind(this));

        return;

      }

      document.removeEventListener('shopify_xr_initialized', _._setupShopifyXr);

      window.ShopifyXR.addModels(JSON.parse($(this).html()));

      window.ShopifyXR.setupXRElements();

    };

    this.init = function (container, settings) {

      var settings = settings || {},

          _container = container; /// First, set up events/callbacks

      // when any media appears

      $(container).on('mediaVisible', '.product-media--video-loaded, .product-media--model-loaded', function () {

        // autoplay all media on larger screens

        if ($(window).width() >= 768) {

          $(this).data('player').play();

        } // update view-in-space

        if ($(this).hasClass('product-media--model')) {

          $('.view-in-space', _container).attr('data-shopify-model3d-id', $(this).data('model-id'));

        }

      }); // when any media is hidden

      $(container).on('mediaHidden', '.product-media--video-loaded, .product-media--model-loaded', function () {

        // pause all media

        $(this).data('player').pause();

      }); // necessary callbacks

      if (settings.onVideoVisible) {

        $(container).on('mediaVisible', '.product-media--video-loaded', settings.onVideoVisible);

      }

      if (settings.onVideoHidden) {

        $(container).on('mediaHidden', '.product-media--video-loaded', settings.onVideoHidden);

      }

      $('model-viewer', container).each(function () {

        if (settings.onModelViewerPlay) {

          $(this).on('shopify_model_viewer_ui_toggle_play', settings.onModelViewerPlay);

        }

        if (settings.onModelViewerPause) {

          $(this).on('shopify_model_viewer_ui_toggle_pause', settings.onModelViewerPause);

        }

      }); /// Second, initialise media

      var $firstMedia = $(container).find('.product-media:first');

      var _autoplayOnceIfRequested = function _autoplayOnceIfRequested($currentMedia) {

        return $firstMedia[0] == $currentMedia[0] && settings.autoplayFirstMedia;

      }; // set up video media elements with a controller

      $(container).find('.product-media--video').each(function (index) {

        var enableLooping = $(this).data('enable-video-looping'),

            element = $(this).find('iframe, video')[0],

            $currentMedia = $(this);

        if (element.tagName === 'VIDEO') {

          // set up a controller for Plyr video

          window.Shopify.loadFeatures([{

            name: 'video-ui',

            version: '1.0',

            onLoad: function () {

              var playerObj = {

                playerType: 'html5',

                element: element

              };

              playerObj.play = function () {

                this.plyr.play();

              }.bind(playerObj);

              playerObj.pause = function () {

                this.plyr.pause();

              }.bind(playerObj);

              playerObj.destroy = function () {

                this.plyr.destroy();

              }.bind(playerObj);

              playerObj.plyr = new Shopify.Plyr(element, {

                controls: ['play', 'progress', 'mute', 'volume', 'play-large', 'fullscreen'],

                autoplay: _autoplayOnceIfRequested($currentMedia),

                loop: {

                  active: enableLooping

                },

                hideControlsOnPause: true,

                iconUrl: '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',

                tooltips: {

                  controls: false,

                  seek: true

                }

              });

              $(this).data('player', playerObj).addClass('product-media--video-loaded'); // callbacks for Plyr playback

              $(element).on('playing', function () {

                // pause other media

                $('.product-media').not($currentMedia).trigger('mediaHidden'); // prevent bubbling inputs that can be used by carousels

                $currentMedia.find('.plyr__controls').off('.themeMediaEventFix').on('keydown.themeMediaEventFix touchstart.themeMediaEventFix mousedown.themeMediaEventFix', function (e) {

                  e.stopPropagation();

                });

                if (typeof callbacks !== 'undefined' && callbacks.onPlyrPlay) {

                  callbacks.onPlyrPlay(playerObj);

                }

              });

              $(element).on('pause ended', function () {

                // remove event bubbling interceptor

                $currentMedia.find('.plyr__controls').off('.themeMediaEventFix');

                if (typeof callbacks !== 'undefined' && callbacks.onPlyrPause) {

                  callbacks.onPlyrPause(playerObj);

                }

              });

              if (settings.onPlyrInit) {

                settings.onPlyrInit(playerObj);

              }

            }.bind(this)

          }]);

          theme.loadStyleOnce('https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css');

        } else if (element.tagName === 'IFRAME') {

          if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(element.src)) {

            // set up a controller for YouTube video

            var existingYTCB = window.onYouTubeIframeAPIReady;

            var loadYoutubeVideo = function () {

              var playerObj = {

                playerType: 'youtube',

                element: element

              };

              var videoId = $(this).data('video-id');

              playerObj.player = new YT.Player(element, {

                videoId: videoId,

                playerVars: {

                  autoplay: _autoplayOnceIfRequested($currentMedia) ? 1 : 0,

                  origin: window.location.origin

                },

                events: {

                  onReady: function onReady(event) {

                    if (_autoplayOnceIfRequested($currentMedia)) {

                      event.target.playVideo();

                    }

                  },

                  onStateChange: function onStateChange(event) {

                    if (event.data === YT.PlayerState.ENDED && enableLooping) {

                      event.target.seekTo(0);

                    }

                  }

                }

              });

              playerObj.play = function () {

                try {

                  this.player.playVideo();

                } catch (ex) {}

              }.bind(playerObj);

              playerObj.pause = function () {

                try {

                  this.player.pauseVideo();

                } catch (ex) {}

              }.bind(playerObj);

              playerObj.destroy = function () {

                try {

                  // ytapi removes iframe, so restore manually

                  var frameHtml = $(this.element)[0].outerHTML,

                      $parent = $(this.element).parent();

                  this.player.destroy();

                  $parent.append(frameHtml);

                } catch (ex) {}

              }.bind(playerObj);

              $(this).data('player', playerObj).addClass('product-media--video-loaded');

              if (settings.onYouTubeInit) {

                settings.onYouTubeInit(playerObj);

              }

            }.bind(this);

            if (window.YT && window.YT.Player) {

              loadYoutubeVideo();

            } else {

              window.onYouTubeIframeAPIReady = function () {

                if (existingYTCB) {

                  existingYTCB();

                }

                loadYoutubeVideo();

              };

              theme.loadScriptOnce('https://www.youtube.com/iframe_api');

            }

          }

        }

      }); // set up a 3d model when it first appears

      $(container).on('mediaVisible mediaVisibleInitial', '.product-media--model:not(.product-media--model-loaded):not(.product-media--model-loading)', function (e) {

        var element = $(this).find('model-viewer')[0],

            autoplay = e.type != 'mediaVisibleInitial' || _autoplayOnceIfRequested($(this)); // do not run this twice

        $(this).addClass('product-media--model-loading'); // load viewer

        theme.loadStyleOnce('https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css');

        window.Shopify.loadFeatures([{

          name: 'model-viewer-ui',

          version: '1.0',

          onLoad: function () {

            $(this).data('player', new Shopify.ModelViewerUI(element)); // add mouseup event proxy to fix carousel swipe gestures

            $('<div class="theme-event-proxy">').on('mouseup', function (e) {

              e.stopPropagation();

              e.preventDefault();

              var newEventTarget = $(e.currentTarget).closest('.product-media')[0];

              newEventTarget.dispatchEvent(new MouseEvent('mouseup', {

                bubbles: true

              }));

            }).appendTo($(this).find('.shopify-model-viewer-ui__controls-overlay')); // when playing or loading, prevent bubbling of mouse/touch start

            $(this).find('model-viewer').on('shopify_model_viewer_ui_toggle_play', function () {

              $(this).closest('.product-media').on('touchstart.themeModelViewerFix mousedown.themeModelViewerFix', function (e) {

                e.stopPropagation();

              });

            }).on('shopify_model_viewer_ui_toggle_pause', function () {

              $(this).closest('.product-media').off('.themeModelViewerFix');

            }); // set class and re-trigger visible event now loaded

            $(this).addClass('product-media--model-loaded').removeClass('product-media--model-loading');

            if (settings.onModelViewerInit) {

              settings.onModelViewerInit(element);

            }

            if (autoplay) {

              $(this).trigger('mediaVisible');

            }

          }.bind(this)

        }]);

      }); // Third, load AR viewer

      if ($('.model-json', container).length) {

        window.Shopify.loadFeatures([{

          name: 'shopify-xr',

          version: '1.0',

          onLoad: _._setupShopifyXr.bind($('.model-json', container))

        }]); // pause video when a 3d model is launched in AR

        $(document).on('shopify_xr_launch', function () {

          $('.product-media--video-loaded').each(function () {

            $(this).data('player').pause();

          });

        });

      } // 3d model in first place - start in paused mode

      setTimeout(function () {

        $('.product-media:first', this).filter('.product-media--model').trigger('mediaVisibleInitial');

      }.bind(container), 50);

    };

    this.destroy = function (container) {

      $(document).off('shopify_xr_launch');

      $(container).off('mediaVisible mediaVisibleInitial mediaHidden');

      $('.product-media--video-loaded, .product-media--model-loaded', container).each(function () {

        $(this).data('player').destroy();

      }).removeClass('product-media--video-loaded product-media--model-loaded');

      $('.product-media--video video', container).off('playing pause ended');

      $('model-viewer', container).off('shopify_model_viewer_ui_toggle_play shopify_model_viewer_ui_toggle_pause');

      $('.product-media--model .theme-event-proxy').off('mouseup').remove();

    };

  }();

  /*================ Sections ================*/

  /**

   * Sidebar section Script

   * ------------------------------------------------------------------------------

   *

     * @namespace sidebar

   */

  theme.Sidebar = new function () {

    this.onSectionLoad = function (container) {

      this.$container = $(container);

      this.namespace = theme.namespaceFromSection(container); // check sidebar exists

      this.sidebarExists = !!$('.sidebar', container).length;

      $('.template-index').toggleClass('page-has-sidebar', this.sidebarExists);

    };

  }();

  ;

  /**

   * Product Template Script

   * ------------------------------------------------------------------------------

   * A file that contains scripts highly couple code to the Product template.

   *

     * @namespace product

   */

  theme.Product = new function () {

    var selectors = {

      addToCart: '[data-add-to-cart]',

      addToCartText: '[data-add-to-cart-text]',

      comparePrice: '[data-compare-price]',

      comparePriceText: '[data-compare-text]',

      originalSelectorId: '[data-product-select]',

      priceWrapper: '[data-price-wrapper]',

      productFeaturedMedia: '[data-product-featured-media]',

      productFeaturedMediaWithGallery: '[data-product-featured-media]:not(.product-image--no-gallery) .product-image__link, .product-thumbnails.slick-slider .product-image__link',

      productThumbnailForCarouselContainer: '.product-thumbnails--inline',

      productThumbnailImage: '.product-thumbnails__link, .carousel-media .product-image__link',

      productJson: '[data-product-json]',

      productPrice: '[data-product-price]',

      zoomValidThumbs: '.product-thumbnails--desktop .product-thumbnails__item-media-image [data-product-single-thumbnail]',

      singleOptionSelector: '[data-single-option-selector]',

      styledSelect: '.selector-wrapper select',

      skuWrapper: '.product-sku',

      sku: '.product-sku__value',

      unitPrice: '.unit-price',

      storeAvailability: '[data-store-availability-container]',

      inventoryNotice: '.product-inventory-notice',

      variantSelector: '.variant-selector'

    };

    this.onSectionLoad = function (container) {

      this.$container = $(container); /// Init store availability if applicable

      if ($(selectors.storeAvailability, container).length) {

        this.storeAvailability = new theme.StoreAvailability($(selectors.storeAvailability, container)[0]);

      } // Stop parsing if we don't have the product json script tag when loading

      // section in the Theme Editor

      if (!$(selectors.productJson, this.$container).html()) {

        return;

      }

      var sectionId = this.$container.attr('data-section-id');

      this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

      var options = {

        $container: this.$container,

        enableHistoryState: this.$container.data('enable-history-state') || false,

        singleOptionSelector: selectors.singleOptionSelector,

        originalSelectorId: selectors.originalSelectorId,

        product: this.productSingleObject

      };

      this.settings = {};

      this.namespace = '.product';

      this.variants = new slate.Variants(options);

      this.$featuredImage = $(selectors.productFeaturedMedia, this.$container);

      this.$zoomValidThumbs = $(selectors.zoomValidThumbs, this.$container);

      this.$container.on('variantChange' + this.namespace, this.functions.updateAddToCartState.bind(this));

      this.$container.on('variantPriceChange' + this.namespace, this.functions.updateProductPrices.bind(this));

      if (this.$container.find(selectors.skuWrapper)) {

        this.$container.on('variantChange' + this.namespace, this.functions.updateSKU.bind(this));

      }

      if (this.$container.find(selectors.inventoryNotice)) {

        this.$container.on('variantChange' + this.namespace, this.functions.updateInventoryNotice.bind(this));

      }

      if (this.$featuredImage.length > 0) {

        this.$container.on('variantImageChange' + this.namespace, this.functions.updateProductImage.bind(this));

      }

      this.$thumbnails = $(selectors.productThumbnailImage, container);

      if (this.$thumbnails.length > 0) {

        this.$container.on('click' + this.namespace + ' pseudoclick' + this.namespace, selectors.productThumbnailImage, this.functions.selectThumbnailImage.bind(this));

      } // image zoom

      this.$container.on('click' + this.namespace, selectors.productFeaturedMediaWithGallery, this.functions.openGallery.bind(this)); // image media

      theme.ProductMedia.init(this.$container); // style dropdowns

      theme.styleVariantSelectors($(selectors.styledSelect, container), options.product);

      if (this.variants.product.variants.length > 1) {

        // emit an event to broadcast the variant update

        $(window).trigger('cc-variant-updated', {

          variant: this.variants.currentVariant,

          product: this.productSingleObject

        });

      }

      if (this.$thumbnails.length > 0) {

        // mobile carousel

        this.$thumbnailForCarouselContainer = $(selectors.productThumbnailForCarouselContainer, container);

        this.functions.assessMobileCarousel.bind(this)();

        $(window).on('debouncedresize' + this.namespace, this.functions.assessMobileCarousel.bind(this)); // reveal thumbnails now - avoiding lazysizes + slick conflict

        this.$thumbnails.find('.lazyload--manual').removeClass('lazyload--manual').addClass('lazyload');

      } // note: adds event to window

      theme.initProductTitleAlignmentWatcher(this.$container, this.namespace);

    };

    this.functions = {

      /**

       * Switches thumbnails into a carousel on mobile

       */

      assessMobileCarousel: function assessMobileCarousel() {

        // test by checking if single image is visible

        if (!this.$featuredImage.is(':visible')) {

          if (!this.$thumbnailForCarouselContainer.hasClass('slick-slider')) {

            this.$thumbnailForCarouselContainer.addClass('slick-slider');

            theme.ProductMedia.destroy(this.$container); // destroy existing media

            this.$thumbnailForCarouselContainer.slick({

              autoplay: false,

              fade: false,

              infinite: false,

              useTransform: true,

              dots: true,

              arrows: true,

              prevArrow: theme.icons.slideshowPrevArrow,

              nextArrow: theme.icons.slideshowNextArrow,

              appendArrows: $('.slick-external-controls .slick-external-arrows', this.$container),

              appendDots: $('.slick-external-controls .slick-external-dots', this.$container),

              adaptiveHeight: true,

              initialSlide: $('.product-thumbnails__item--active', this.$thumbnailForCarouselContainer).index() || 0

            }); // create carousel media

            this.$thumbnailForCarouselContainer.find('.product-thumbnails__item').each(function () {

              $('<div class="carousel-media">').append($(this).find('.thumbnail-media-template').html()).prependTo(this);

            });

            theme.ProductMedia.init(this.$container, {

              onPlyrPlay: function onPlyrPlay(evt) {

                $(evt.target).closest('.product-media').find('.plyr__controls').off('.themeModelViewerFix').on('touchstart.themeModelViewerFix touchmove.themeModelViewerFix touchend.themeModelViewerFix mousedown.themeModelViewerFix mousemove.themeModelViewerFix mouseup.themeModelViewerFix', function (e) {

                  e.stopPropagation();

                });

              }

            });

            this.$thumbnailForCarouselContainer.find('.product-media').trigger('mediaVisibleInitial');

            this.$thumbnailForCarouselContainer.on('afterChange', function (evt, slick, current) {

              // notify media of visibility

              var $currentMedia = $('.product-media', slick.$slides[current]);

              $('.product-media').not($currentMedia).trigger('mediaHidden');

              $currentMedia.trigger('mediaVisible'); // fix tabbing

              theme.productGallerySlideshowTabFix(slick.$slides, current);

            });

          }

          var selectedVal = $("#SingleOptionSelector-0 option:selected").data('value');

          if(selectedVal){

            
            $('.product-thumbnails--inline .product-thumbnails__item').each(function(){
              if($(this).hasClass('selectedVal')){
                   this.$thumbnailForCarouselContainer.slick('slickUnfilter');
                   this.$thumbnailForCarouselContainer.slick('slickFilter', '.'+selectedVal);
              }
            });
          }        

         

        } else {

          if (this.$thumbnailForCarouselContainer.hasClass('slick-slider')) {

            // remove carousel media

            theme.ProductMedia.destroy(this.$container);

            this.$thumbnailForCarouselContainer.find('.carousel-media').remove();

            this.$thumbnailForCarouselContainer.slick('unslick').off('afterChange');

            this.$thumbnailForCarouselContainer.removeClass('slick-slider');

            theme.ProductMedia.init(this.$container); // init original large media

            this.$thumbnailForCarouselContainer.find('.product-media').trigger('mediaVisibleInitial');

          }

        }

      },

      /**

       * Updates the DOM state of the add to cart button

       *

       * @param {boolean} enabled - Decides whether cart is enabled or disabled

       * @param {string} text - Updates the text notification content of the cart

       */

      updateAddToCartState: function updateAddToCartState(evt) {

        var variant = evt.variant;
        if (variant) {

          $(selectors.priceWrapper, this.$container).removeClass('product-price--unavailable');

        } else {

          $(selectors.addToCart, this.$container).prop('disabled', true);

          $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);

          $(selectors.priceWrapper, this.$container).addClass('product-price--unavailable');

          return;

        }

        if (variant.available) {

          $(selectors.addToCart, this.$container).prop('disabled', false);

          $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);

        } else {

          $(selectors.addToCart, this.$container).prop('disabled', true);

          $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);

        } // backorder

        var $backorderContainer = $('.backorder', this.$container);

        if ($backorderContainer.length) {

          if (variant && variant.available) {

            var $option = $(selectors.originalSelectorId + ' option[value="' + variant.id + '"]', this.$container);

            if (variant.inventory_management && $option.data('stock') == 'out') {

              $backorderContainer.find('.backorder__variant').html(this.productSingleObject.title + (variant.title.indexOf('Default') >= 0 ? '' : ' - ' + variant.title));

              $backorderContainer.show();

            } else {

              $backorderContainer.hide();

            }

          } else {

            $backorderContainer.hide();

          }

        }

      },

      /**

       * Get the display unit for unit pricing

       */

      _getBaseUnit: function _getBaseUnit(variant) {

        return variant.unit_price_measurement.reference_value === 1 ? variant.unit_price_measurement.reference_unit : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;

      },

      /**

       * Updates the DOM with specified prices

       *

       * @param {string} productPrice - The current price of the product

       * @param {string} comparePrice - The original price of the product

       */

      updateProductPrices: function updateProductPrices(evt) {

        var variant = evt.variant;

        var $comparePrice = $(selectors.comparePrice, this.$container);
       
        var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
        
        var $price = $(selectors.productPrice, this.$container);

        var $unitPrice = $(selectors.unitPrice, this.$container);

        var RRP = variant.compare_at_price ;
        var minPrice = variant.price ;
        var youSave = parseInt(RRP) - parseInt(minPrice);
        var youSavePerc = Math.round(((RRP - minPrice) / RRP) * 100);
        $price.html('<span class="theme-money">' + theme.Shopify.formatMoney(variant.price, theme.moneyFormat) + '</span>');
        $('.save-price-sec').remove();
        if(RRP > minPrice ){
        $('<div class="save-price-sec"><span class="product-label">You Save:</span><div class="save-price-per">' + theme.Shopify.formatMoney(youSave, theme.moneyFormat) + ' ('+youSavePerc+'%)</div> </div>').insertAfter('.product-price');
        } else {
          $('.save-price-sec').remove();
        }
         var weight = variant.weight/453.59237;

        var final_weight = weight.toFixed(1);

        $('.variant-weight').html(final_weight+'lb');

        $('.variant-option-title').html(variant.option1);

        if (variant.compare_at_price > variant.price) {

          $comparePrice.html('<span class="theme-money">' + theme.Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat) + '</span>');

          $compareEls.removeClass('hide');

          $price.addClass('product-price__reduced');

        } else {

          $comparePrice.html('');

          $compareEls.addClass('hide');

          $price.removeClass('product-price__reduced');

        }

        if (variant.unit_price_measurement) {

          var $newUnitPriceArea = $('<div class="unit-price small-text">');

          $('<span class="unit-price__price theme-money">').html(theme.Shopify.formatMoney(variant.unit_price, theme.moneyFormat)).appendTo($newUnitPriceArea);

          $('<span class="unit-price__separator">').html(theme.strings.unitPriceSeparator).appendTo($newUnitPriceArea);

          $('<span class="unit-price__unit">').html(this.functions._getBaseUnit(variant)).appendTo($newUnitPriceArea);

          if ($unitPrice.length) {

            $unitPrice.replaceWith($newUnitPriceArea);

          } else {

            $(selectors.priceWrapper, this.$container).append($newUnitPriceArea);

          }

        } else {

          $unitPrice.remove();

        }

      },

      /**

       * Updates the SKU

       */

      updateSKU: function updateSKU(evt) {

        var variant = evt.variant;

        if(variant && variant.sku){

        if(metaData[variant.sku]){

          if(metaData[variant.sku][0] || metaData[variant.sku][1] || metaData[variant.sku][2]){

            var meta_dimension = metaData[variant.sku];

            $('.dimension-row').css('display','table-row');

            if(meta_dimension[1]){

              var width = ' x '+ meta_dimension[1];

            }

            if(meta_dimension[2]){

              var leng = ' x '+ meta_dimension[2];

            }

            var dimension = meta_dimension[0] + width + leng;

            $('.variant_dimension').html(dimension);

          }

          else if($('.product-metafield-dimension-value').html() != ''){

            $('.variant_dimension').html($('.product-metafield-dimension-value').html());

          }

          else{

            $('.variant_dimension').html('');

            $('.dimension-row').css('display','none');

          }

        }

        if(meta_bullet[variant.sku]){

          if(meta_bullet[variant.sku][0] || meta_bullet[variant.sku][1]  || meta_bullet[variant.sku][2] || meta_bullet[variant.sku][3] || meta_bullet[variant.sku][4] || meta_bullet[variant.sku][5]){

            var bullet_list = '<ul><li>'+meta_bullet[variant.sku][0] +'</li><li>'+meta_bullet[variant.sku][1] +'</li><li>'+meta_bullet[variant.sku][2] +'</li><li>'+meta_bullet[variant.sku][3] +'</li><li>'+meta_bullet[variant.sku][4] +'</li><li>'+meta_bullet[variant.sku][5] +'</li></ul>';

            $('.meta-bullet-points').html(bullet_list);

          }

        }

    }

        if (variant && variant.sku) {

          $(selectors.skuWrapper, this.$container).removeClass('product-sku--empty');

          $(selectors.sku, this.$container).html(variant.sku);

        } else {

          $(selectors.skuWrapper, this.$container).addClass('product-sku--empty');

          $(selectors.sku, this.$container).empty();

        }

      },

      _getVariantOptionElement: function _getVariantOptionElement(variant) {

        return $(selectors.variantSelector, this.$container).find('option[value="' + variant.id + '"]');

      },

      /**

       * Updates the Inventory Notice

       */

      updateInventoryNotice: function updateInventoryNotice(evt) {

        var variant = evt.variant;

        if (variant) {

          var inventoryData = this.functions._getVariantOptionElement(variant).data('inventory');

          if (inventoryData) {

            $(selectors.inventoryNotice, this.$container).removeClass('product-inventory-notice--no-inventory').html(theme.strings.inventoryNotice.replace('[[ quantity ]]', inventoryData));

          } else {

            $(selectors.inventoryNotice, this.$container).addClass('product-inventory-notice--no-inventory').empty();

          }

        } else {

          $(selectors.inventoryNotice, this.$container).addClass('product-inventory-notice--no-inventory').empty();

        }

      },

      /**

       * Display selected thumbnail

       */

      selectThumbnailImage: function selectThumbnailImage(evt) {

        var $thumbnailContainer = $(evt.currentTarget).parent();

        if (!$thumbnailContainer.hasClass('product-thumbnails__item--active')) {

          // if a carousel exists

          if (this.$thumbnailForCarouselContainer.hasClass('slick-slider')) {

            if ($thumbnailContainer.hasClass('carousel-media')) {// selected actual slide - do nothing

            } else {

              // hidden thumbnail, e.g. variant image change

              var mediaId = $thumbnailContainer.find('[data-thumbnail-media-id]').data('thumbnail-media-id');

              var slickIndex = this.$thumbnailForCarouselContainer.find('[data-thumbnail-media-id="' + mediaId + '"]').closest('.slick-slide').data('slick-index');

              this.$thumbnailForCarouselContainer.slick('slickGoTo', slickIndex);

              $thumbnailContainer.addClass('product-thumbnails__item--active').siblings('.product-thumbnails__item--active').removeClass('product-thumbnails__item--active');

            }

          } else {

            // with thumbnails

            theme.ProductMedia.destroy(this.$container);

            this.$featuredImage.html($(evt.currentTarget).find('.thumbnail-media-template').html()); // load media and play immediately

            theme.ProductMedia.init(this.$container, {

              autoplayFirstMedia: true

            });

            $thumbnailContainer.addClass('product-thumbnails__item--active').siblings('.product-thumbnails__item--active').removeClass('product-thumbnails__item--active');

          }

        }

        evt.preventDefault();

      },

      /**

       * Updates the DOM with the specified image URL

       */

      updateProductImage: function updateProductImage(evt) {

        var variant = evt.variant;

        var selected_color = variant.option1;

        var select_color = selected_color.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/-*$/, '');

        $('.product-thumbnails--desktop').slick('slickUnfilter');

        $('.product-thumbnails--desktop').slick('slickFilter','.'+select_color);   

        $('.product-thumbnails--desktop').slick('refresh');

        if (variant.featured_media) {

          this.$container.find('[data-thumbnail-media-id="' + variant.featured_media.id + '"]').trigger('pseudoclick');

        }

      },

      /**

       * Show gallery of all product images

       */

      openGallery: function openGallery(evt) {

        evt.preventDefault();

        var pswpElement = document.querySelectorAll('.pswp')[0];

        var items = [];

        if (this.$zoomValidThumbs.length) {

          var useSlideshowImg = !this.$zoomValidThumbs.is(':visible');

          this.$zoomValidThumbs.each(function () {

            var item = {

              src: $(this).attr('href'),

              w: $(this).data('image-w'),

              h: $(this).data('image-h')

            };

            var img;

            if (useSlideshowImg) {

              img = $('.product-image__link[href="' + $(this).attr('href') + '"]:visible img')[0];

            } else {

              img = $(this).find('img')[0];

            }

            if (img && typeof img.currentSrc !== 'undefined') {

              item.msrc = img.currentSrc;

            }

            items.push(item);

          });

        } else {

          var item = {

            src: this.$featuredImage.find('a').attr('href'),

            w: this.$featuredImage.data('image-w'),

            h: this.$featuredImage.data('image-h')

          };

          var img = this.$featuredImage.find('img')[0];

          if (typeof img.currentSrc !== 'undefined') {

            item.msrc = img.currentSrc;

          }

          items.push(item);

        }

        var index = 0;

        var $activeThumb = this.$container.find('.product-thumbnails__item--active .product-thumbnails__link');

        //var $activeThumb = this.$container.find('.product-thumbnails__item--active:not(.slick-slide):visible .product-thumbnails__link, .product-thumbnails__item-media-image.slick-current:visible .product-thumbnails__link');

        

        if ($activeThumb.length) {

          var activeHref = $activeThumb.attr('href');

          

          for (var i = 0; i < items.length; i++) {

            if (items[i].src == activeHref) {

              index = i;

              break;

            }

          }

        }

        var options = {

          index: index,

          history: false,

          captionEl: false,

          shareEl: false,

          fullscreenEl: false,

          getThumbBoundsFn: function (imageIndex) {

            var thumbnail = false;

            var hrefToFind = items[imageIndex].src; // first check - main image on desktop

            if (this.$featuredImage.find('.product-image__link:visible').attr('href') == hrefToFind) {

              thumbnail = this.$featuredImage.find('.product-image__link img')[0];

            } else {

              // second check - thumbnails & slideshow

              var $thumb = this.$container.find('.product-thumbnails__link, .product-image__link').filter(function () {

                return $(this).attr('href') == hrefToFind;

              }).filter(':visible');

              if ($thumb.length) {

                thumbnail = $thumb.find('img')[0];

              }

            } // backup to avoid js error

            if (!thumbnail) {

              thumbnail = this.$featuredImage.find('img')[0];

            }

            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop,

                rect = thumbnail.getBoundingClientRect();

            return {

              x: rect.left,

              y: rect.top + pageYScroll,

              w: rect.width

            };

          }.bind(this)

        }; // Initializes and opens PhotoSwipe

        this.imageGallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

        this.imageGallery.init();

        this.imageGallery.listen('destroy', function () {

          this.imageGallery = null;

        }.bind(this));

      }

    };

    this.onSectionUnload = function (container) {

      this.$container.off(this.namespace);

      $(window).off(this.namespace);

      if (this.imageGallery) {

        this.imageGallery.close();

      }

      if (this.$thumbnailForCarouselContainer) {

        this.$thumbnailForCarouselContainer.filter('.slick-slider').slick('unslick').off('afterChange');

      }

      if (this.storeAvailability) {

        this.storeAvailability.onSectionUnload();

      }

      theme.ProductMedia.destroy(this.$container);

    };

  }();

  ;

  /**

   * Header Script

   * ------------------------------------------------------------------------------

   *

   * @namespace Header

   */

  theme.Header = new function () {

    this.onSectionLoad = function (container) {

      this.$container = $(container);

      this.namespace = theme.namespaceFromSection(container);

      this.mobileMenuTransitionTime = 500;

      this.$searchBar = $('.search-bar', container);

      this.$newsletterSignupButton = $('.js-header-newsletter-open', this.$container);

      this.$searchInput = $('.search-form__input');

      /**

       * Making search bar un-tabbable on page load

       */

      $('.header-search-form', this.$container).find('a, button, input').attr('tabindex', '-1');

      /**

       * Toggle header search bar open

       */

      $('.js-header-search-trigger', this.$container).on('click' + this.namespace, function (e) {

        e.preventDefault();

        $('body').toggleClass('show-search');

        $('.header-search-form', this.$container).find('a, button, input').removeAttr('tabindex');

        $('.header-search-form .search-form__input', this.$container).focus();

      }.bind(this));

      /**

       * Fetch search results for entered text

       */

      $('.search-form__input[data-live-search="true"]', this.$container).on('change' + this.namespace + ' keyup' + this.namespace + ' paste' + this.namespace, function (e) {

        this.functions.fetchSearchResults.bind(this)(e);

      }.bind(this)); // mobile menu events

      $(this.$container).on('click' + this.namespace, '.js-mobile-menu-icon', this.functions.mobileMenuOpen.bind(this));

      $(this.$container).on('click' + this.namespace, '.js-close-mobile-menu', this.functions.mobileMenuClose.bind(this));

      this.$mobileDropdownContainer = $('.mobile-nav-column-inner', container);

      $(this.$container).on('click' + this.namespace, '.js-mobile-dropdown-trigger', this.functions.mobileMenuDropdownOpen.bind(this));

      $(this.$container).on('click' + this.namespace, '.js-mobile-dropdown-return', this.functions.mobileMenuDropdownClose.bind(this)); // open newsletter form on click

      if (this.$newsletterSignupButton.length > 0) {

        $(this.$container).on('click' + this.namespace, '.js-header-newsletter-open', function () {

          $.colorbox({

            transition: 'none',

            html: $('.header-newsletter-wrapper').html(),

            onOpen: theme.colorboxFadeTransOnOpen,

            onComplete: theme.colorboxFadeTransOnComplete

          });

        }); // show newsletter form if it contains messages

        if ($('.header-newsletter-wrapper .form-success, .header-newsletter-wrapper .errors').length) {

          $.colorbox({

            transition: 'fade',

            html: $('.header-newsletter-wrapper').html(),

            onOpen: theme.colorboxFadeTransOnOpen,

            onComplete: theme.colorboxFadeTransOnComplete

          });

        }

      } // aria labels

      $('.main-nav__has-dropdown > a, .main-nav__child-has-dropdown > a', this.$container).attr('aria-haspopup', 'true').attr('aria-expanded', 'false');

      this.$container.on('mouseenter' + this.namespace + ' mouseleave' + this.namespace, '.main-nav__has-dropdown, .main-nav__child-has-dropdown', function (evt) {

        if (evt.type == 'mouseenter') {

          $(this).children('[aria-expanded]').attr('aria-expanded', true);

          $(this).addClass('show-dropdown');

        } else {

          $(this).children('[aria-expanded]').attr('aria-expanded', false);

          $(this).removeClass('show-dropdown');

        }

      }); // keyboard navigation - parent links

      this.$container.on('keydown' + this.namespace, '.main-nav__has-dropdown > .main-nav__link', function (evt) {

        if (evt.which == 40) {

          // Down arrow

          evt.preventDefault();

          $(evt.target).trigger('mouseenter');

        }

        if (evt.which == 38 || evt.which == 27) {

          // Up arrow or esc key

          evt.preventDefault();

          $(evt.target).trigger('mouseleave');

        }

      }); // keyboard navigation - child links

      this.$container.on('keydown' + this.namespace, '.main-nav__child-has-dropdown > .main-nav__child-link', function (evt) {

        if (evt.which == 39 || evt.which == 40) {

          // Right arrow or down arrow

          evt.preventDefault();

          $(evt.target).trigger('mouseenter');

        }

        if (evt.which == 37 || evt.which == 38 || evt.which == 27) {

          // Left arrow, up arrow or esc key

          evt.preventDefault();

          $(evt.target).trigger('mouseleave');

        }

      }); // keyboard navigation - grandchild links

      this.$container.on('keydown' + this.namespace, '.main-nav__sub-child-link', function (evt) {

        if (evt.which == 27) {

          // Esc key

          evt.preventDefault();

          $(evt.target).trigger('mouseleave');

        }

      }); // touch events

      $(this.$container).on('touchstart' + this.namespace + ' touchend' + this.namespace + ' click' + this.namespace, '.main-nav__has-dropdown > .main-nav__link, .main-nav__child-has-dropdown > .main-nav__child-link', function (evt) {

        // unless showing mobile menu

        if (!$(this).next('.dropdown-chevron').is(':visible')) {

          if (evt.type == 'touchstart') {

            $(this).data('touchstartedAt', evt.timeStamp);

          } else if (evt.type == 'touchend') {

            // down & up in under a second - presume tap

            if (evt.timeStamp - $(this).data('touchstartedAt') < 1000) {

              $(this).data('touchOpenTriggeredAt', evt.timeStamp);

              if ($(this).parent().hasClass('show-dropdown')) {

                // trigger close

                $(this).trigger('mouseleave');

              } else {

                // trigger close on any open items

                $('.main-nav .show-dropdown').removeClass('show-dropdown').children('a').attr('aria-expanded', false); // trigger open

                $(this).trigger('mouseenter');

              } // prevent fake click

              return false;

            }

          } else if (evt.type == 'click') {

            // if touch open was triggered very recently, prevent click event

            if ($(this).data('touchOpenTriggeredAt') && evt.timeStamp - $(this).data('touchOpenTriggeredAt') < 1000) {

              return false;

            }

          }

        }

      }); // keep menus in viewport

      this.functions.assessMenuPositions.bind(this)();

      $(window).on('debouncedresize' + this.namespace, this.functions.assessMenuPositions.bind(this)); // localization

      $('.disclosure', this.$container).each(function () {

        $(this).data('disclosure', new theme.Disclosure($(this)));

      });

    };

    this.functions = {

      /**

      * Ensure dropdown menus do not go off the right-edge of the page

      */

      assessMenuPositions: function assessMenuPositions() {

        var windowWidth = $(window).width();

        $('.main-nav__dropdown', this.$container).each(function () {

          var thisWidth = $(this).outerWidth(); // this dropdown

          var gutter = 20;

          var marginLeft = parseInt($(this).css('margin-left')) || 0;

          var offEdgeAmount = windowWidth - gutter - ($(this).offset().left - marginLeft + thisWidth);

          $(this).css('margin-left', offEdgeAmount < 0 ? offEdgeAmount : ''); // child dropdown

          $(this).toggleClass('main-nav__dropdown--expand-left', $(this).offset().left + thisWidth * 2 > windowWidth);

        });

      },

      /**

      * Fetching search results

      */

      fetchSearchResults: function fetchSearchResults(e) {

        var $input = $(e.target);

        var terms = $input.val();

        var includeMeta = false;

        if (this.$searchInput.data('live-search-meta')) {

          includeMeta = true;

        } // only do something if search terms have changed

        if (terms != $input.data('previous-terms')) {

          $input.data('previous-terms', terms); // is it a valid search term

          if (terms.length > 0) {

            // abort first, let callbacks run

            if (this.searchXhr) {

              this.searchXhr.abort();

            } // add class to show results, in case it's closed. Also hide existing items.

            this.$searchBar.addClass('search-bar--show-results search-bar--loading').removeClass('search-bar--has-results'); // build search url

            var $form = $input.closest('form');

            var searchUrl = $form.attr('action') + ($form.attr('action').indexOf('?') > -1 ? '&' : '?') + $form.serialize(); // build request for api or fallback

            var ajaxUrl, ajaxData;

            if (theme.shopifyFeatures.predictiveSearch) {

              // use the API

              ajaxUrl = theme.routes.search_url + '/suggest.json';

              ajaxData = {

                "q": $form.find('input[name="q"]').val(),

                "resources": {

                  "type": $form.find('input[name="type"]').val(),

                  "limit": 12,

                  "options": {

                    "unavailable_products": 'last',

                    "fields": includeMeta ? "title,product_type,variants.title,vendor,tag,variants.sku" : "title,product_type,variants.title,vendor"

                  }

                }

              };

            } else {

              // use the theme template fallback

              ajaxUrl = $form.attr('action') + '?' + $form.serialize() + '&view=data';

              ajaxData = null;

            } // fetch search results

            this.searchXhr = $.ajax({

              url: ajaxUrl,

              data: ajaxData,

              dataType: "json",

              success: this.functions.buildSearchResults.bind(this, searchUrl)

            }).always(function () {

              this.searchXhr = null;

              this.$searchBar.removeClass('search-bar--loading');

            }.bind(this));

          } else {

            if (this.searchXhr) {

              this.searchXhr.abort();

            }

            this.$searchBar.removeClass('search-bar--loading search-bar--has-results');

          }

        }

      },

      /**

      * Build search results from response

      */

      buildSearchResults: function buildSearchResults(searchUrl, response) {

        this.$searchBar.addClass('search-bar--has-results');

        var $resultsContainer = $('.search-bar__results-list', this.$searchBar).empty();

        if (response.resources.results.products && response.resources.results.products.length > 0 || response.resources.results.pages && response.resources.results.pages.length > 0 || response.resources.results.articles && response.resources.results.articles.length > 0) {

          var $productResults = $('<div class="search-bar__results-products">');

          var $pageResults = $('<div class="search-bar__results-pages">');

          if (response.resources.results.products) {

            for (var i = 0; i < response.resources.results.products.length; i++) {

              var result = response.resources.results.products[i];

              var $item = $('<a class="mini-product">').attr('href', result.url);

              var $imgCont = $('<div class="mini-product__image-container">').appendTo($item);

              if (result.image) {

                $('<img class="mini-product__image" alt="" role="presentation"/>').attr('src', slate.Image.getSizedImageUrl(result.image, '100x100_crop_center')).appendTo($imgCont);

              }

              var $details = $('<div class="mini-product__details">').appendTo($item);

              $('<div class="mini-product__title">').html(result.title).appendTo($details);

              if (this.$searchInput.data('live-search-vendor')) {

                $('<div class="mini-product__vendor small-text">').html(result.vendor).appendTo($details);

              }

              if (this.$searchInput.data('live-search-price')) {

                var $price = $('<div class="mini-product__price">').html(theme.Shopify.formatMoney(result.price_min, theme.moneyFormat)).appendTo($details);

                if (parseFloat(result.compare_at_price_min) > parseFloat(result.price_min)) {

                  $price.addClass('mini-product__price--on-sale');

                }

              }

              $item.appendTo($productResults);

            }

          }

          if (response.resources.results.pages) {

            for (var i = 0; i < response.resources.results.pages.length; i++) {

              var result = response.resources.results.pages[i];

              $('<a class="search-bar__results-pages__link">').attr('href', result.url).html(result.title).appendTo($pageResults);

            }

          }

          if (response.resources.results.articles) {

            for (var i = 0; i < response.resources.results.articles.length; i++) {

              var result = response.resources.results.articles[i];

              $('<a class="search-bar__results-pages__link">').attr('href', result.url).html(result.title).appendTo($pageResults);

            }

          }

          $resultsContainer.append($productResults);

          if ($pageResults.children().length) {

            $('<h6 class="search-bar__results-pages-title small-cap-heading">').html(theme.strings.searchResultsPages).prependTo($pageResults);

            $resultsContainer.append($pageResults);

          }

          $('<a class="search-bar__results-all-link">').html(theme.strings.searchResultsViewAll).attr('href', searchUrl).appendTo($resultsContainer);

        } else {

          $('<div>').html(theme.strings.searchResultsNoResults).appendTo($resultsContainer);

        }

      },

      /**

       * Event for showing the mobile navigation

       */

      mobileMenuOpen: function mobileMenuOpen(evt) {

        evt.preventDefault();

        $(document.body).addClass('mobile-menu-prime');

        setTimeout(function () {

          $(document.body).addClass('mobile-menu-open');

        }, 10);

      },

      /**

       * Event for closing the mobile navigation

       */

      mobileMenuClose: function mobileMenuClose(evt) {

        evt.preventDefault();

        $(document.body).removeClass('mobile-menu-open');

        setTimeout(function () {

          $(document.body).removeClass('mobile-menu-prime');

        }, 500);

      },

      /**

       * Event for opening a mobile dropdown menu

       */

      mobileMenuDropdownOpen: function mobileMenuDropdownOpen(evt) {

        evt.preventDefault();

        var $dropdownToShow = $(evt.currentTarget).siblings('.main-nav__dropdown');

        if ($dropdownToShow.length) {

          // show level 2 dropdown

          var $newDropdown = $dropdownToShow.clone().wrap('<div class="mobile-nav-menu-container mobile-dropdown mobile-menu-level-2">').parent(); // add return link

          $('<a class="mobile-dropdown__back js-mobile-dropdown-return" href="#">').html(['<span class="feather-icon">', theme.icons.arrowLeft, '</span><span class="mobile-dropdown__back-text">', $(evt.currentTarget).siblings('.main-nav__link').html(), '</span>'].join('')).prependTo($newDropdown);

          this.$mobileDropdownContainer.append($newDropdown);

          setTimeout(function () {
            this.$mobileDropdownContainer.addClass('show-mobile-menu-level-2 show-mobile-menu-level-3');
          }.bind(this), 10);

        } else {

          $dropdownToShow = $(evt.currentTarget).siblings('.main-nav__sub-dropdown');

          if ($dropdownToShow.length) {

            // show level 3 dropdown

            var $newDropdown = $dropdownToShow.clone().wrap('<div class="mobile-nav-menu-container mobile-dropdown mobile-menu-level-3">').parent(); // add return link

            $('<a class="mobile-dropdown__back js-mobile-dropdown-return" href="#">').html(['<span class="feather-icon">', theme.icons.arrowLeft, '</span><span class="mobile-dropdown__back-text">', $(evt.currentTarget).siblings('.main-nav__child-link').html(), '</span>'].join('')).prependTo($newDropdown);

            this.$mobileDropdownContainer.append($newDropdown);

            setTimeout(function () {
              this.$mobileDropdownContainer.addClass('show-mobile-menu-level-2 show-mobile-menu-level-3');
            }.bind(this), 10);

          }

        }

      },

      /**

       * Event for closing a mobile dropdown menu

       */

      mobileMenuDropdownClose: function mobileMenuDropdownClose(evt) {

        evt.preventDefault();
      if(this.$mobileDropdownContainer.hasClass('show-mobile-menu-level-3') &&
      this.$mobileDropdownContainer.hasClass('show-mobile-menu-level-2')) {
        this.$mobileDropdownContainer.removeClass('show-mobile-menu-level-3'); // remove menu element after transition time
        var $toRemove = this.$mobileDropdownContainer.find('.mobile-menu-level-3');
          setTimeout(function () {
            $toRemove.remove();
          }, this.mobileMenuTransitionTime);
          this.$mobileDropdownContainer.removeClass('show-mobile-menu-level-2'); // remove menu element after transition time
          var $toRemove = this.$mobileDropdownContainer.find('.mobile-menu-level-2');
          setTimeout(function () {
            $toRemove.remove();
          }, this.mobileMenuTransitionTime);

       } else if (this.$mobileDropdownContainer.hasClass('show-mobile-menu-level-3')) {
          // transition out level 3 dropdown

          this.$mobileDropdownContainer.removeClass('show-mobile-menu-level-3'); // remove menu element after transition time

          var $toRemove = this.$mobileDropdownContainer.find('.mobile-menu-level-3');

          setTimeout(function () {

            $toRemove.remove();

          }, this.mobileMenuTransitionTime);

        } else if (this.$mobileDropdownContainer.hasClass('show-mobile-menu-level-2')) {

          // transition out level 2 dropdown

          this.$mobileDropdownContainer.removeClass('show-mobile-menu-level-2'); // remove menu element after transition time

          var $toRemove = this.$mobileDropdownContainer.find('.mobile-menu-level-2');

          setTimeout(function () {

            $toRemove.remove();

          }, this.mobileMenuTransitionTime);

        }

      }

    };

    this.onSectionUnload = function () {

      this.$container.off(this.namespace);

      $('.js-header-search-trigger', this.$container).off(this.namespace);

      $('.search-form__input', this.$container).off(this.namespace);

      $(document).off(this.namespace);

      $(window).off(this.namespace);

      this.$searchBar.off(this.namespace);

      $('.disclosure', this.$container).each(function () {

        $(this).data('disclosure').unload();

      });

    };

  }();

  ;

  /**

   * Footer Script

   * ------------------------------------------------------------------------------

   *

   * @namespace Footer

   */

  theme.Footer = new function () {

    this.onSectionLoad = function (container) {

      this.$container = $(container);

      this.namespace = theme.namespaceFromSection(container); // localization

      $('.disclosure', this.$container).each(function () {

        $(this).data('disclosure', new theme.Disclosure($(this)));

      });

    };

    this.onSectionUnload = function () {

      $('.disclosure', this.$container).each(function () {

        $(this).data('disclosure').unload();

      });

    };

  }();

  ;

  /**

   * Banner Section Script

   * ------------------------------------------------------------------------------

   *

   * @namespace Banner

   */

  theme.Banner = new function () {

    this.onSectionLoad = function (container) {

      this.$container = $(container);

      this.namespace = theme.namespaceFromSection(container);

      this.$slideshow = $('.slideshow', this.$container);

      this.stackBreakpoint = 840; // Initialise slideshow

      this.$slideshow.on('init', function () {

        $('.lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');

      }).slick({

        autoplay: this.$slideshow.data('autoplay'),

        fade: this.$slideshow.data('transition') != 'slide',

        speed: this.$slideshow.data('transition') == 'instant' ? 0 : 500,

        autoplaySpeed: this.$slideshow.data('autoplay-speed') * 1000,

        infinite: true,

        useTransform: true,

        arrows: false,

        dots: this.$slideshow.find('.slide').length > 1,

        pauseOnHover: this.$slideshow.data('transition') != 'instant' || this.$slideshow.data('autoplay-speed') > 2 // no pause when quick & instant // no pause when quick & instant

      }); // Slideshow

      this.$companionContent = $('.banner-section__companion-column .overlay__inner', this.$container);

      if (this.$companionContent.children().length > 1) {

        this.functions.assessCompanionCarousel.bind(this)();

        $(window).on('debouncedresize' + this.namespace, this.functions.assessCompanionCarousel.bind(this));

      }

    };

    this.functions = {

      /**

      * Enable/disable carousel on companion content based on screen size

      */

      assessCompanionCarousel: function assessCompanionCarousel() {

        if ($(window).width() < this.stackBreakpoint) {

          if (!this.$companionContent.hasClass('slick-slider')) {

            this.$companionContent.addClass('slick-slider').children().addClass('slide');

            this.$companionContent.parent().addClass('overlay--with-slider');

            this.$companionContent.slick({

              autoplay: true,

              fade: false,

              infinite: true,

              useTransform: true,

              arrows: false,

              dots: false,

              autoplaySpeed: 7000 // 7 seconds between slides

            });

          }

        } else {

          if (this.$companionContent.hasClass('slick-slider')) {

            this.$companionContent.slick('unslick');

            this.$companionContent.parent().removeClass('overlay--with-slider');

            this.$companionContent.removeClass('slick-slider').children().removeClass('slide');

          }

        }

      }

    };

    this.onBlockSelect = function (block) {

      $(block).closest('.slick-slider').slick('slickGoTo', $(block).data('slick-index')).slick('slickPause');

    };

    this.onBlockDeselect = function (block) {

      $(block).closest('.slick-slider').slick('slickPlay');

    };

    this.onSectionUnload = function () {

      this.$slideshow.slick('unslick').off('init');

      if (this.$companionContent.hasClass('slick-slider')) {

        this.$companionContent.slick('unslick');

      }

      $(window).off(this.namespace);

    };

  }();

  ;

  /**

   * Featured Collection Section Script

   * ------------------------------------------------------------------------------

   *

   * @namespace FeaturedCollection

   */

  theme.FeaturedCollection = new function () {

    this.onSectionLoad = function (container) {

      this.$container = $(container);

      this.namespace = theme.namespaceFromSection(container);

      this.$carousel = $('[data-grid-carousel]', this.$container);

      if (this.$carousel.length) {

        // switch to swiper classes

        this.$carousel.addClass('swiper-container').children('.grid').addClass('swiper-wrapper').removeClass('grid').children().addClass('swiper-slide').removeClass('grid__item'); // init swiper

        this.carouselSwiper = new Swiper(this.$carousel, {

          init: false,

          //loop: true,

          //loopedSlides: 6,

          freeMode: false,

          slidesPerView: this.$carousel.data('grid-carousel-columns'),

          autoHeight: false,

          grabCursor: true,

          effect: 'slide',

          centeredSlides: false,

          spaceBetween: 14,

          navigation: {

            nextEl: $('.carousel-next', this.$container),

            prevEl: $('.carousel-prev', this.$container)

          },

          pagination: {

            el: '.swiper-pagination',

            },

          autoplay: false,

          breakpoints: {

            768: {

              slidesPerView: 2

            },

            560: {

              spaceBetween: 12,

              freeMode: true,

              slidesPerView: 2

            }

          }

        });

        this.carouselSwiper.once('init', function (evt) {

          this.$el.find('.swiper-slide-duplicate .lazyloading').addClass('lazyload');

        });

        this.carouselSwiper.init();

      } // note: adds event to window

      theme.initProductTitleAlignmentWatcher(this.$container, this.namespace);

    };

    this.onSectionUnload = function () {

      $(window).off(this.namespace);

      if (this.$carousel.length) {

        this.carouselSwiper.destroy();

      }

    };

  }();

  ;

  /**

   * MiniCollectionList Section Script

   * ------------------------------------------------------------------------------

   *

   * @namespace MiniCollectionList

   */

  theme.MiniCollectionList = new function () {

    this.onSectionLoad = function (container) {

      this.$container = $(container);

      this.namespace = theme.namespaceFromSection(container);

      this.$slideshow = $('.swiper-container', this.$container);

      /**

       * Swiper slideshow

       */

      var slidesperView = 4;

      if ($('.sidebar').length) {

        slidesperView = 3;

      }

      var count = this.$slideshow.find('.swiper-slide', this.$container).length;

      if (count > 0) {

        this.mySwiper = new Swiper(this.$slideshow, {

          //loop: true,

          //loopedSlides: count,

          freeMode: true,

          slidesPerView: slidesperView,

          grabCursor: true,

          spaceBetween: 14,

          navigation: {

            nextEl: "[data-section-id=\"".concat(this.$container.attr('data-section-id'), "\"] .mini-collection-slider-next"),

            prevEl: "[data-section-id=\"".concat(this.$container.attr('data-section-id'), "\"] .mini-collection-slider-prev")

          },

          breakpoints: {

            1090: {

              slidesPerView: slidesperView - 1

            },

            720: {

              slidesPerView: slidesperView - 2

            },

            520: {

              slidesPerView: 1,

              spaceBetween: 12

            }

          }

        });

      }

    };

    this.onBlockSelect = function (block) {

      if (this.mySwiper) {

        this.mySwiper.slideTo($(block).index(), 1000);

      }

    };

    this.onSectionUnload = function () {

      if (this.mySwiper) {

        this.mySwiper.destroy();

      }

    };

  }();

  ;

  /**

     * SlideUpFeatured Section Script

     * ------------------------------------------------------------------------------

     *

     * @namespace SlideUpFeatured

     */

   theme.SlideUpFeatured = new function () {

    this.onSectionLoad = function (container) {

      this.$container = $(container);

      this.namespace = theme.namespaceFromSection(container);

      this.$slideshow = $('.swiper-container', this.$container);

      /**

       * Swiper slideshow

       */

      var slidesperView = 4;

      if ($('.sidebar').length) {

        slidesperView = 3;

      }

      var count = this.$slideshow.find('.swiper-slide', this.$container).length;

      if (count > 0) {

        this.mySwiper = new Swiper(this.$slideshow, {

          //loop: true,

          //loopedSlides: count,

          freeMode: true,

          slidesPerView: slidesperView,

          grabCursor: true,

          spaceBetween: 14,

          navigation: {

            nextEl: "[data-section-id=\"".concat(this.$container.attr('data-section-id'), "\"] .mini-collection-slider-next"),

            prevEl: "[data-section-id=\"".concat(this.$container.attr('data-section-id'), "\"] .mini-collection-slider-prev")

          },

          breakpoints: {

            1090: {

              slidesPerView: slidesperView - 1

            },

            720: {

              slidesPerView: slidesperView - 2

            },

            520: {

              slidesPerView: 1,

              spaceBetween: 12

            }

          }

        });

      }

    };

    this.onBlockSelect = function (block) {

      if (this.mySwiper) {

        this.mySwiper.slideTo($(block).index(), 1000);

      }

    };

    this.onSectionUnload = function () {

      if (this.mySwiper) {

        this.mySwiper.destroy();

      }

    };

  }();

  ;

/**

     * announcement Section Script

     * ------------------------------------------------------------------------------

     *

     * @namespace AnnouncementList

     */

 theme.AnnouncementList = new function () {

  this.onSectionLoad = function (container) {

    this.$container = $(container);

    this.namespace = theme.namespaceFromSection(container);

    this.$slideshow = $('.swiper-container', this.$container);

    /**

     * Swiper slideshow

     */

    var slidesperView = 1;

    if ($('.sidebar').length) {

      slidesperView = 1;

    }

    var count = this.$slideshow.find('.swiper-slide', this.$container).length;

    if (count > 0) {

      this.mySwiper = new Swiper(this.$slideshow, {

        loop: true,

        //loopedSlides: count,

        freeMode: true,

        slidesPerView: slidesperView,

        grabCursor: false,

        spaceBetween: 14,

        navigation: {

          nextEl: "[data-section-id=\"".concat(this.$container.attr('data-section-id'), "\"] .logo-list-slider-next"),

          prevEl: "[data-section-id=\"".concat(this.$container.attr('data-section-id'), "\"] .logo-list-slider-prev")

        }

      });

    }

  };

  this.onBlockSelect = function (block) {

    if (this.mySwiper) {

      this.mySwiper.slideTo($(block).index(), 1000);

    }

  };

  this.onSectionUnload = function () {

    if (this.mySwiper) {

      this.mySwiper.destroy();

    }

  };

}();

;

/** */

theme.BrandContainer = new function () {

 

  this.onSectionLoad = function (container) {

   

    this.$container = $(container);

    this.namespace = theme.namespaceFromSection(container);

    this.$brandpop = $('.allbrand-page-content', this.$container);

  this.$brandpop.click(function(e) {

   this.$brandpoptext = $('.popup', e.currentTarget.parentNode);

   $.colorbox({

    transition: 'none',

    html:  this.$brandpoptext.html(),

    onOpen: theme.colorboxFadeTransOnOpen,

    onComplete: theme.colorboxFadeTransOnComplete,

    width: '100%',

    height: '100%',

    maxWidth: '750px',

    maxHeight: '600px',

  });

});

  }

}();

  /**

   * LogoList Section Script

   * ------------------------------------------------------------------------------

   *

   * @namespace LogoList

   */

  theme.LogoList = new function () {

    this.onSectionLoad = function (container) {

      this.$container = $(container);

      this.namespace = theme.namespaceFromSection(container);

      this.$slideshow = $('.swiper-container', this.$container);

      /**

       * Swiper slideshow

       */

      var firstBreakPoint = 768;

      if ($('body').hasClass('page-has-sidebar')) {

        firstBreakPoint = 1000;

      }

      var slidesPerView = this.$slideshow.data('items-per-row');

      var slideCount = this.$slideshow.find('.swiper-slide').length;

      if (slideCount > 0) {

        var _breakpoints;

        this.mySwiper = new Swiper(this.$slideshow, {

          freeMode: true,

          slidesPerView: this.$slideshow.data('items-per-row'),

          grabCursor: true,

          spaceBetween: 14,

          navigation: {

            nextEl: "[data-section-id=\"".concat(this.$container.attr('data-section-id'), "\"] .logo-list-slider-next"),

            prevEl: "[data-section-id=\"".concat(this.$container.attr('data-section-id'), "\"] .logo-list-slider-prev")

          },

          breakpoints: (_breakpoints = {}, _defineProperty(_breakpoints, firstBreakPoint, {

            slidesPerView: 3

          }), _defineProperty(_breakpoints, 560, {

            slidesPerView: 3,

            spaceBetween: 12

          }), _breakpoints)

        });

      }

    };

    this.onBlockSelect = function (block) {

      if (this.mySwiper) {

        this.mySwiper.slideTo($(block).index(), 1000);

      }

    };

    this.onSectionUnload = function () {

      if (this.mySwiper) {

        this.mySwiper.destroy();

      }

    };

  }();

  ;

  

  /**

   * BackgroundVideo Script

   * ------------------------------------------------------------------------------

   *

   * @namespace BackgroundVideo

   */

  theme.BackgroundVideo = new function () {

    this.onSectionLoad = function (container) {

      theme.VideoManager.onSectionLoad(container);

    };

    this.onSectionUnload = function () {

      theme.VideoManager.onSectionUnload(container);

    };

  }();

  ;

  theme.Gallery = new function () {

    this.onSectionLoad = function (container) {

      this.$container = $(container);

      this.namespace = theme.namespaceFromSection(container);

      this.$carouselGallery = $('.gallery--mobile-carousel', container);

      if (this.$carouselGallery.length) {

        var assessCarouselFunction = function assessCarouselFunction() {

          var isCarousel = !!this.carouselSwiper,

              shouldShowCarousel = this.$carouselGallery.css('display') === 'flex';

          if (!shouldShowCarousel) {

            $('.lazyload--manual', this.$carouselGallery).removeClass('lazyload--manual').addClass('lazyload');

          }

          if (isCarousel && !shouldShowCarousel) {

            // Destroy carousel

            // - unload swiper

            this.carouselSwiper.destroy();

            this.carouselSwiper = null; // - de-structure swiper

            this.$carouselGallery.removeClass('swiper-container').find('.swiper-slide').removeClass('swiper-slide').addClass('gallery__item').appendTo(this.$carouselGallery);

            this.$carouselGallery.find('.swiper-wrapper').remove(); // - re-row items

            var rowLimit = 3;

            var $currentRow = null;

            this.$carouselGallery.find('.gallery__item').each(function (index, item) {

              if (index % rowLimit === 0) {

                $currentRow = $('<div class="gallery__row">').addClass(Math.floor(index / 3) % 2 === 0 ? 'gallery__row--odd' : 'gallery__row--even').appendTo(this.$carouselGallery);

              }

              $(item).appendTo($currentRow);

            }.bind(this));

          } else if (!isCarousel && shouldShowCarousel) {

            // Create carousel

            // - de-row items

            this.$carouselGallery.find('.gallery__item').appendTo(this.$carouselGallery);

            this.$carouselGallery.find('.gallery__row').remove(); // - convert to swiper structure

            this.$carouselGallery.addClass('swiper-container');

            var $swiperWrapper = $('<div class="swiper-wrapper">').appendTo(this.$carouselGallery);

            this.$carouselGallery.find('.gallery__item').removeClass('gallery__item').addClass('swiper-slide').appendTo($swiperWrapper); // - init carousel

            this.carouselSwiper = new Swiper(this.$carouselGallery, {

              init: false,

              //loop: true,

              //loopedSlides: 6,

              freeMode: false,

              slidesPerView: 1,

              autoHeight: false,

              grabCursor: true,

              effect: 'slide',

              centeredSlides: false,

              spaceBetween: 14,

              // navigation: {

              //   nextEl: $('.carousel-next', this.$container),

              //   prevEl: $('.carousel-prev', this.$container),

              // },

              autoplay: false

            });

            this.carouselSwiper.once('init', function (evt) {

              this.$el.find('.swiper-slide-duplicate .lazyloading').addClass('lazyload');

            });

            this.carouselSwiper.init();

          }

        };

        assessCarouselFunction.call(this);

        $(window).on('debouncedresize' + this.namespace, assessCarouselFunction.bind(this));

      }

    };

    this.onSectionUnload = function (container) {

      $(window).off(this.namespace);

      if (this.carouselSwiper) {

        this.carouselSwiper.destroy();

      }

    };

    this.onBlockSelect = function (block) {};

    this.onBlockDeselect = function (block) {};

  }();

  /**

   * Collection Script

   * ------------------------------------------------------------------------------

   * For collection pages

   *

   * @namespace collection

   */

  theme.Collection = new function () {

    this.onSectionLoad = function (container) {

      theme.initProductTitleAlignmentWatcher($(container), '.collectionTemplate');

    };

    this.onSectionUnload = function () {};

  }();

  ;

  /**

   * Cart Template Script

   * ------------------------------------------------------------------------------

   * For the cart page

   *

   * @namespace main-cart

   */

  theme.Cart = new function () {

    var selectors = {

      termsCheckbox: '#terms'

    };

    this.onSectionLoad = function (container) {

      this.$container = $(container);

      this.namespace = '.cartTemplate'; // show/hide shipping estimates

      this.$container.on('click' + this.namespace, '.js-shipping-calculator-trigger', function () {

        var $this = $(this);

        var $parent = $this.parents('.shipping-calculator-container');

        $parent.toggleClass('calculator-open');

        if ($parent.hasClass('calculator-open')) {

          $this.children().html(theme.strings.cart_shipping_calculator_hide_calculator);

          $parent.children('.shipping-calculator').slideDown(250);

        } else {

          $this.children().html(theme.strings.cart_shipping_calculator_title);

          $parent.children('.shipping-calculator').slideUp(250);

        }

      }); // show/hide the cart notes

      this.$container.on('click' + this.namespace, '.js-cart-notes-trigger', function () {

        var $this = $(this);

        var $parent = $this.parent('.cart-notes-container');

        $parent.toggleClass('notes-open');

        if ($parent.hasClass('notes-open')) {

          $this.children().html(theme.strings.cart_general_hide_note);

          $parent.children('.cart-notes').slideDown(250);

        } else {

          $this.children().html(theme.strings.cart_general_show_note);

          $parent.children('.cart-notes').slideUp(250);

        }

      }); // terms and conditions checkbox

      if ($(selectors.termsCheckbox, container).length > 0) {

        $(document).on('click' + this.namespace, '[name="checkout"], a[href="/checkout"]', function () {

          if ($(selectors.termsCheckbox + ':checked').length == 0) {

            alert(theme.strings.cartTermsNotChecked);

            return false;

          }

        });

      } // quantity adjustment

      if (this.$container.data('ajax-update')) {

        var updateCartFunction = this.functions.updateCart.bind(this);

        this.$container.on('keyup' + this.namespace + ' change' + this.namespace, '.quantity-adjuster__input', function () {

          if ($(this).data('initial-value') && $(this).data('initial-value') == $(this).val()) {

            return;

          }

          if ($(this).val().length == 0 || $(this).val() == '0') {

            return;

          }

          var inputId = $(this).attr('id');

          updateCartFunction({

            line: $(this).data('line'),

            quantity: $(this).val()

          }, function () {

            // set focus inside input that changed

            console.log('Focussing on: ' + '#' + inputId);

            $('#' + inputId).focus();

          });

          $(this).data('previousValue', $(this).val());

        });

        this.$container.on('click' + this.namespace, '.quantity-adjuster__button--down, .quantity-adjuster__button--up', function (e) {

          var $input = $(this).closest('.quantity-adjuster').find('.quantity-adjuster__input');

          if ($(this).hasClass('quantity-adjuster__button--down')) {

            $input.val(parseInt($input.val()) - 1).trigger('change');

          } else {

            $input.val(parseInt($input.val()) + 1).trigger('change');

          }

          return false;

        });

      }

      theme.cartNoteMonitor.load($('.cart-notes [name="note"]', this.$container)); // note: adds event to window

      theme.initProductTitleAlignmentWatcher(this.$container, this.namespace);

    };

    this.functions = {

      /**

       * Function for changing the cart and updating the page

       */

      updateCart: function updateCart(params, successCallback) {

        var _ = this;

        if (_.cartXhr) {

          _.cartXhr.abort();

        }

        if (_.cartRefreshXhr) {

          _.cartRefreshXhr.abort();

        }

        _.cartXhr = $.ajax({

          type: 'POST',

          url: theme.routes.cart_change_url + '.js',

          data: params,

          dataType: 'json',

          success: function success(data) {

            if (_.cartRefreshXhr) {

              _.cartRefreshXhr.abort();

            } // fetch new html for the page

            _.cartRefreshXhr = $.ajax({

              type: 'GET',

              url: theme.routes.cart_url + '?view=ajax',

              success: function success(data) {

                var toReplace = ['.cart-items', '.cart-subtotal-and-discounts'];

                var $newDom = $('<div>' + data + '</div>');

                $newDom.find('.fade-in').removeClass('fade-in');

                for (var i = 0; i < toReplace.length; i++) {

                  $('[data-section-type="cart"] ' + toReplace[i]).html($newDom.find(toReplace[i]).html());

                }

                successCallback();

              },

              error: function error(data) {

                if (data.statusText != 'abort') {

                  console.log('Error refreshing page');

                  console.log(data);

                }

              },

              complete: function complete() {

                _.cartRefreshXhr = null;

              }

            });

          },

          error: function error(data) {

            console.log('Error processing update');

            console.log(data);

          }

        });

      }

    };

    this.onSectionUnload = function () {

      $(window).off(this.namespace);

      $(document).off(this.namespace);

      this.$container.off(this.namespace);

      theme.cartNoteMonitor.unload($('.cart-notes [name="note"]', this.$container));

    };

  }();

  ;

  /*================ Templates ================*/

  /**

   * Customer Addresses Script

   * ------------------------------------------------------------------------------

   * A file that contains scripts highly couple code to the Customer Addresses

   * template.

   *

   * @namespace customerAddresses

   */

  theme.customerAddresses = function () {

    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {

      return;

    } // Initialize observers on address selectors, defined in shopify_common.js

    if (Shopify) {

      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {

        hideElement: 'AddressProvinceContainerNew'

      });

    } // Initialize each edit form's country/province selector

    $('.address-country-option').each(function () {

      var formId = $(this).data('form-id');

      var countrySelector = 'AddressCountry_' + formId;

      var provinceSelector = 'AddressProvince_' + formId;

      var containerSelector = 'AddressProvinceContainer_' + formId;

      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {

        hideElement: containerSelector

      });

    }); // Toggle new/edit address forms

    $('.address-new-toggle').on('click', function () {

      $newAddressForm.toggleClass('hide');

    });

    $('.address-edit-toggle').on('click', function () {

      var formId = $(this).data('form-id');

      $('#EditAddress_' + formId).toggleClass('hide');

    });

    $('.address-delete').on('click', function () {

      var $el = $(this);

      var formId = $el.data('form-id');

      var confirmMessage = $el.data('confirm-message');

      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {

        Shopify.postLink(theme.routes.account_addresses_url + '/' + formId, {

          parameters: {

            _method: 'delete'

          }

        });

      }

    });

  }();

  ;

  /**

   * Password Template Script

   * ------------------------------------------------------------------------------

   * A file that contains scripts highly couple code to the Password template.

   *

   * @namespace password

   */

  theme.customerLogin = function () {

    var config = {

      recoverPasswordForm: '#RecoverPassword',

      hideRecoverPasswordLink: '#HideRecoverPasswordLink'

    };

    if (!$(config.recoverPasswordForm).length) {

      return;

    }

    checkUrlHash();

    resetPasswordSuccess();

    $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);

    $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

    function onShowHidePasswordForm(evt) {

      evt.preventDefault();

      toggleRecoverPasswordForm();

    }

    function checkUrlHash() {

      var hash = window.location.hash; // Allow deep linking to recover password form

      if (hash === '#recover') {

        toggleRecoverPasswordForm();

      }

    }

    /**

     *  Show/Hide recover password form

     */

    function toggleRecoverPasswordForm() {

      $('#RecoverPasswordForm').toggleClass('hide');

      $('#CustomerLoginForm').toggleClass('hide');

    }

    /**

     *  Show reset password success message

     */

    function resetPasswordSuccess() {

      var $formState = $('.reset-password-success'); // check if reset password form was successfully submited.

      if (!$formState.length) {

        return;

      } // show success message

      $('#ResetSuccess').removeClass('hide');

    }

  }();

  ;

  theme.namespaceFromSection = function (container) {

    return ['.', $(container).data('section-type'), $(container).data('section-id')].join('');

  };

  theme.openPageContentInLightbox = function (url) {

    $.get(url, function (data) {

      var $content = $('#MainContent', $.parseHTML('<div>' + data + '</div>'));

      $.colorbox({

        transition: 'fade',

        html: '<div class="lightbox-content">' + $content.html() + '</div>',

        onOpen: theme.colorboxFadeTransOnOpen,

        onComplete: function onComplete() {

          theme.colorboxFadeTransOnComplete(); // check any new inputs

          $('#cboxContent .input-wrapper input').trigger('inputstateEmpty');

        }

      });

    });

  };

  theme.styleVariantSelectors = function ($els, data) {

    $els.each(function () {

      if (typeof $(this).data('listed') != 'undefined') {

        // list options out, bound to the original dropdown

        $(this).clickyBoxes(); // change swatch label on hover

        var $label = $(this).closest('.selector-wrapper').find('.variant-option-title');

        if ($label.length) {

          $label.data('default-content', $label.html());

          $(this).siblings('.clickyboxes').on('change', function () {

            $label.data('default-content', $(this).find('a.active').data('value'));

          }).on('mouseenter', 'a', function () {

            $(this).siblings('.exclusive-text').addClass('show-exclusive');

            $label.html($(this).data('value'));

          }).on('mouseleave', 'a', function () {

             $(this).siblings('.exclusive-text').removeClass('show-exclusive');

            $label.html($label.data('default-content'));

          });

        }

        if (data.options.length == 1) {

          for (var i = 0; i < data.variants.length; i++) {

            var variant = data.variants[i];

            if (!variant.available) {

              $(this).siblings('.clickyboxes').find('a').filter(function () {

                return $(this).data('value') == variant.option1;

              }).addClass('unavailable');

            }

          }

        }

      } else {

        // apply select2 to dropdown

        var config = {};

        theme.select2.init($(this), config);

      }

    });

  };

  theme.select2 = {

    init: function init($els, config) {

      var standardSelectOptions = {

        minimumResultsForSearch: Infinity

      };

      var swatchSelectOptions = {

        minimumResultsForSearch: Infinity,

        templateResult: theme.select2.swatchSelect2OptionTemplate,

        templateSelection: theme.select2.swatchSelect2OptionTemplate

      };

      if (typeof config !== 'undefined') {

        standardSelectOptions = $.extend(standardSelectOptions, config);

        swatchSelectOptions = $.extend(swatchSelectOptions, config);

      }

      $els.each(function () {

        $(this).select2($(this).data('colour-swatch') ? swatchSelectOptions : standardSelectOptions);

      });

    },

    swatchSelect2OptionTemplate: function swatchSelect2OptionTemplate(state) {

      if (state.id) {

        var colourKey = removeDiacritics(state.id).toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/-*$/, '');

        return $(['<div class="swatch-option">', '<span class="swatch-option__nugget bg-', colourKey, '"></span>', '<span class="swatch-option__label">', state.text, '</span>', '</div>'].join(''));

      } else {

        return $(['<div class="swatch-option swatch-option--all">', '<span class="swatch-option__label">', state.text, '</span>', '</div>'].join(''));

      }

    }

  };

  theme.colorboxFadeTransOnOpen = function () {
    $('#colorbox').addClass('colorbox--hide');

  };

  theme.colorboxFadeTransOnComplete = function () {
    setTimeout(function () {
      $('#colorbox').addClass('colorbox--enable-trans');

      setTimeout(function () {

        $('#colorbox').removeClass('colorbox--hide');

        setTimeout(function () {

          $('#colorbox').removeClass('colorbox--enable-trans');

        }, 300);

      }, 20);

    }, 10);

  };

  theme.productGallerySlideshowTabFix = function (slides, current) {

    // tabindex everything to prevent tabbing into hidden slides

    $(slides[current]).find('a, input, button, select, iframe, video, model-viewer, [tabindex]').each(function () {

      if (typeof $(this).data('theme-slideshow-original-tabindex') !== 'undefined') {

        if ($(this).data('theme-slideshow-original-tabindex') === false) {

          $(this).removeAttr('tabindex');

        } else {

          $(this).attr('tabindex', $(this).data('theme-slideshow-original-tabindex'));

        }

      } else {

        $(this).removeAttr('tabindex');

      }

    });

    $(slides).not(slides[current]).find('a, input, button, select, iframe, video, model-viewer, [tabindex]').each(function () {

      if (typeof $(this).data('theme-slideshow-original-tabindex') === 'undefined') {

        $(this).data('theme-slideshow-original-tabindex', typeof $(this).attr('tabindex') !== 'undefined' ? $(this).attr('tabindex') : false);

        $(this).attr('tabindex', '-1');

      }

    });

  };

  try {

    theme.shopifyFeatures = JSON.parse(document.documentElement.querySelector('#shopify-features').textContent);

  } catch (e) {

    theme.shopifyFeatures = {};

  }

  $(document).ready(function () {

    // Common a11y fixes

    slate.a11y.pageLinkFocus($(window.location.hash));

    $('.in-page-link').on('click', function (evt) {

      slate.a11y.pageLinkFocus($(evt.currentTarget.hash));

    }); // Enable focus style when using tab

    $(document).on('keyup.themeTabCheck', function (evt) {

      if (evt.keyCode === 9) {

        $('body').addClass('tab-used');

        $(document).off('keyup.themeTabCheck');

      }

    }); // Target tables to make them scrollable

    var tableSelectors = '.rte table';

    slate.rte.wrapTable({

      $tables: $(tableSelectors),

      tableWrapperClass: 'rte__table-wrapper'

    }); // Target iframes to make them responsive

    var iframeSelectors = '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({

      $iframes: $(iframeSelectors),

      iframeWrapperClass: 'rte__video-wrapper'

    });

    document.querySelector('.footer-blocks').addEventListener('click', function (e) {
      
      if (!e.target.matches('.js-footer-block-toggle')) return;

      var btn = e.target;
      var content = btn.parentNode.nextElementSibling;
      btn.classList.toggle('is-active');

      if (btn.classList.contains('is-active')) {
        content.style.height = "".concat(content.scrollHeight, "px");

      } else {
        content.style.height = null;
      }

    }); // Apply a specific class to the html element for browser support of cookies.

    if (slate.cart.cookiesEnabled()) {

      document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');

    } // Quantity input wrapper

    $(document).on('change', '.quantity-proxy', function () {

      var value = $(this).val();

      var $input = $(this).siblings('[name="quantity"]');

      if (value == '10+') {

        $input.val('10').closest('.quantity-wrapper').addClass('hide-proxy');

        setTimeout(function () {

          $input.select().focus();

        }, 10);

      } else {

        $input.val(value);

      }

    });

  });

  theme.initProductTitleAlignmentWatcher = function ($container, namespace) {

    var $productGrids = $('.product-grid', $container);

    if ($productGrids.length) {

      theme.alignProductImageTitles.bind($productGrids)();

      $(window).on('debouncedresize' + namespace, theme.alignProductImageTitles.bind($productGrids));

    }

  };

  theme.alignProductImageTitles = function () {

    $(this).each(function () {

      var tallest = 0;

      $('.product-block__primary-image', this).each(function () {

        var h = $(this).height();

        if (h > tallest) {

          tallest = h;

        }

      });

      $('.product-block__image', this).css('min-height', tallest);

    });

  };

  if ($('.section-search').length) {

    theme.initProductTitleAlignmentWatcher($('.section-search'), 'main-search');

  }

  theme.Sections.init();

  theme.Sections.register('sidebar', theme.Sidebar, {

    deferredLoad: false

  });

  theme.Sections.register('product', theme.Product, {

    deferredLoad: false

  });

  theme.Sections.register('header', theme.Header, {

    deferredLoad: false

  });

  theme.Sections.register('footer', theme.Footer);

  theme.Sections.register('banner', theme.Banner);

  theme.Sections.register('featured-collection', theme.FeaturedCollection);

  theme.Sections.register('mini-collection-list', theme.MiniCollectionList);

  theme.Sections.register('announcement-bar', theme.AnnouncementList);

  theme.Sections.register('main-brand-container', theme.BrandContainer);

  theme.Sections.register('logo-list', theme.LogoList);

  theme.Sections.register('background-video', theme.VideoManager, {

    deferredLoadViewportExcess: 800

  });

  theme.Sections.register('gallery', theme.Gallery);

  theme.Sections.register('collection', theme.Collection, {

    deferredLoad: false

  });

  theme.Sections.register('cart', theme.Cart, {

    deferredLoad: false

  }); //Register dynamically pulled in sections

  theme.Sections.register('slideup-featuredblock', theme.SlideUpFeatured);

  $(function ($) {

    if (cc.sections.length) {

      cc.sections.forEach(function (section) {

        try {

          theme.Sections.register(section.name, section.section);

        } catch (err) {

          console.error("Unable to register section ".concat(section.name, "."), err);

        }

      });

    } else {

      console.warn('Barry: No common sections have been registered.');

    }

  });

})(theme.jQuery);  

/* Built with Barry v1.0.7 */
if(document.getElementById("header-account") != null) {
document.getElementById("header-account").addEventListener("mouseover", function(){

  var content = $('.header-account-content').html();

  if(content){

    document.body.classList.add("is-header-hover");

  }

  else{

    document.getElementById("header-account").classList.add('no-dropdown-content');

  }

});
}
document.getElementById("header-account").addEventListener("mouseout", removeClassinbody);

document.getElementById("track-sec").addEventListener("mouseover", addClassinbody);

document.getElementById("track-sec").addEventListener("mouseout", removeClassinbody);

document.getElementById("header-cart").addEventListener("mouseover", addClassinbody);

document.getElementById("header-cart").addEventListener("mouseout", removeClassinbody);

// $('.menu-lv-1').hover(function(){

 

//     document.body.classList.remove("is-header-hover");

//     document.body.classList.add("is-header-hover");

//     //$('#darkness').css('display','none');

//     //$('#darkness').css('display','block');

 

// }, function(){

//   document.body.classList.remove("is-header-hover");

//   //$('#darkness').css('display','none');

// });

function addClassinbody(){

  document.body.classList.remove("is-header-hover");

  document.body.classList.add("is-header-hover");

  }

function removeClassinbody(){

  document.getElementById("header-account").classList.remove('no-dropdown-content');

  document.body.classList.remove("is-header-hover");

  }

$('.product-acc-btn').click(function(){ 

  

  if($(this).siblings('.product-acc-des').hasClass('active-des'))

  {

    $('.product-acc-btn').removeClass('active-acc-btn');

    $(this).siblings('.product-acc-des').removeClass('active-des');

  }

 else{

    $('.product-acc-des').removeClass('active-des');

    $('.product-acc-btn').removeClass('active-acc-btn');

    $(this).addClass('active-acc-btn');

    $(this).siblings('.product-acc-des').addClass('active-des');

 }

});

$('.ask-on-expert').click(function(){

  window.tidioChatApi.show();

  window.tidioChatApi.open();

});

$('.popup-close').click(function(){

  $('.ask-expert-content').css('display','none');

});

$('.qty-box .qty-btn').on('click', function(){

  var qty = parseInt($(this).parent('.qty-box').find('.quantity-proxy').val());

  if($(this).hasClass('qty-plus')) {

    qty++;

  }else {

    if(qty > 1) {

      qty--;

    }

  }

  qty = (isNaN(qty))?1:qty;

  $(this).parent('.qty-box').find('.quantity-proxy').val(qty);

  var $input = $(this).siblings('[name="quantity"]');

  $input.val(qty);

}); 

$(document).ready(function(){

  $('#clickyboxes-SingleOptionSelector-0 li a').addClass('first-click-active');

  $('.options--size li a').addClass('first-click-size-active');

  var active = $('.activeList a');

 

  var size_active = $('.options--size a.active');

  // console.log(size_active);

  // $('#clickyboxes-SingleOptionSelector-0 .activeList').next('.parent-list').find('a').click();

  //  $('#clickyboxes-SingleOptionSelector-0 .activeList').prev('.parent-list').find('a').click();

  if($('#clickyboxes-SingleOptionSelector-0 .activeList').next('.parent-list').length > 0){
    $('#clickyboxes-SingleOptionSelector-0 .activeList').next('.parent-list').find('a').click();
  }

  else if($('#clickyboxes-SingleOptionSelector-0 .activeList').prev('.parent-list').length > 0){
    $('#clickyboxes-SingleOptionSelector-0 .activeList').prev('.parent-list').find('a').click();
  }

  else if($('.options--size a.active').parent('li').prev('li').length > 0 && !$('.options--size a').hasClass('availablesizevariant')){
    $('.options--size a.active').parent('li').prev('li').find('a').click();
  }

  else if($('.options--size a.active').parent('li').next('li').length > 0 && !$('.options--size a').hasClass('availablesizevariant')){
    $('.options--size a.active').parent('li').next('li').find('a').click();
  }

  else{

  }



  $(active).click();
  $(size_active).click();

});

var heighest = [];

i = 0;

$('.custom_menu_2 .site-nav-dropdown').each(function(){

  heighest[i++] = $(this).height();

});

if ($(".template-index .custom_menu_2 .site-nav-dropdown")[0]){

  var heightest_height = Math.max.apply(Math,heighest);

}

else{

  var heightest_height = Math.max.apply(Math,heighest) + 40;

}

$('.mega-3 .custom_menu_2 .site-nav-dropdown').css('height', heightest_height+'px');

$(window).scroll(function() {

  //var navHeight = $( window).height() - 70;

    if ($(window).scrollTop() > 10) {

      $('#shopify-section-header').addClass('header-fixed');

      $('#shopify-section-announcement').addClass('header-fixed-announced');

      $('#shopify-section-announce-stripe').addClass('fixed-announced');



      $('main').addClass('top-space');

    }

    else {

      $('#shopify-section-header').removeClass('header-fixed');

      $('#shopify-section-announcement').removeClass('header-fixed-announced');

      $('#shopify-section-announce-stripe').removeClass('fixed-announced');

      $('main').removeClass('top-space');

    }

 });

$('.product-thumbnails--desktop').slick({

  arrows: true,

  dots: false,

  infinite: false,

  speed: 500,

  slidesToShow: 5,

  slidesToScroll: 3,

  vertical: true,

  verticalSwiping: true,

  prevArrow: '<div class="slide-arrow prev-arrow"><i class="arrow up"></i></div>',

  nextArrow: '<div class="slide-arrow next-arrow"><i class="arrow down"></i></div>',

  responsive: [

    {

      breakpoint: 1023,

      settings: {

        slidesToShow: 2,

        slidesToScroll: 2,

        row:1,

        vertical: false,

        verticalSwiping: false,

        horizontal: true,

        horizontalSwiping: true,

        prevArrow: '<div class="slide-arrow prev-arrow"><i class="arrow left"></i></div>',

        nextArrow: '<div class="slide-arrow next-arrow"><i class="arrow right"></i></div>',

      },

      
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        row:1,
        vertical: false,
        verticalSwiping: false,
        horizontal: true,
        horizontalSwiping: true,
        prevArrow: '<div class="slide-arrow prev-arrow"><i class="arrow left"></i></div>',
        nextArrow: '<div class="slide-arrow next-arrow"><i class="arrow right"></i></div>',
      },
      
    }

  ]

});

$('.product-thumbnails--desktop').on('wheel', (function(e) {

  e.preventDefault();

  if (e.originalEvent.deltaY < 0) {

    $(this).slick('slickPrev');

  } else {

    $(this).slick('slickNext');

  }

}));

var filtered = false;

$('.brand-details-collection-section .brand_collection').slick({

  arrows: true,

  dots: false,

  infinite: false,

  speed: 500,

  slidesToShow: 5,

  slidesToScroll: 1,

  prevArrow: '<div class="slide-arrow prev-arrow"><i class="arrow left"></i></div>',

  nextArrow: '<div class="slide-arrow next-arrow"><i class="arrow right"></i></div>',

  responsive: [

    {

      breakpoint: 1023,

      settings: {

        slidesToShow: 3,

        slidesToScroll: 1,

        

      }

    },

    {

      breakpoint: 480,

      settings: {

        slidesToShow: 1,

        slidesToScroll: 1,

        

      }

    }

  ]

});

$('.related-blog-sec').slick({

  arrows: true,

  dots: false,

  infinite: false,

  speed: 500,

  slidesToShow: 3,

  slidesToScroll: 1,

  prevArrow: '<div class="slide-arrow prev-arrow"><i class="arrow left"></i></div>',

  nextArrow: '<div class="slide-arrow next-arrow"><i class="arrow right"></i></div>',

  responsive: [

    {

      breakpoint: 1200,

      settings: {

        slidesToShow: 2,

        slidesToScroll: 1,

        

      }

    },

    {

      breakpoint: 1023,

      settings: {

        slidesToShow: 1,

        slidesToScroll: 1,

        

      }

    },

    {

      breakpoint: 480,

      settings: {

        slidesToShow: 1,

        slidesToScroll: 1,

        

      }

    }

  ]

});

setTimeout(function(){

$('.product-recommendations .product-grid').slick({

  arrows: true,

  dots: false,

  infinite: true,

  speed: 500,

  slidesToShow: 5,

  slidesToScroll: 1,

  prevArrow: '<div class="slide-arrow prev-arrow"><i class="arrow left"></i></div>',

  nextArrow: '<div class="slide-arrow next-arrow"><i class="arrow right"></i></div>',

  responsive: [

    {

      breakpoint: 1200,

      settings: {

        slidesToShow: 3,

        slidesToScroll: 3,

        

      }

    },

    {

      breakpoint: 1023,

      settings: {

        slidesToShow: 3,

        slidesToScroll: 3,

        

      }

    },

    {

      breakpoint: 767,

      settings: {

        slidesToShow: 2,

        slidesToScroll: 2,

        

      }

    }

  ]

});

}, 1800);

$('.article-collections').slick({

  arrows: true,

  dots: false,

  infinite: false,

  speed: 500,

  slidesToShow: 4,

  slidesToScroll: 1,

  prevArrow: '<div class="slide-arrow prev-arrow"><i class="arrow left"></i></div>',

  nextArrow: '<div class="slide-arrow next-arrow"><i class="arrow right"></i></div>',

  responsive: [

    {

      breakpoint: 1200,

      settings: {

        slidesToShow: 2,

        slidesToScroll: 1,

        

      }

    },

    {

      breakpoint: 1023,

      settings: {

        slidesToShow: 2,

        slidesToScroll: 1,

        

      }

    },

    {

      breakpoint: 767,

      settings: {

        slidesToShow: 1,

        slidesToScroll: 1,

        

      }

    }

  ]

});

$('.slideup-swipper').slick({

  arrows: false,

  dots: false,

  infinite: false,

  speed: 500,

  slidesToShow: 4,

  slidesToScroll: 1,

  prevArrow: '<div class="slide-arrow prev-arrow"><i class="arrow left"></i></div>',

  nextArrow: '<div class="slide-arrow next-arrow"><i class="arrow right"></i></div>',

  responsive: [

    {

      breakpoint: 1200,

      settings: {

        slidesToShow: 2,

        slidesToScroll: 1,

        

      }

    },

    {

      breakpoint: 1023,

      settings: {

        slidesToShow: 2,

        slidesToScroll: 1,

        

      }

    },

    {

      breakpoint: 767,

      settings: {

        slidesToShow: 1,

        slidesToScroll: 1,

        

      }

    }

  ]

});

$('.inner_overview_box').click(function(){

  var id = $(this).data('value');

  $('.account-page__tabcontent').css('display','none');

  $('#'+id).css('display','block');

  $('.account-back-link').css('display','block');

});

$('.account-back-link').click(function(){

  $('.account-page__tabcontent').css('display','none');

  $('.account-back-link').css('display','none');

  $('#Overview').css('display','block');

});

$('.address-new-btn').click(function(){

  $('#addnewaddr-model').css('display','block');

}); 

$('.model-close').click(function(){

  $('#addnewaddr-model').css('display','none');

}); 

$('.address-edit-form').click(function(){

  var id = $(this).data('form-id');

  $('#edit-addr-form-'+id).css('display','block');

  $('#EditAddress_'+id).removeClass('hide');

}); 

$('.edit-close').click(function(){

  $('.edit-addr-form').css('display','none');

  //$('.edit_form').addClass('hide');

}); 

jQuery(document).ready(function () {

	var pageWidth = $(window).width();

	if (pageWidth > 1024) {

		let parent = document.querySelector(".feature-image-sec");

		if (parent != null) {

			document.querySelector("body").style.overflowX = "initial";

		}

	}

});
$('.availablesizevariant').click(function(){

  if(!$(this).hasClass('active')){

    window.location.href = $(this).attr('href');

  }

});

if (window.location.href.indexOf("collections") > -1) {

  var result = get_query();

  for (var key in result){

    if(key == 'refinementList[vendor][0]'){

      var url_brand_name = result[key].toLowerCase();

      $('.collection-brand-section').each(function(){

              var innertext = $.trim($(this).find('.brand-title span').text().toLowerCase());

              if(url_brand_name == innertext){

                $('.main-brand-container').removeClass('current-active-section');

                $(this).parent().find('.main-brand-container').addClass('current-active-section');

              }

              

        }); 

    }

    

  }

}

function get_query(){

  var url = decodeURIComponent(document.location.href);

  var qs = url.substring(url.indexOf('?') + 1).split('&');

  for(var i = 0, result = {}; i < qs.length; i++){

      qs[i] = qs[i].split('=');

      result[qs[i][0]] = decodeURIComponent(qs[i][1]);

  }

  return result;

}

$('.clickyboxes.options--size li a').click(function(e){

  

  if(e.hasOwnProperty('originalEvent') || $('.options--color a').hasClass('first-click-size-active')){

    

    $('.clickyboxes.options--size li a').removeClass('first-click-size-active');

    $('.clickyboxes.options--size li a').removeClass('fullactive');

    $('.clickyboxes.options--color li a').removeClass('fullactive');

    $(this).addClass('fullactive');

  }

       

  

    

}); 

$('.options--color a').click(function(e){

  

  if(e.hasOwnProperty('originalEvent') || $('.options--color a').hasClass('first-click-active')){

    $('.options--color li a').removeClass('first-click-active');

    $('.clickyboxes.options--color li a').removeClass('fullactive');

    $('.clickyboxes.options--size li a').removeClass('fullactive');

    $(this).addClass('fullactive');

  }

  

});

$('.containvendor').click(function(){

  var data_value = $(this).data('value');

  if(data_value){

    $('.containvendor').removeClass('active-vendor');

    $(this).addClass('active-vendor');

    $('.brand-div').css('display','none');

    $('.brand-display-'+data_value).css('display','flex');

  }

  else{

    $('.containvendor').removeClass('active-vendor');

    $('.containvendor:nth-child(1)').addClass('active-vendor');

    $('.brand-div.vendor-available').css('display','flex');

  }

  

});

$('.allbrand_blocks_wrapper').slick({

  arrows: true,

  dots: false,

  infinite: false,

  speed: 500,

  slidesToShow: 4,

  slidesToScroll: 1,

  prevArrow: '<div class="slide-arrow prev-arrow"><i class="arrow left"></i></div>',

  nextArrow: '<div class="slide-arrow next-arrow"><i class="arrow right"></i></div>',

  responsive: [

    {

      breakpoint: 1023,

      settings: {

        slidesToShow: 2,

        slidesToScroll: 1,

        

      }

    },

    {

      breakpoint: 767,

      settings: {

        slidesToShow: 1,

        slidesToScroll: 1,

        

      }

    }

  ]

});

$('.account-form #Email').change(function(){

  $('.hidden-subscription #mce-EMAIL').val($(this).val());

});

$('.account-form .submit-btn').click(function(){

  if($("#email_sub").prop('checked') == true){

    $('.hidden-subscription #mc-embedded-subscribe').click();

  }

});



  

    $('.options--size li a').mouseenter(function(){

      if(!$(this).hasClass('available-size') && !$(this).hasClass('availablesizevariant')){

        

          $(this).siblings('span').html('Not Available');

          $(this).siblings('span').removeClass('non-available-hover');

          $(this).siblings('span').addClass('non-available-hover');

          $(this).parent('li').addClass('unavailablesizevariant-li');

          

      }

      if($(this).hasClass('soldout')){

        $(this).siblings('span').html('Out of Stock');

        $(this).siblings('span').removeClass('non-available-hover');

        $(this).siblings('span').addClass('non-available-hover');

      }

    });

    $('.options--size li a').mouseleave(function(){     

      $(this).parent('li').removeClass('unavailablesizevariant-li')  

      $(this).siblings('span').removeClass('non-available-hover');

      setTimeout(function(){

        $(this).siblings('span').html('');

      }, 500);

    });

    $('.options--color li a').mouseenter(function(){

      if(!$(this).hasClass('available-color')){

          $('.exclusive-text').css('visibility','hidden');

          $(this).parent('li').addClass('unavailablevariant-li');

          $(this).siblings('.not-available-color').html('Not Available');

          $(this).siblings('.not-available-color').removeClass('non-available-hover');

          $(this).siblings('.not-available-color').addClass('non-available-hover');

          

      }

      if($(this).hasClass('soldout')){

        $('.exclusive-text').css('visibility','hidden');

        $(this).siblings('.not-available-color').html('Out of Stock');

        $(this).siblings('.not-available-color').removeClass('non-available-hover');

        $(this).siblings('.not-available-color').addClass('non-available-hover');

      }

    });

    $('.options--color li a').mouseleave(function(){     

      $(this).parent('li').removeClass('unavailablevariant-li');

      $(this).siblings('.not-available-color').removeClass('non-available-hover');

      setTimeout(function(){

        $(this).siblings('span').html('');

      }, 500);

    });

 $('#SingleOptionSelector-1 option').each(function(){

  if($(this).data('already') != ''){

    var already_value = $(this).data('already');

  

    $('#clickyboxes-SingleOptionSelector-1 li a').each(function(){

      if(already_value){

        if($(this).html() == already_value){

          $(this).addClass('duplicatevariant');

  

        }

      }

      

    });

    

  }

  $(".duplicatevariant").eq(0).css("display", "none");

 })

    

 $('#chat-box').click(function(){

  window.tidioChatApi.show();

  window.tidioChatApi.open();

  });

  $('.cart-subtotal-row .js-cart-notes-trigger span').click(function(){

  var cart = $('.standard-link').innerText;

  if(cart !=  "Hide instructions for seller"){

    $('.cart-notes').toggleClass('note-display');

  }

});

// document.querySelector(".js-cart-notes-trigger").addEventListener("click",function(){

//   var cart = document.querySelector(".standard-link").innerText;

// if(cart ==  "Hide instructions for seller"){

//  $('.cart-notes').toggleClass('note-hide');

//  $('.cart-notes').removeClass('note-display');

// }  

// });

// Contact form validation

var contactForm = document.querySelector("#contact_form");
if (contactForm != null) {
var allInputs = contactForm.querySelectorAll('input,textarea');
}
if (contactForm != null) {

	contactForm.addEventListener(

		"invalid",

		(function () {

			return function (e) {

				e.preventDefault();

				myValidation(e.target);

			};

		})(),

		true

	);

  if(allInputs != null){

    allInputs.forEach((ele) => {

      ele.addEventListener("input", (e) => {

        e.target.parentNode.querySelector(".form-field-error")

          ? (e.target.parentNode.querySelector(".form-field-error").innerText =

              "")

          : null;

      });

      ele.addEventListener("change", (e) => {

        e.target.parentNode.querySelector(".form-field-error")

          ? (e.target.parentNode.querySelector(".form-field-error").innerText =

              "")

          : null;

      });

    });

  }

	function myValidation(ele) {

		var errorLabel = ele.dataset.errorLabel;

		if (ele.value == "") {

			ele.parentNode.querySelector(

				".form-field-error"

			).innerText = `${errorLabel} is required`;

		} else if (ele.validity) {

			ele.parentNode.querySelector(

				".form-field-error"

			).innerText = `You have to enter a valid ${errorLabel}`;

		}

	}

}

$('.desktop-mobile-both .product-thumbnails__item a').click(function(){

  $('.desktop-mobile-both .product-thumbnails__item').removeClass('slick-current');

  $('.desktop-mobile-both .product-thumbnails__item').removeClass('slick-active');

  $(this).parent('.product-thumbnails__item').addClass('slick-current');

  $(this).parent('.product-thumbnails__item').addClass('slick-active');

  var id = $(this).attr('data-thumbnail-media-id');

  var index = $(this).parent('.product-thumbnails__item').index()+1;

  $('.slick-external-dots .slick-dots li button').each(function(){

    if($(this).html() == index){

      $(this).click();

    }

  });

});

$('.swatch-span').click(function(){

  var feature = $(this).data('feature');

});
// mailchimp confirmation 
$( document ).ready(function() {
  var url = window.location.href;
  var sub = "subscribed";
  if(url.indexOf(sub) != -1){
    $('.success-modal').removeAttr('hidden');
      $('body').addClass('scroll-block');      
  }
});
// mailchimp confirmation close
$('#close-message-pop').click(function() {
  $('.success-modal').prop("hidden", !this.checked);
  $('body').removeClass('scroll-block');      
});


$( document ).ready(function() {
  const availableList = document.querySelectorAll(".parent-list a.available-color");
  for(let j=0;j<availableList.length;j++) {
    availableList[j].parentElement.classList.add("li-available-variant");  
  }
const soldoutList = document.querySelectorAll(".parent-list a.soldout");
for(let i=0;i<soldoutList.length;i++) {
  soldoutList[i].parentElement.classList.add("li-notavailable-variant");  
}

// const soldoutListSize = document.querySelectorAll(".not-available-size");

// for(let i=0;i<soldoutListSize.length;i++) {
//   if(soldoutListSize[i].classList.contains('not-available-size')) {
//     soldoutListSize[i].parentElement.classList.add("li-notavailable-size");  
//   }
// }
});


$('ul.clickyboxes.options--size a').click(function(){

  console.log('this');
  const availableColor = document.querySelectorAll("a.available-color");
  console.log(availableColor);
   for(let i=0;i<availableColor.length;i++) {
    availableColor[i].parentElement.classList.remove("li-available-variant");  

     availableColor[i].parentElement.classList.add("li-available-variant-color");  
   }
 });





const mediaQuery = window.matchMedia('(max-width: 767px)');
setTimeout(() => {
  var color_length = $('li.parent-list.unavailable-color.li-available-variant').not( ".li-notavailable-variant" ).length; 
console.log('color option length',color_length);
if (!mediaQuery.matches) {
var show_length = 12;

if(color_length > 12){

  setTimeout(function(){ 

    $('#clickyboxes-SingleOptionSelector-0 li').css('display','none');

    $('#clickyboxes-SingleOptionSelector-0 li:lt('+show_length+')').css('display','block');  

    var remaining = color_length - show_length;

    $('.loadMore').remove();

    $('.options--color').after('<div class="loadMore">'+remaining+'</div>');

    $('.loadMore').css('margin-bottom','50px'); 

    $('.loadMore').click(function() {

  

      show_length= (show_length+12 <= color_length) ? show_length+12 : color_length;

      var remaining = color_length - show_length;

      if(remaining == 0){

        $('.loadMore').css('display','none');

      }

      $('.loadMore').html(remaining);

        $('#clickyboxes-SingleOptionSelector-0 li:lt('+show_length+')').show();

    });

  }, 100);
}
           

}
}, 5000);



